import { getProfiles } from "@services/UserService";
import moment from "moment";
import {
    MINIMUM_FILTERS_TO_DISPLAY,
    FILTER_TYPE_SYMBOLS,
    MODULES,
    DEFAULT_DECIMAL_PLACE,
    EXTERNAL_FILTERS,
    statusColorMap,
    spinnerHtml,
    gridUpdateConfig,
    moduleConfigs,
    DEFAULT_CAMPAIGN_NAME_REGEX,
    CUSTOM_FILTER_TYPES,
    TAGS_MODULE_MAPPING,
    TAG_COLORS,
    DEFAULT_TAG_TYPES,
    MISC_PA_REPORT_WIDGET,
    NO_FILTER_MODULES,
    routePatterns,
    DISABLED_STATES,
    CerbosResources,
    CommonPermissionsActions,
    ReviewActions,
    RulesActions,
    SearchTermAnalyticsActions,
    HistoryActions,
    ReportsActions,
    KeywordsActions,
    CampaignsActions,
    PortfoliosActions,
    AdgroupsActions,
    ProductsActions,
    ABSOLUTE_PLAN_METRICES,
    RATIO_PLAN_METRICES,
    GENERATE_MEDIA_PLAN_CONFIG,
    MEDIA_PLAN_METRICES,
    CAMPAIGN_STATES,
    catOverviewCompareTablesMetricsToSum,
    CategoryOverviewChartsKeys,
    CategoryInsightsOverviewSections,
    catOverviewComparisonTableMetricsToSum,
    CategoryOverviewSerpKeys,
    valueDeltaDefault,
    REVSTACK_COUNTRY_DATE_FORMATS,
    UserRoles,
    MIN_BULK_CAMPAIGN_BUGET_LIMIT,
    channelsMapping,
    BCC_CAMPAIGN_TYPE_MAPPING_SHORT,
    SessionStorageKey,
    BCC_KEYWORD_TYPE_ABBREVIATIONS,
} from "./constants";
import {
    GlobalTagRecordType,
    BCC_KEYWORD_TYPES,
    BCC_MODULE_TYPES,
    BCC_TARGET_TYPES,
    IBCCKeyword,
    IKeywordCohort,
    ICountryData,
    IUserChannelAccess,
    KeywordModalType,
    MappingSyncStatus,
    KeywordTypeValues,
    TagColFields,
} from "./common-types";
import { showModalHandler, showToast } from "./modals";
import store from "../store";
import {
    createClusterGroups,
    formatClusterDataWithProducts,
    getClientLogoUrl,
    getClusterGroups,
    getProductGroups,
} from "./retrieve-data";
import { setClusters } from "../features/clustersSlice";
import {
    getProductPriorityFromState,
    getVariantSelectionFromState,
} from "../components/widgets/WidgetCellRenderers";
import {
    setIsAddTagTypeFormSubmitted,
    updateActiveClientGroupId,
    updateActiveClientId,
    updateClientIdOnChannelChange,
    updateClientList,
    updateClientSubGroupId,
    updateTagTypeList,
    updateTagTypeListLoading,
} from "@features/clientDataSlice";
import * as Sentry from "@sentry/react";
import {
    sendRequest,
    updateUserSettings,
    updateBuybox,
    populateSellersData,
    getClientChannels,
    getClientReports,
    getAllChannelsForClientIds,
} from "./retrieve-data";
import cronstrue from "cronstrue";
import { populateTotalRow } from "./row-aggregation";
import { getSelectedDateRange } from "./date-range";
import {
    updateMainGridFilters,
    updateCampaignFilters,
    updateKeywordFilters,
    updateAdgroupFilters,
    updatePortfolioFilters,
    updateProductFilters,
    updatePoCheckedNode,
    updatePdCheckedNode,
    updateAdCheckedNode,
    updateCaCheckedNode,
    updatePoGridFilters,
    updatePdGridFilters,
    updateCaGridFilters,
    updateAdGridFilters,
    updatePlacementFilters,
} from "@features/filtersSlice";
import {
    setAddAsExactData,
    setcampaignPortfolioData,
    setIsRuleSaveButtonDisabled,
    setMediaPlanConfigValues,
    updateShowNewMediaPlanDisplay,
    updateShowRequestAlert,
} from "@features/modalSlice";
import {
    updateIsAllPortfoliosSelected,
    updateIsAllCampaignsSelected,
    updateIsAllAdgroupsSelected,
} from "@features/modalSlice";
import {
    updateAllPortfolioId,
    updateAllSysCampaignId,
    updateAllSysAdgroupId,
} from "@features/selectAllGridDataSlice";
import { updateActiveTab } from "@features/activeTabSlice";
import { updateActiveModule } from "@features/activeModuleSlice";
import { TargetTypeOption } from "./multi-select-dropdown";
import {
    AdditionalBidParams,
    BadgeColor,
    BadgeText,
    Campaign,
    ChannelName,
    Channels,
    TClientTags,
    CommonGridParams,
    IBulkRequiredConfig,
    IChannels,
    IClient,
    ICommonRowDataRedux,
    IConfigs,
    IDRange,
    IFilters,
    ILog,
    IParams,
    IPortfolio,
    IRevertAction,
    IStrapiAssetResponse,
    IStrapiResponse,
    IUpdatedGridData,
    IUserCountryDetails,
    Keyword,
    Modules,
    ParentModule,
    RecordType,
    SubModule,
    TApi,
    TBulkKeywords,
    TBuyboxEnabledData,
    TCampaignFilters,
    TCampaignTargetObject,
    TCommonRowData,
    TCommonRowObj,
    TCreateNegativeKeyword,
    TFetchAssets,
    TFilterModel,
    TGetTrendsData,
    THandleAddBtnClick,
    TMerge,
    TNegativeKw,
    TOperationType,
    TOtherAttr,
    TProductsData,
    TRequestedParams,
    TSelectedTargets,
    TSellersData,
    TSpecificAdgroup,
    TTimezone,
    TUpdateAdgroups,
    TUpdateCampaigns,
    TCampaigns,
    TUpdateKeywords,
    TUpdatePortfolios,
    TUpdateProductAds,
    TUpdateRow,
    TagsMap,
    TUpdateNegativeKeywords,
    TGoalsData,
    TGoalsConfig,
    TUpdateTagMapping,
    TValidateTagRemoveResponse,
    TProductMappingUpdateConfig,
    Platforms,
    ProductModalType,
    TCerbosPrincipal,
    TCerbosResources,
    TCerbosAction,
    ICerbosData,
    ICerbosResource,
    IAccess,
    IClientAccess,
    THashConfig,
    DeepDiveBrandScoreInfo,
    IUserRecord,
    ClientGroup,
    TSelectOptionsChildrenProps,
    TMediaPlanEditConfig,
    MatchType,
    IMediaPlanRowObj,
    TMediaPlanRowData,
    ICreateMediaPlan,
    IEditMediaPlan,
    TMappedPlanData,
    TMediaPlanChangeLogs,
    TPlanLevelChanges,
    TPlanRecordChanges,
    PlanMetrics,
    TMediaPlanConfig,
    User,
    RuleFilterTextProps,
    RuleFilterType,
    Nature,
    StateTypeValues,
    ActionType,
    Features,
    ProgramType,
    CostType,
    IReportsData,
    IClientChanges,
    IProductMappingListParams,
    IPfmSkuFilterParams,
    ISubCategoryPerformance,
    IFormattedSubCategoryPerformance,
    ICategoryOverviewDrainers,
    IFormattedDrainerData,
    ICategoryOverviewCrossChannelGraphData,
    ICategoryOverviewCompetitionGraphData,
    MyProductTrendsModules,
    ICategoryOverviewComparisonGraphData,
    ICategoryOverviewComparisonGraphFormattedData,
    TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite,
    MetricWithDelta,
    IBestSellerSKUData,
    ICategoryOverviewCrossChannelCompetitionComparisonGraphItem,
    ICategoryOverviewBestSellerSKUTableRow,
    TApply1DSMappingConfig,
    ITagWorkerPayload,
    TUpdateConfigBulkProductMapping,
    CommonWidgetMetrics,
    AggregationField,
    IcategoryOverviewCrossChannelCompetitonComparisonData,
    TFormattedCategoryOverviewCrossChannelCompetitonComparisonData,
    TCatOverviewCrossChannelCompetitionComparisonAggEntry,
    KeywordMappingConfig,
    GRID_COLUMNS,
    TBrandsData,
} from "./common-types";
import { checkForKeywordOrTarget } from "./bulk-keywords-addition";
import CryptoJS from "crypto-js";
import {
    updateEnableBuybox,
    updateEnableDayparting,
    updateClientTimezone,
    updateBuyboxEnabledData,
    updateIsBuyboxUpdated,
    updateDoPreferredSellersExist,
    updateEnableRevstack,
    updateUserCountryDetails,
    updateEnableKeywordRecommendation,
} from "@features/adminSettingsSlice";
import {
    updateHistoryLogsSelectionData,
    updateKeywordsSelectionData,
    updateNegativeKeywordsSelectionData,
    updateOverviewKeywordsSelectionData,
    updateProductAdgroupsSelectionData,
    updateProductsSelectionData,
} from "@features/selectedDataSlice";
import {
    CellClassParams,
    ColumnApi,
    ExcelExportParams,
    GridApi,
    GridReadyEvent,
    ICellRendererParams,
    RowNode,
    ValueFormatterParams,
} from "ag-grid-community";
import React, {
    ChangeEvent,
    Dispatch,
    SetStateAction,
} from "react";
import selectedDataWorker from "@workers/selected-data.worker?worker";
import aggregateWorker from "@workers/row-aggregator.worker?worker";
import requestWorker from "@workers/request.worker?worker";
import mergeWorker from "@workers/merge.worker?worker";
import bulkKeywordsWorker from "@workers/bulk-keywords.worker?worker";
import getUpdatedGridData from "@workers/grid-params.worker?worker";
import { Tooltip } from "bootstrap";
import {
    each,
    compact,
    map,
    forEach,
    filter,
    omit,
    isEmpty,
    chain,
    contains,
    intersection,
    find,
    indexOf,
    includes,
    uniq,
    pluck,
    mapObject,
    reduce,
    pick,
    isEqual,
    partition,
    isNull,
    sortBy,
} from "underscore";
import {
    updateChannelWalletBalance,
    updateChannelCurrencySymbol,
    updateChannelDomain,
    updateChannel,
} from "@/features/channelSlice";
import { setUpdateGridData } from "./filters";
import dayjs, { Dayjs } from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { MutableRefObject } from "react";
import { GrowthBook } from "@growthbook/growthbook-react";
import { cerbos } from "./cerbosConfig";
import { matchPath } from "react-router-dom";
import { updateClientSelection } from "@/features/clientSelectionSlice";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
import { calculateRatio } from "@/workers/row-aggregator.worker";
import {
    resetMediaPlanEditConfig,
    resetMediaPlanGridApiMap,
    setGenerateMediaPlanData,
    setIsMediaPlanCreate,
    setIsMediaPlanEdit,
    setMediaPlanEditConfig,
    setMediaPlanningList,
    setPortfoliosData,
    setSelectedReportData,
} from "@/features/gridDataSlice";
import { setMediaPlanListLoading } from "@/features/loaderSlice";
import { isValidCron } from "cron-validator";
import { updateErrorStatusCode } from "@/features/errorStatusCodeSlice";
import tagWorker from "../workers/tag.worker?worker";
import tableWorker from "../workers/table.worker?worker";
import _ from "underscore";
import { TDate } from "./funnel";
import {
    formatCategoryOverviewBrandContributionData,
    formatCategoryOverviewMarketShareAndSizeData,
    formatCategoryOverviewMSTrendsOverTimeData,
    formatCategoryOverviewSubCategoriesData,
    formatCategoryOverviewSummaryWidgetData,
} from "./widget";
import { CHANNEL_CONFIGS } from "@/config/channel-configs";
import $ from "jquery";
import { toggleProductPriority } from "@/features/clustersSlice";
import { updateSidebarLogo } from "@/features/sidebarSlice";
import { updateCampaignCreationDisplay } from "@/features/campaignCreationSlice";

let defaultDateRange: string;

/**
 * @param s - The string to convert to title case.
 * @returns The title cased string.
 * @example "user_name" → "User Name", "MARKET SHARE" → "Market Share", "WT. AVAIL" → "Wt. Avail"
 */

export const titleCase = (s: string, keepHyphens = false) => {
    if (!s) return s;

    const str = s.toString();

    let result = keepHyphens
        ? str.replace(/^[_]*(.)|[_]+(.)/g, (_, c, d) =>
            c ? c.toUpperCase() : " " + d.toUpperCase()
        )
        : str.replace(/^[_-]*(.)|[_-]+(.)/g, (_, c, d) =>
            c ? c.toUpperCase() : " " + d.toUpperCase()
        );

    if (keepHyphens) {
        result = result.replace(/-([a-z])/g, (_, c) => "-" + c.toUpperCase());
    }

    result = result.replace(/\b[A-Z]{2,}\b/g, (match) => {
        if (match.includes(".")) {
            return match
                .split(".")
                .map((part) =>
                    part.length > 0
                        ? part.charAt(0) + part.slice(1).toLowerCase()
                        : part
                )
                .join(".");
        }
        return match.charAt(0) + match.slice(1).toLowerCase();
    });

    return result;
};

export const capitalizeFirst = (str: string): string => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const startCase = (str: string): string => {
    return str
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
};

export const toUnderScoreCase = (str: string): string => {
    return str.replace(/\s/g, "_").toLowerCase().trim();
};

export const generateRandomString = (length: number) => {
    const result = [];
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result.push(
            characters.charAt(Math.floor(Math.random() * charactersLength))
        );
    }
    return result.join("");
};

export const getRequestParams = (p: TRequestedParams) => {
    const { dateObj, ...params } = p;
    return {
        ...params,
        ...(dateObj && Object.keys(dateObj).length
            ? dateObj.start
                ? { start: dateObj.start, end: dateObj.end }
                : { dateRangeKey: dateObj.selectedDate || defaultDateRange }
            : {}),
    };
};

export const setProfiles = async () => {
    try {
        const clients = (await getProfiles()).rows;
        const { userData } = store.getState();
        const userDetails = userData.value;

        const defaultClient = userDetails.default_client;
        const lastVisitedClient = getClientId();

        let activeClient: number = defaultClient || clients[0].id;

        if (
            clients.length &&
            clients.find((client: IClient) => client.id === lastVisitedClient)
        ) {
            activeClient = lastVisitedClient;
        }

        // Enable Client Selection Dropdown
        store.dispatch(updateClientSelection(clients.length === 1));
        store.dispatch(updateClientList(clients));

        await updateClientSettings(+activeClient);
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        throw err;
    }
};

export const sortByStatusAndColumn = (columnApi: ColumnApi) => {
    columnApi.resetColumnState();
    columnApi.applyColumnState({
        state: [
            { colId: "name", sort: "asc", sortIndex: 1 },
            { colId: "status", sort: "asc", sortIndex: 0 },
        ],
        // defaultState: { sort: null },
    });
};

export function filterKeywordsByCustomDate(
    start: moment.MomentInput,
    end: moment.MomentInput
) {
    return {
        report_date: {
            dateFrom: moment(start).format("YYYY-MM-DD"),
            dateTo: moment(end).format("YYYY-MM-DD"),
            filterType: "date",
            type: "inRange",
        },
    };
}

export const getClientId = (): number =>
    +(
        store.getState().clientIdOnChannelChange.value ||
        store.getState().activeClientId.value ||
        sessionStorage.getItem("active_client")
    );

export const getCountryCode = () => getClientAttributes().countryCode;

export const getCurrency = () => getClientAttributes().currency;

export const getAccountType = () => getClientAttributes().accountType;

export async function getPortfolio() {
    try {
        const clientPortfolio = await sendRequest(
            {
                type: `portfolios/id`,
                method: "post",
                API_DOMAIN: process.env.VITE_API_DOMAIN || "/api",
            },
            true
        );
        if (!clientPortfolio.status) {
            throw new Error("Could not get client specific portfolios");
        }
        return clientPortfolio.rows;
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
    }
}

export async function getCampaigns(
    filterArray: TCampaignFilters,
    actionType: string
) {
    const clientCampaigns = await sendRequest(
        {
            type: `campaigns/filter/list`,
            method: "post",
            API_DOMAIN: process.env.VITE_API_DOMAIN || "/api",
            data: {
                actionType,
                ...(filterArray.length && { filter: filterArray }),
            },
        },
        true
    );
    if (!clientCampaigns.status || !clientCampaigns.rows.length) {
        throw new Error("Could not get client specific campaigns");
    }
    window.sessionStorage.setItem(
        "campaignList",
        JSON.stringify(clientCampaigns.rows)
    );
    return clientCampaigns.rows;
}

export const getAdGroups = async (conditions: TSpecificAdgroup) => {
    const type = "adgroups/search";
    const response = await sendRequest({
        method: "post",
        type,
        data: {
            filters: {
                filter: conditions,
            },
        },
    });
    if (response.rows) {
        return response.rows;
    }
    return [];
};

export const createNegativeKeywords = async (data: TCreateNegativeKeyword) => {
    return await sendRequest({
        type: `keywords/negative`,
        data,
        method: "post",
    });
};

function getFilterDisplayValue(
    api: GridApi,
    field: string,
    appliedFilter: Record<string, any>,
    showTooltip = false,
    showCloseButton = true,
    visible = true
) {
    const { actionModalDisp } = store.getState();
    const isRuleModule = actionModalDisp.value;
    const key = (appliedFilter.header && appliedFilter.header.name) || field;
    const filterElement = document.createElement("span") as HTMLSpanElement;
    filterElement.className =
        "selected-filter badge border ms-1 mt-1 position-relative";
    filterElement.id = "filter-element";
    filterElement.setAttribute(
        "style",
        "width: 150px; padding: 7px; font-size:11px;"
    );
    let filterText: string;
    const isCustomFilter = CUSTOM_FILTER_TYPES.includes(
        appliedFilter.condition1?.type || appliedFilter.type
    );

    //to set custom tag type filter pill
    if (appliedFilter?.exclude !== undefined) {
        filterText = `${key} ${appliedFilter.exclude
                ? RuleFilterTextProps.NOT_IN
                : RuleFilterTextProps.IN
            } ${appliedFilter.values.join(",")}`;
    }
    //to set custom tag filter pill
    else if (appliedFilter?.isAndMode !== undefined) {
        const filterValues = map(
            appliedFilter.values,
            (v: string) => v.split("##")[1]
        );
        filterText = `${key} in ${filterValues.join(",")}`;
    } else if (
        Object.prototype.hasOwnProperty.call(
            appliedFilter,
            RuleFilterTextProps.CONDITION_1
        )
    ) {
        filterText = `${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.condition1.type]
            } ${!isCustomFilter
                ? appliedFilter.condition1[
                appliedFilter.filterType === RuleFilterType.DATE
                    ? RuleFilterTextProps.DATE_FROM
                    : RuleFilterTextProps.FILTER
                ]
                : ""
            } ${appliedFilter.operator} ${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.condition2.type]
            } ${!isCustomFilter
                ? appliedFilter.condition2[
                appliedFilter.filterType === RuleFilterType.DATE
                    ? RuleFilterTextProps.DATE_FROM
                    : RuleFilterTextProps.FILTER
                ]
                : ""
            }`;
    } else {
        if (appliedFilter.type === RuleFilterType.IN_RANGE) {
            filterText = `${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.type]} ${appliedFilter[
                appliedFilter.filterType === RuleFilterType.DATE
                    ? RuleFilterTextProps.DATE_FROM
                    : RuleFilterTextProps.FILTER
                ]
                } AND ${appliedFilter[
                appliedFilter.filterType === RuleFilterType.DATE
                    ? RuleFilterTextProps.DATE_TO
                    : RuleFilterTextProps.FILTER_TO
                ]
                }`;
        } else if (appliedFilter.filterType === RuleFilterType.SET) {
            filterText = `${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.filterType]
                } ${appliedFilter.values.join(",")}`;
        } else if (isCustomFilter) {
            filterText = `${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.type]}`;
        } else {
            filterText = `${key} ${FILTER_TYPE_SYMBOLS[appliedFilter.type]} ${appliedFilter[
                appliedFilter.filterType === RuleFilterType.DATE &&
                    appliedFilter.type !== RuleFilterType.RELATIVE
                    ? RuleFilterTextProps.DATE_FROM
                    : RuleFilterTextProps.FILTER
                ]
                }`;
        }
    }
    filterElement.textContent =
        filterText.length > 25
            ? `${filterText.substring(0, 20)}...`
            : filterText;
    const tooltipComponent = document.createElement("div");
    tooltipComponent.innerHTML = filterText;

    if (showTooltip) {
        $(filterElement).on("mouseenter", function EnableTooltip() {
            filterElement.dataset.toggle = "tooltip";
            filterElement.dataset.html = "true";
            filterElement.dataset.placement = "top";
            filterElement.title = filterText;
            const tooltipTriggerList = [].slice.call(
                document.querySelectorAll("#filter-element")
            );
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });
        });
    }
    if (showCloseButton && !isRuleModule && !["report_date"].includes(field)) {
        const closeButton = document.createElement(
            "button"
        ) as HTMLButtonElement;
        closeButton.type = "button";
        closeButton.className = `btn btn-primary-sm close-btn-sml bg-light rounded-circle times`;
        closeButton.setAttribute(
            "style",
            `position: absolute;
									z-index: 1000;
									padding: 0 5px;
									display:none;
									opacity:0.4;
									top: 5px;
									right: 2px;
                                    height: 16px;
                                    width:16px`
        );
        filterElement.onmouseout = function () {
            (
                (this as Document).querySelector(
                    ".close-btn-sml"
                ) as HTMLSpanElement
            ).style.display = "none";
        };
        filterElement.onmouseover = function () {
            (
                (this as Document).querySelector(
                    ".close-btn-sml"
                ) as HTMLSpanElement
            ).style.display = "unset";
        };
        closeButton.onmouseout = function () {
            (this as HTMLButtonElement).style.opacity = "0.4";
        };
        closeButton.onmouseover = function () {
            (this as HTMLButtonElement).style.opacity = "1";
        };
        filterElement.appendChild(closeButton);
        closeButton.onclick = () => {
            const tooltipInstance = Tooltip.getInstance(filterElement);
            if (tooltipInstance) {
                tooltipInstance.dispose();
            }
            const event = {
                detail: { key: field },
            };
            removeFilter(event, api);
        };
    }

    if (!visible) {
        filterElement.style.display = "none";
    }
    return filterElement;
}

type TRemoveFilterEvent = {
    detail: { key: string };
};

function removeFilter(event: TRemoveFilterEvent, api: GridApi) {
    const currentFilterModal = api.getFilterModel();
    const {
        // portfoliosData,
        keywordsData,
        productsData,
        campaignsData,
        adgroupsData,
        placementsData,
        poCheckedNode,
        caCheckedNode,
        adCheckedNode,
        pdCheckedNode,
        poFilterCount,
        caFilterCount,
        adFilterCount,
        pdFilterCount,
    } = store.getState();

    // let poInitCount = portfoliosData.value.length;
    const caInitCount = campaignsData.value.length;
    const adInitCount = adgroupsData.value.length;
    const kwInitCount = keywordsData.value.length;
    const pdInitCount = productsData.value.length;
    const plInitCount = placementsData.value.length;

    const poNodeCount = poCheckedNode.value.length;
    const caNodeCount = caCheckedNode.value.length;
    const adNodeCount = adCheckedNode.value.length;
    const pdNodeCount = pdCheckedNode.value.length;

    const key = event.detail.key;
    switch (key) {
        case "sys_campaign_id": {
            store.dispatch(updateCampaignFilters({}));
            store.dispatch(updateCaCheckedNode([]));
            store.dispatch(updateCaGridFilters({}));

            if (caFilterCount) {
                const {
                    pdCount,
                    adCount,
                    kwCount,
                    plCount,
                }: Record<string, number> = caFilterCount.value;
                if (
                    poNodeCount === 0 &&
                    adNodeCount === 0 &&
                    pdNodeCount === 0
                ) {
                    setPillBadges("adgroups-badge", adInitCount);
                    setPillBadges("keywords-badge", kwInitCount);
                    setPillBadges("products-badge", pdInitCount);
                    setPillBadges("placements-badge", plInitCount);
                } else {
                    setPillBadges("adgroups-badge", adCount);
                    setPillBadges("keywords-badge", kwCount);
                    setPillBadges("products-badge", pdCount);
                    setPillBadges("placements-badge", plCount);
                }
            }
            break;
        }
        case "sys_adgroup_id": {
            store.dispatch(updateAdgroupFilters({}));
            store.dispatch(updateAdCheckedNode([]));
            store.dispatch(updateAdGridFilters({}));

            if (adFilterCount) {
                const {
                    pdCount,
                    caCount,
                    kwCount,
                    plCount,
                }: Record<string, number> = adFilterCount.value;
                if (
                    poNodeCount === 0 &&
                    caNodeCount === 0 &&
                    pdNodeCount === 0
                ) {
                    setPillBadges("campaigns-badge", caInitCount);
                    setPillBadges("keywords-badge", kwInitCount);
                    setPillBadges("products-badge", pdInitCount);
                    setPillBadges("placements-badge", plInitCount);
                } else {
                    setPillBadges("campaigns-badge", caCount);
                    setPillBadges("keywords-badge", kwCount);
                    setPillBadges("products-badge", pdCount);
                    setPillBadges("placements-badge", plCount);
                }
            }
            break;
        }
        case "portfolio_id": {
            store.dispatch(updatePortfolioFilters({}));
            store.dispatch(updatePoCheckedNode([]));
            store.dispatch(updatePoGridFilters({}));

            if (poFilterCount) {
                const {
                    pdCount,
                    caCount,
                    adCount,
                    kwCount,
                    plCount,
                }: Record<string, number> = poFilterCount.value;
                if (
                    adNodeCount === 0 &&
                    caNodeCount === 0 &&
                    pdNodeCount === 0
                ) {
                    setPillBadges("campaigns-badge", caInitCount);
                    setPillBadges("adgroups-badge", adInitCount);
                    setPillBadges("keywords-badge", kwInitCount);
                    setPillBadges("products-badge", pdInitCount);
                    setPillBadges("placements-badge", plInitCount);
                } else {
                    setPillBadges("campaigns-badge", caCount);
                    setPillBadges("adgroups-badge", adCount);
                    setPillBadges("keywords-badge", kwCount);
                    setPillBadges("products-badge", pdCount);
                    setPillBadges("placements-badge", plCount);
                }
            }
            break;
        }
        case "top_product": {
            store.dispatch(updateProductFilters({}));
            store.dispatch(updatePdCheckedNode([]));
            store.dispatch(updatePdGridFilters({}));

            if (pdFilterCount) {
                const {
                    caCount,
                    adCount,
                    kwCount,
                    plCount,
                }: Record<string, number> = pdFilterCount.value;

                if (
                    poNodeCount === 0 &&
                    caNodeCount === 0 &&
                    adNodeCount === 0
                ) {
                    setPillBadges("campaigns-badge", caInitCount);
                    setPillBadges("adgroups-badge", adInitCount);
                    setPillBadges("keywords-badge", kwInitCount);
                    setPillBadges("placements-badge", plInitCount);
                } else {
                    setPillBadges("campaigns-badge", caCount);
                    setPillBadges("adgroups-badge", adCount);
                    setPillBadges("keywords-badge", kwCount);
                    setPillBadges("placements-badge", plCount);
                }
            }
            break;
        }
        default:
            setPillBadges("campaigns-badge", caInitCount);
            setPillBadges("adgroups-badge", adInitCount);
            setPillBadges("keywords-badge", kwInitCount);
            setPillBadges("products-badge", pdInitCount);
            setPillBadges("placements-badge", plInitCount);
    }
    const activeFilters = JSON.parse(sessionStorage.getItem("activeFilters"));
    // if(api !== null){
    //   delete currentFilterModal[event.detail.key];
    //   delete activeFilters[event.detail.key];
    //   sessionStorage.setItem("activeFilters",JSON.stringify(activeFilters));
    //   api.setFilterModel(currentFilterModal);
    //   setFilters(api);
    // }
    delete currentFilterModal[event.detail.key];
    delete activeFilters[event.detail.key];
    sessionStorage.setItem("activeFilters", JSON.stringify(activeFilters));
    api.setFilterModel(currentFilterModal);
    setFilters(api);
    const selectedNodes = api.getSelectedNodes();
    selectedNodes.forEach((item: RowNode) => {
        item.setSelected(false);
    });
    // $("#campaigns-badge").html(campaignsData.value.length);
    // $("#adgroups-badge").html(adgroupsData.value.length);
    // $("#keywords-badge").html(keywordsData.value.length);
    // $("#products-badge").html(productsData.value.length);
}

function hideLessFiltersHandler(rootId: string) {
    document.getElementById(setFilterDropDownId()).style.display = "none";
    hideElementById("less-filters-btn", rootId);
    showElementById("more-filters-btn", rootId, "inline-block");
}

function showMoreFiltersHandler(rootId: string) {
    const filterComponentId = setFilterDropDownId();
    document.getElementById(filterComponentId).style.display = "unset";
    const totalFilters = document.querySelector(".selectedFilters").childNodes;
    const parentElem = document.createElement("div");
    const minFiltersLen =
        rootId === "#actions-modal #modal-filters"
            ? 2
            : MINIMUM_FILTERS_TO_DISPLAY;
    totalFilters.forEach((data, index) => {
        if (index > minFiltersLen - 1) {
            const childElem = document.createElement("div");
            childElem.id = "filters-drop-down-option";
            childElem.innerText = (data as HTMLElement).innerText;
            parentElem.append(childElem);
        }
    });
    document.getElementById(filterComponentId).innerHTML = "";
    document.getElementById(filterComponentId).append(parentElem);
    hideElementById("more-filters-btn", rootId);
    showElementById("less-filters-btn", rootId, "inline-block");
}

function getHideLessFiltersButtonComponent(state: string, rootId: string) {
    const config = {
        id: "less-filters-btn",
        classes: "btn btn-xs text-primary",
        value: " Show less",
        style: state === "show" ? "display:inline-block;" : "display:none;",
        clickHandler: () => hideLessFiltersHandler(rootId),
    };
    const hideButton = createButtonElement(config);
    return hideButton;
}

function getShowMoreFiltersButtonComponent(state: string, rootId: string) {
    const config = {
        id: "more-filters-btn",
        classes: "btn btn-xs text-primary",
        value: " Show more",
        style: state === "show" ? "display:inline-block;" : "display:none;",
        clickHandler: () => showMoreFiltersHandler(rootId),
    };
    const moreButton = createButtonElement(config);
    return moreButton;
}

export function removeAppliedFilters() {
    const savedFilterContainer = document.querySelector("#savedFilters");
    if (savedFilterContainer) {
        savedFilterContainer.innerHTML = "";
    }
}

/**
 * !This function needs to be refactored
 */

export function onClickClearFiltersHandler(
    api?: GridApi,
    clearFiltersFromSessionStorage = true
) {
    if (clearFiltersFromSessionStorage) {
        sessionStorage.removeItem("appliedFilters");
    }
    // setDefaultFilters(api);
    removeAppliedFilters();
    setDefaultFilters(api);
}

export function getCurrentFilterDOM(
    api: GridApi,
    filterModel: TFilterModel,
    showTooltip = false,
    showCloseButton = true,
    numberOfDisplayedFilters = 3
) {
    const keys = Object.keys(filterModel);
    const currentFilters = document.createElement("span");
    currentFilters.className =
        "selectedFilters float-none float-sm-start ellipsis";
    if (keys.length) {
        keys.forEach((key, index) => {
            /** @fixed : condition was false even when .filter exist but falsy like .filter = 0, it should have been allowed */
            if (
                [
                    RuleFilterTextProps.FILTER,
                    RuleFilterTextProps.DATE_FROM,
                    RuleFilterTextProps.CONDITION_1,
                    RuleFilterTextProps.CONDITION_2,
                    RuleFilterTextProps.VALUES,
                ].some((field) => field in filterModel[key]) ||
                CUSTOM_FILTER_TYPES.includes(filterModel[key].type)
            ) {
                currentFilters.append(
                    getFilterDisplayValue(
                        api,
                        key,
                        filterModel[key],
                        showTooltip,
                        showCloseButton,
                        !(index > numberOfDisplayedFilters - 1)
                    )
                );
            }
        });
    }
    return currentFilters;
}

function showElementById(elementId: string, rootId?: string, display = "flex") {
    $(`${rootId ? rootId : ""} #${elementId}`).css("display", display);
}

function hideElementById(elementId: string, rootId?: string) {
    $(`${rootId ? rootId : ""} #${elementId}`).css("display", "none");
}

function disableButton(buttonId: string) {
    $(`#${buttonId}`).attr("disabled", "true");
}

function enableButton(buttonId: string) {
    $(`#${buttonId}`).attr("disabled", "false");
}

type TBtnConfig = {
    id: string;
    classes: string;
    value: string;
    style: string;
    clickHandler: () => void;
    attributes?: Record<string, string>;
};

function createButtonElement(config: TBtnConfig) {
    const button = document.createElement("span");
    const inputElement = document.createElement("input") as HTMLInputElement;
    inputElement.type = "button";
    inputElement.className = config.classes;
    inputElement.value = config.value;
    inputElement.id = config.id;
    inputElement.style.cssText = config.style;
    inputElement.onclick = config.clickHandler;

    if (config.attributes && Object.keys(config.attributes).length) {
        Object.keys(config.attributes).forEach((attr) => {
            inputElement.setAttribute(attr, config.attributes[attr]);
        });
    }

    button.append(inputElement);
    return button;
}

const setFilterDropDownId = () => {
    const { actionModalDisp } = store.getState();
    const isRuleModule = actionModalDisp.value;
    return isRuleModule ? "rules-filters-drop-down" : "filters-drop-down";
};

export function showAppliedFilters(
    api: GridApi,
    filterModel: TFilterModel,
    parentElem: string,
    showButtons = true,
    showTooltip = true
) {
    /** change to also allow inserting filter pills in an unmounted element */
    const parentElement =
        typeof parentElem === "string"
            ? document.querySelector(`${parentElem}`)
            : parentElem;

    parentElement.innerHTML = "";
    parentElement.className = "clearfix";
    // parentElement.style.marginBottom="40px";
    const keys = Object.keys(filterModel);

    const minFiltersLen = [
        "#actions-modal #modal-filters",
        "#product-mapping-filters",
    ].includes(parentElem)
        ? 2
        : MINIMUM_FILTERS_TO_DISPLAY;

    const currentFilters = getCurrentFilterDOM(
        api,
        filterModel,
        showTooltip,
        true,
        minFiltersLen
    );

    let moreButton: string | HTMLSpanElement = "";
    let lessButton: string | HTMLSpanElement = "";

    if (keys.length) {
        if (keys.length > minFiltersLen) {
            moreButton = getShowMoreFiltersButtonComponent("show", parentElem);
            lessButton = getHideLessFiltersButtonComponent("hide", parentElem);
        }
        enableButton("saveFiltersBtn");
    } else {
        disableButton("saveFiltersBtn");
    }
    parentElement.append(currentFilters);

    // Filters drop down
    const filtersElement = document.createElement("div");
    filtersElement.className = "card shadow";
    filtersElement.id = setFilterDropDownId();
    const buttonsElement = document.createElement("div");
    const dropDownElement = document.createElement("div");
    const buttonsGroup = document.createElement("div");
    buttonsGroup.style.cssText = "display:inline-block;margin-top:0.4rem";
    buttonsElement.append(moreButton);
    buttonsElement.append(lessButton);
    dropDownElement.append(filtersElement);
    buttonsGroup.append(buttonsElement);
    buttonsGroup.append(dropDownElement);

    if (showButtons) {
        parentElement.append(buttonsGroup);
    }
}

export function addRelativeDateFilter(
    key: string,
    dateRangeKey: IDRange | string
) {
    return {
        [key]: {
            filter: dateRangeKey,
            filterType: "date",
            type: "relative",
        },
    };
}

export function setFilters(api?: GridApi, modelId?: string) {
    const defaultDateKey = "Last 7 Days";
    const { activeModule } = getActiveModule();
    const activeDateFilter = JSON.parse(
        sessionStorage.getItem("currentDateFilter")
    );
    const currentDateFilter = activeDateFilter
        ? activeDateFilter
        : addRelativeDateFilter("report_date", defaultDateKey);
    const activeFilters = JSON.parse(sessionStorage.getItem("activeFilters"));
    const filterModel = { ...currentDateFilter, ...activeFilters };

    activeModule === ParentModule.CHANGE_LOG && delete filterModel.report_date;
    !includes(NO_FILTER_MODULES, activeModule) &&
        showAppliedFilters(api, filterModel, modelId || "#savedFilters");

    Sentry.setTag("filters", JSON.stringify(filterModel));
}

export const negativeKeywordsSelectionChanged = async (
    event: GridReadyEvent
) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node: RowNode) => node.data);
        store.dispatch(updateNegativeKeywordsSelectionData(selectedData));
        showElementById("bulk-operations-div");
    } else {
        store.dispatch(updateNegativeKeywordsSelectionData([]));
        hideElementById("bulk-operations-div");
    }
};

export const historyLogsSelectionChanged = async (event: GridReadyEvent) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node: RowNode) => node.data);
        store.dispatch(updateHistoryLogsSelectionData(selectedData));
        showElementById("bulk-operations-div");
    } else {
        store.dispatch(updateHistoryLogsSelectionData([]));
        hideElementById("bulk-operations-div");
    }
};

type TItem = {
    campaign_id: string;
    ad_group_id: string;
    customer_search_term: string;
    program_type: string;
    adgroup_type: string;
    keyword_type: string;
    nature: string;
};

export async function addBulkNegatives() {
    const negativeKeywordsSelectionData =
        store.getState().negativeKeywordsSelectionData.value;
    const selectedData = checkForKeywordOrTarget(
        negativeKeywordsSelectionData,
        "customer_search_term"
    );
    const channel = store.getState().channel.value;

    const spinnerElement = $(`#add-negatives-bulk-action`);
    spinnerElement.replaceWith(spinnerHtml);
    try {
        const data = selectedData.map((item) => {
            const {
                campaign_id,
                ad_group_id,
                customer_search_term,
                program_type,
                adgroup_type,
                keyword_type,
                nature,
            } = item as TItem;

            return {
                attribute: ["create_negative_target"],
                campaignId: campaign_id,
                ...(ad_group_id && { adGroupId: ad_group_id }),
                keywordText: customer_search_term,
                programType: program_type,
                state: StateTypeValues.ENABLED,
                matchType:
                    keyword_type === RecordType.KEYWORD
                        ? MatchType.NEGATIVE_EXACT
                        : MatchType.ASIN_SAME_AS,
                adGroupType:
                    (keyword_type === RecordType.KEYWORD &&
                        nature === Nature.AUTO) ||
                        channel !== Channels.AMAZON
                        ? RecordType.KEYWORD
                        : adgroup_type,
                nature,
            };
        });

        const keywords = data
            .filter((i) => i.adGroupType === RecordType.KEYWORD)
            .map((i) => {
                delete i["adGroupType"];
                delete i["nature"];
                return i;
            });

        const targets = data
            .filter((i) => i.adGroupType === RecordType.TARGET)
            .map((i) => {
                delete i["adGroupType"];
                delete i["nature"];
                return i;
            });

        const response = await createNegativeKeywords({
            ...(keywords.length && { keywords }),
            ...(targets.length && { targets }),
        });

        const message = response.metadata
            ? `${response.metadata.keywordsAndTargets.success}/${response.metadata.keywordsAndTargets.total} negative keywords and targets are successfully created.`
            : response.message;

        if (response.status) {
            showToast("success", message);
        } else {
            showToast(
                "danger",
                response.isUserRestricted
                    ? `Unable to add negatives: ${response.message}`
                    : "Unable to add negatives"
            );
        }
    } catch (err) {
        console.error(err);
        showToast(
            "danger",
            `Unable to add negatives: ${(err as Error).message}`
        );
        Sentry.captureException(err);
    }
    $("#bulkActionSpinner").replaceWith(spinnerElement);
    $("#pa-bulk-action-drop-down").css({ display: "none" });
}

export const removeBulkNegatives = async () => {
    const negativeKeywordsSelectionData =
        store.getState().negativeKeywordsSelectionData.value;
    const spinnerElement = $(`#remove-negatives-bulk-action`);
    spinnerElement.replaceWith(spinnerHtml);
    try {
        const response = await updateNegativeKeywords(
            map(negativeKeywordsSelectionData, (n) => ({
                keywordId: n.sys_neg_kw_id,
                state: StateTypeValues.ARCHIVED,
                attribute: ["state"],
            }))
        );

        const message = response.metadata
            ? `${response.metadata.keywordsAndTargets.success}/${response.metadata.keywordsAndTargets.total} negative keywords/targets are successfully created.`
            : response.message;

        if (response.status) {
            showToast("success", message);
        } else {
            showToast(
                "danger",
                response.isUserRestricted
                    ? `Unable to add negatives: ${response.message}`
                    : "Unable to add negatives"
            );
        }
    } catch (err) {
        console.error(err);
        showToast(
            "danger",
            `Unable to add negatives: ${(err as Error).message}`
        );
        Sentry.captureException(err);
    }
    $("#bulkActionSpinner").replaceWith(spinnerElement);
    $("#pa-bulk-action-drop-down").css({ display: "none" });
};

export function onFilterSelection(
    key: string,
    selectedNodes: RowNode[],
    gridApi: GridApi
) {
    const values = selectedNodes
        .map((node: RowNode) => ("" + node.data[key]).split(","))
        .flat();
    const currentFilters =
        JSON.parse(sessionStorage.getItem("activeFilters")) || {};
    delete currentFilters[key];
    const activeFilters = {
        ...gridApi.getFilterModel(),
        ...currentFilters,
        ...(values.length
            ? {
                [key]: {
                    values: values,
                    filterType: RuleFilterType.SET,
                },
            }
            : {}),
    };

    sessionStorage.setItem("activeFilters", JSON.stringify(activeFilters));
    setFilters(gridApi);
}

export const setInitialFilters = () => {
    const { activeModule } = getActiveModule();
    let initialFilters;

    if (activeModule === SubModule.SUGGESTED_NEG_KWS) {
        initialFilters = {
            sale: { filterType: "number", type: "lessThan", filter: 1 },
            spend: {
                filterType: "number",
                type: "greaterThanOrEqual",
                filter: 100,
            },
        };
    } else if (activeModule === SubModule.KEYWORD_MANUAL) {
        initialFilters = {
            acos: {
                filterType: "number",
                type: "lessThanOrEqual",
                filter: 100,
            },
            orders: {
                filterType: "number",
                type: "greaterThanOrEqual",
                filter: 1,
            },
        };
    }
    return initialFilters;
};

export function setDefaultFilters(api?: GridApi) {
    const defaultDateKey = "Last 7 Days";
    const activeDateFilter = JSON.parse(
        sessionStorage.getItem("currentDateFilter")
    );
    const currentDateFilter = activeDateFilter
        ? activeDateFilter
        : addRelativeDateFilter("report_date", defaultDateKey);
    const initialFilters = setInitialFilters();
    const activeFilters = {
        ...initialFilters,
        ...currentDateFilter,
    };
    sessionStorage.setItem("activeFilters", JSON.stringify(activeFilters));
    setFilters(api);
    if (api) {
        api.setFilterModel(initialFilters);
    }
}

function filterCondition(
    type: string,
    key: string,
    value: string,
    node: RowNode
) {
    switch (type) {
        case "percentIncreasedBy":
            if (
                node.data[`${key}_change`] &&
                node.data[`${key}_change`] >= value
            ) {
                return true;
            }
            break;
        case "percentDecreasedBy":
            if (
                node.data[`${key}_change`] &&
                node.data[`${key}_change`] <= -value
            ) {
                return true;
            }
            break;
        case "inSet":
            if (node.data[key] && JSON.parse(value).includes(node.data[key])) {
                return true;
            }
            break;
        default:
            console.error(`Unknown filterType ${type}`);
    }
    return false;
}

let externalFilters: Record<string, any>[] = [];

export function isExternalFilterPresent({ api }: { api: GridApi }) {
    const filterModel = api.getFilterModel();
    externalFilters = Object.entries(filterModel)
        .map((externalFilter) => {
            let filterType;
            if (
                externalFilter[1].type &&
                EXTERNAL_FILTERS.includes(externalFilter[1].type)
            ) {
                filterType = {
                    key: externalFilter[0],
                    type: externalFilter[1].type,
                    value: externalFilter[1].filter,
                };
            } else if (
                externalFilter[1].condition1 &&
                EXTERNAL_FILTERS.includes(externalFilter[1].condition1.type)
            ) {
                filterType = {
                    key: externalFilter[0],
                    type: externalFilter[1].condition1.type,
                    value: externalFilter[1].condition1.filter,
                };
            } else if (
                externalFilter[1].condition2 &&
                EXTERNAL_FILTERS.includes(externalFilter[1].condition2.type)
            ) {
                filterType = {
                    key: externalFilter[0],
                    type: externalFilter[1].condition2.type,
                    value: externalFilter[1].condition2.filter,
                };
            }
            return filterType;
        })
        .filter((externalFilter) => externalFilter);

    return !!externalFilters.length;
}

export function doesExternalFilterPass(node: RowNode) {
    const result =
        externalFilters &&
        externalFilters.filter((externalFilter: Record<string, any>) =>
            externalFilter && externalFilter.type
                ? filterCondition(
                    externalFilter.type,
                    externalFilter.key,
                    externalFilter.value,
                    node
                )
                : false
        );

    return result.length === externalFilters.length;
}

export function showActionModalHandler(activeModule: string) {
    let path;
    let moduleSlug;
    if (
        activeModule === SubModule.PORTFOLIO ||
        activeModule === SubModule.CAMPAIGN ||
        activeModule === SubModule.ADGROUP ||
        activeModule === SubModule.KEYWORD ||
        activeModule === SubModule.PRODUCT
    ) {
        path = ParentModule.PERFORMANCE_OVERVIEW;
        moduleSlug = activeModule;
    } else if (activeModule === SubModule.SUGGESTED_NEG_KWS) {
        // neg kws module was divided into 2 sub parts (suggested and existing)
        path = ParentModule.NEGATIVE_KEYWORDS;
        moduleSlug = ParentModule.NEGATIVE_KEYWORDS;
    } else {
        path = activeModule;
        //review with Vaheed - fix for nkw rule
        moduleSlug = activeModule;
    }

    const activeFilters = JSON.parse(sessionStorage.getItem("activeFilters"));

    const config = {
        ...(!MODULES[path].hasSubModules && {
            module:
                path === ParentModule.PERFORMANCE_OVERVIEW
                    ? moduleSlug
                    : MODULES[path].moduleSlug,
        }),
        module: moduleSlug,
        ...(MODULES[path].actions && {
            actions: MODULES[path].actions,
        }),
        filter: {
            ...activeFilters,
        },
        isEdit: false,
    };

    showModalHandler("actions-modal", config);
}

export function campaignClassFormatter(params: ValueFormatterParams) {
    switch (params.value) {
        case "campaign":
            return `Normal`;
        default:
            return ``;
    }
}

export function bulkAction(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    show: boolean,
    setShow?: (arg: boolean) => void,
    excludedBidProgramType?: string[]
) {
    const isBudgetUpdate = $("#updateBudgetOption")?.length > 0;
    const type = isBudgetUpdate ? "campaigns" : "keywords";
    const operationType = (
        isBudgetUpdate ? $("#updateBudgetOption") : $("#updateBidOption")
    )
        .find("option:selected")
        .val();
    bulkActionChangeSubmit(
        operationType as string,
        type,
        {
            isBulkAction: true,
            event,
        },
        show,
        setShow,
        excludedBidProgramType
    );
}

export function bulkActionChangeSubmit(
    operationType: string,
    type = "keywords",
    spinnerOptions?: TOperationType,
    show?: boolean,
    setShow?: (arg: boolean) => void,
    excludedBidProgramType?: string[],
    moduleConfig?: {
        equally_divide_budget?: {
            payloadKey: string;
            isVisible?: boolean;
            showForTypes?: string[];
        };
    }
) {
    const isBulkAction =
        (spinnerOptions && spinnerOptions.isBulkAction) || false;
    let selectedData: Keyword[] & Campaign[];
    let data: object | Array<object>;
    const productsData: TProductsData[] = [];
    let productAdsArr = [];
    const spinnerElement = $(`#${operationType}-bulk-action`);

    const {
        campaignsSelectionData,
        keywordsSelectionData,
        overviewKeywordsSelectionData,
        productsSelectionData,
        productAdgroupsSelectionData,
        customModalDisp,
        channel,
        clientTimezone,
    } = store.getState();

    const channelId = channel.value;

    isBulkAction &&
        setSpinner("add", spinnerOptions.event, spinnerOptions.isBulkAction);
    const { activeModule } = getActiveModule();
    let isModalAction = false;

    if (type === SubModule.CAMPAIGN) {
        selectedData = campaignsSelectionData.value;
    } else if (type === SubModule.KEYWORD) {
        if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
            isModalAction = true;
            selectedData = keywordsSelectionData.value;
        } else {
            if (excludedBidProgramType?.length) {
                selectedData = overviewKeywordsSelectionData.value.filter(
                    (keyword: Keyword) =>
                        !excludedBidProgramType.includes(keyword.program_type)
                );
            } else {
                selectedData = overviewKeywordsSelectionData.value;
            }
            if (!selectedData.length) {
                showToast(
                    "danger",
                    "This operation is not allowed for the selected data"
                );
                setSpinner("remove", spinnerOptions.event, true);
                return;
            }
        }
    } else if (type === ParentModule.PRODUCT_ANALYTICS) {
        isModalAction = true;
        selectedData = customModalDisp.value
            ? productAdgroupsSelectionData.value
            : productsSelectionData.value;
    } else if (type == SubModule.PRODUCT) {
        selectedData = productAdgroupsSelectionData.value;
    }

    const bulkRequiredConfig: IBulkRequiredConfig = {
        selectedRows: selectedData,
        bulkParamsToChange: [],
        ...(!isModalAction && {
            paramToFilter: gridUpdateConfig[type as Modules].paramToFilter,
        }),
    };
    const updateGridConfig = {
        isReduxState: true,
        bulkRequiredConfig,
    };

    switch (type) {
        case SubModule.CAMPAIGN:
            if (
                operationType === Features.PAUSE ||
                operationType === Features.ENABLE ||
                operationType === Features.ARCHIVE
            ) {
                if (channelId === Channels.BLINKIT) {
                    let filteredCampaigns;
                    if (operationType === Features.ARCHIVE) {
                        filteredCampaigns = selectedData.filter(
                            (c: Campaign) =>
                                c.state !== CAMPAIGN_STATES.ARCHIVED
                        );
                    }

                    if (operationType === Features.ENABLE) {
                        filteredCampaigns = selectedData.filter(
                            (c: Campaign) => c.state !== CAMPAIGN_STATES.ENABLED
                        );
                    }

                    if (operationType !== Features.ARCHIVE) {
                        data = map(filteredCampaigns, (c: Campaign) => ({
                            campaignId: c.sys_campaign_id.toString(),
                            state: `${operationType}d`,
                            attribute: ["budget"],
                            endDate: c.end_date
                                ? dayjs
                                    .tz(
                                        dayjs(
                                            typeof c.end_date === "string"
                                                ? dayjs(
                                                    c.end_date,
                                                    "YYYY-MM-DD"
                                                )
                                                : c.end_date
                                        ).utc(),
                                        clientTimezone.value
                                    )
                                    .endOf("day")
                                    .valueOf()
                                : 0,
                            budget: parseInternationalizedValue(c.budget),
                            tillBudgetEnds: c.till_budget_ends,
                            equallyDivideBudget:
                                !isNull(c.equally_divide_budget) &&
                                c.equally_divide_budget,
                        }));
                    } else {
                        data = map(filteredCampaigns, (c: Campaign) => ({
                            campaignId: c.sys_campaign_id.toString(),
                            state: `${operationType}d`,
                            attribute: ["state"],
                        }));
                    }
                } else {
                    data = map(selectedData, (c: Campaign) => ({
                        campaignId: c.sys_campaign_id.toString(),
                        state: `${operationType}d`,
                        attribute: ["state"],
                    }));
                }

                if (!(data as Array<object>).length) {
                    showToast(
                        "danger",
                        "This operation is not allowed for the selected campaigns"
                    );
                    return;
                }

                updateCampaigns(data as TUpdateCampaigns).then((response) => {
                    if (response.status) {
                        forEach(selectedData, (campaign: Campaign) => {
                            const statusInputId = `campaign-status-btn-${campaign.sys_campaign_id}`;
                            operationType === "enable"
                                ? $(`#${statusInputId}`).prop("checked", true)
                                : $(`#${statusInputId}`).prop("checked", false);
                        });
                        showToast(
                            "success",
                            `Status of ${selectedData.length} ${type} changed successfully to ${operationType}d`
                        );
                        bulkRequiredConfig.bulkParamsToChange = [
                            {
                                key: GRID_COLUMNS.STATE,
                                newValue: `${operationType}d`,
                            },
                            {
                                key: GRID_COLUMNS.CAMPAIGN_STATUS,
                                newValue:
                                    operationType === Features.PAUSE
                                        ? "stopped"
                                        : "active",
                                isDateCalcReq: false,
                            },
                            {
                                key: GRID_COLUMNS.IS_ARCHIVED_ENTITY,
                                newValue:
                                    operationType === Features.PAUSE
                                        ? true
                                        : false,
                                isDateCalcReq: false,
                            },
                        ];

                        setUpdateGridData(updateGridConfig);
                    } else {
                        showToast(
                            "danger",
                            response.isUserRestricted
                                ? `Operation campaigns updation is unsuccessful: ${response.message}`
                                : `Operation campaigns updation is unsuccessful. Please try again later.`
                        );
                    }
                    isBulkAction &&
                        setSpinner("remove", spinnerOptions.event, true);
                });
            } else if (
                operationType === ActionType.PERC_INC ||
                operationType === ActionType.PERC_DEC ||
                operationType === ActionType.ABSOLUTE
            ) {
                const budgetInput = +$("input#updateBudgetInput").val();
                const isUpdateBudgets = validateBidOrBudgetValueUpdate(
                    selectedData,
                    budgetInput,
                    operationType,
                    "budget"
                );

                if (isUpdateBudgets) {
                    const clientTimezone =
                        store.getState().clientTimezone.value;
                    if (channel.value === Channels.BLINKIT) {
                        selectedData = filter(
                            campaignsSelectionData.value,
                            (c) => c.state != CAMPAIGN_STATES.ARCHIVED
                        );
                    }
                    const campaignData = selectedData.map(
                        (c: Campaign) =>
                        ({
                            campaignId: c.sys_campaign_id.toString(),
                            changeType: operationType,
                            changeValue: budgetInput,
                            attribute: ["budget"],
                            state: c.state,
                            ...(channel.value !== Channels.AMAZON && {
                                endDate: c.end_date
                                    ? dayjs
                                        .tz(
                                            dayjs(
                                                typeof c.end_date ===
                                                    "string"
                                                    ? dayjs(
                                                        c.end_date,
                                                        "YYYY-MM-DD"
                                                    )
                                                    : c.end_date
                                            ).utc(),
                                            clientTimezone
                                        )
                                        .endOf("day")
                                        .valueOf()
                                    : 0,
                                tillBudgetEnds: c.till_budget_ends,
                                ...(moduleConfig?.equally_divide_budget
                                    ?.payloadKey &&
                                    moduleConfig.equally_divide_budget.showForTypes?.includes(
                                        c.program_type
                                    ) && {
                                    [moduleConfig.equally_divide_budget
                                        .payloadKey]:
                                        c.equally_divide_budget,
                                }),
                            }),
                        } as TCampaigns)
                    );

                    if (campaignData.length > 0) {
                        updateCampaigns(campaignData)
                            .then((response) => {
                                if (response.status) {
                                    const successMessage = response.message
                                        ? response.message
                                        : `Budget updated successfully for ${selectedData.length} campaigns`;

                                    bulkRequiredConfig.bulkParamsToChange = [
                                        {
                                            key: "budget",
                                            newValue: budgetInput,
                                        },
                                    ];
                                    bulkRequiredConfig.updateType =
                                        operationType === ActionType.PERC_INC
                                            ? ActionType.PERC_INC
                                            : operationType ===
                                                ActionType.PERC_DEC
                                                ? ActionType.PERC_DEC
                                                : ActionType.ABSOLUTE;

                                    // Track successful updates
                                    bulkRequiredConfig.successfulUpdatedRows =
                                        selectedData;

                                    setUpdateGridData(updateGridConfig);
                                    showToast("success", successMessage);
                                } else {
                                    showToast("danger", response.message);
                                }
                            })
                            .catch((error) => {
                                console.error(
                                    "Error updating campaign budgets:",
                                    error
                                );
                                showToast(
                                    "danger",
                                    "Failed to update campaign budgets"
                                );
                                Sentry.captureException(error);
                            })
                            .finally(() => {
                                isBulkAction &&
                                    setSpinner(
                                        "remove",
                                        spinnerOptions.event,
                                        true
                                    );
                                show && setShow(false);
                            });
                    }
                    $("input#updateBudgetInput").val("");
                }
            }
            break;
        case "keywords":
            if (
                operationType === ActionType.PERC_INC ||
                operationType === ActionType.PERC_DEC ||
                operationType === ActionType.ABSOLUTE
            ) {
                const bidInput = +$("input#updateBidInput").val();
                let changedValue: number,
                    isBidExceeded = false;
                if (
                    !validateBidOrBudgetValueUpdate(
                        selectedData,
                        bidInput,
                        operationType,
                        "bid"
                    )
                ) {
                    return;
                }

                switch (channelId) {
                    case Channels.AMAZON:
                        selectedData.forEach((k: Keyword) => {
                            if (operationType === ActionType.PERC_INC)
                                changedValue = k.bid + (k.bid / 100) * bidInput;
                            else if (operationType === ActionType.PERC_DEC)
                                changedValue = k.bid - (k.bid / 100) * bidInput;
                            else if (operationType === ActionType.ABSOLUTE)
                                changedValue = bidInput;

                            const programType =
                                k.cost_type === CostType.VCPM
                                    ? ProgramType["SD-VCPM"]
                                    : k.program_type;

                            if (
                                changedValue < k.min_bid_value ||
                                changedValue > k.max_bid_value
                            )
                                isBidExceeded = true;
                            if (
                                (programType.toUpperCase() ===
                                    ProgramType.SD.toUpperCase() ||
                                    programType.toUpperCase() ===
                                    ProgramType["SD-VCPM"].toUpperCase()) &&
                                changedValue > k.campaign_budget / 2
                            )
                                isBidExceeded = true;
                            else if (
                                (programType.toUpperCase() ===
                                    ProgramType.SP.toUpperCase() ||
                                    programType.toUpperCase() ===
                                    ProgramType.SB.toUpperCase()) &&
                                changedValue > k.campaign_budget
                            )
                                isBidExceeded = true;
                        });

                        break;
                    case Channels.FLIPKART:
                    case Channels.BLINKIT:
                    case Channels.ZEPTO:
                    case Channels.TAKEALOT:
                    case Channels.PURPLLE:
                    case Channels.INSTAMART:
                    case Channels.MYNTRA:
                        selectedData.forEach((k: Keyword) => {
                            if (operationType === ActionType.PERC_INC)
                                changedValue = k.bid + (k.bid / 100) * bidInput;
                            else if (operationType === ActionType.PERC_DEC)
                                changedValue = k.bid - (k.bid / 100) * bidInput;
                            else if (operationType === ActionType.ABSOLUTE)
                                changedValue = bidInput;

                            if (
                                changedValue < k.min_bid_value ||
                                ((channelId === Channels.FLIPKART ||
                                    (channelId === Channels.BLINKIT &&
                                        k.record_type === RecordType.TARGET)) &&
                                    changedValue > k.max_bid_value)
                            )
                                isBidExceeded = true;
                        });
                        break;
                    default:
                        console.info(`Channel not found for bulk action.`);
                }
                if (isBidExceeded) {
                    const isUpdateBids = window.confirm(
                        "Some bids violate the permissible limits. Do you want to set those to the respective permissible limits?"
                    );
                    if (isUpdateBids) {
                        data = {
                            keywords: selectedData.map((k: Keyword) => ({
                                attribute: [
                                    activeModule === SubModule.PLACEMENTS
                                        ? "placement"
                                        : "bid",
                                ],
                                ...(activeModule === SubModule.PLACEMENTS
                                    ? {
                                        placementId:
                                            k.sys_ams_keyword_id.toString(),
                                    }
                                    : {
                                        keywordId:
                                            k.sys_ams_keyword_id.toString(),
                                    }),
                                campaignBudget: k.campaign_budget,
                                changeType: operationType,
                                changeValue: bidInput,
                            })),
                        };
                    } else {
                        data = null;
                        $("input#updateBidInput").val("");
                        isBulkAction &&
                            setSpinner("remove", spinnerOptions.event, true);
                        hideChangeBid();
                    }
                } else {
                    data = {
                        keywords: selectedData.map((k: Keyword) => ({
                            ...(activeModule === SubModule.PLACEMENTS
                                ? {
                                    placementId:
                                        k.sys_ams_keyword_id.toString(),
                                }
                                : {
                                    keywordId:
                                        k.sys_ams_keyword_id.toString(),
                                }),
                            changeType: operationType,
                            changeValue: bidInput,
                            attribute: [
                                activeModule === SubModule.PLACEMENTS
                                    ? "placement"
                                    : "bid",
                            ],
                        })),
                    };
                }

                data &&
                    (activeModule === SubModule.PLACEMENTS
                        ? updatePlacements(data as TUpdateKeywords)
                        : updateKeywords(data as TUpdateKeywords)
                    )
                        .then((response) => {
                            if (response.status) {
                                const message = response.metadata
                                    ? `${response.metadata.keywords.success}/${response.metadata.keywords.total} keywords and ${response.metadata.targets.success}/${response.metadata.targets.total} targets are successful.`
                                    : response.message;

                                //* This is common for all channels
                                bulkRequiredConfig.bulkParamsToChange = [
                                    {
                                        key: "bid",
                                        newValue: bidInput,
                                    },
                                ];
                                bulkRequiredConfig.updateType = operationType;

                                switch (channelId) {
                                    case Channels.AMAZON: {
                                        const successResults: TCommonRowData =
                                            [];
                                        response.metadata &&
                                            response.metadata.successResults.forEach(
                                                (k: TCommonRowObj) =>
                                                    successResults.push(
                                                        selectedData.find(
                                                            (
                                                                keyword: Record<
                                                                    string,
                                                                    TCommonRowObj
                                                                >
                                                            ) =>
                                                                keyword.sys_ams_keyword_id ===
                                                                k
                                                        )
                                                    )
                                            );

                                        const keywordsParams = response.metadata
                                            ? successResults
                                            : selectedData;
                                        //* Succesfull changes will be updated in the grid
                                        bulkRequiredConfig.successfulUpdatedRows =
                                            keywordsParams;

                                        if (isModalAction) {
                                            keywordsParams.forEach(
                                                (k: Record<string, any>) => {
                                                    const bidInputElementId = `budget-update-field-${k.sys_ams_keyword_id}`;

                                                    if (
                                                        operationType ===
                                                        ActionType.PERC_INC
                                                    )
                                                        changedValue =
                                                            k.bid +
                                                            (k.bid / 100) *
                                                            bidInput;
                                                    else if (
                                                        operationType ===
                                                        ActionType.PERC_DEC
                                                    )
                                                        changedValue =
                                                            k.bid -
                                                            (k.bid / 100) *
                                                            bidInput;
                                                    else if (
                                                        operationType ===
                                                        ActionType.ABSOLUTE
                                                    )
                                                        changedValue = bidInput;

                                                    changedValue =
                                                        changedValue <
                                                            k.min_bid_value
                                                            ? k.min_bid_value
                                                            : changedValue >
                                                                k.max_bid_value
                                                                ? k.max_bid_value
                                                                : changedValue;

                                                    $(
                                                        `#${bidInputElementId}`
                                                    ).val(
                                                        round(changedValue, 2)
                                                    );
                                                }
                                            );
                                        }
                                        break;
                                    }
                                    case Channels.FLIPKART:
                                    case Channels.BLINKIT:
                                    case Channels.ZEPTO:
                                    case Channels.TAKEALOT:
                                    case Channels.PURPLLE:
                                    case Channels.INSTAMART:
                                    case Channels.MYNTRA:
                                        break;
                                    default:
                                        console.info(
                                            `Channel not found for bulk action.`
                                        );
                                }

                                showToast("success", message);
                                !isModalAction &&
                                    setUpdateGridData(updateGridConfig);
                            } else {
                                const errorMessage = response.isUserRestricted
                                    ? `Operation keywords updation is unsuccessful: ${response.message}`
                                    : `Operation keywords updation is unsuccessful. Please try again later.`;
                                throw new Error(errorMessage);
                            }
                        })
                        .catch((err: any) => {
                            console.error(err);
                            showToast("danger", `${err.message}`);
                            Sentry.captureException(err);
                            hideChangeBid();
                        })
                        .finally(() => {
                            isBulkAction &&
                                setSpinner(
                                    "remove",
                                    spinnerOptions.event,
                                    true
                                );
                            show && setShow(false);
                        });
            } else if (
                operationType === "pause" ||
                operationType === "enable" ||
                operationType === "archive"
            ) {
                data = {
                    keywords: selectedData.map((k: Keyword) => ({
                        keywordId: k.sys_ams_keyword_id.toString(),
                        state: `${operationType}d`,
                        attribute: ["state"],
                    })),
                };
                // add spinner here
                spinnerElement.replaceWith(spinnerHtml);
                updateKeywords(data as TUpdateKeywords)
                    .then((response) => {
                        if (response.status) {
                            bulkRequiredConfig.bulkParamsToChange = [
                                {
                                    key: "state",
                                    newValue: `${operationType}d`,
                                },
                                {
                                    key: "serving_status",
                                    newValue: `${operationType}d`,
                                },
                            ];
                            setUpdateGridData(updateGridConfig);
                            showToast(
                                "success",
                                `Status of ${selectedData.length} ${type} changed successfully to ${operationType}d`
                            );
                        } else {
                            showToast(
                                "danger",
                                response.isUserRestricted
                                    ? `Operation keywords updation is unsuccessful: ${response.message}`
                                    : `Operation keywords updation is unsuccessful. Please try again later.`
                            );
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        Sentry.captureException(err);
                        showToast(
                            "danger",
                            `Operation keywords updation is unsuccessful. Please try again later.: ${err.message}`
                        );
                    })
                    .finally(() => {
                        isBulkAction &&
                            setSpinner("remove", spinnerOptions.event, true);
                        //remove spinner
                        $("#bulkActionSpinner").replaceWith(spinnerElement);
                        $("#pa-bulk-action-drop-down").css({ display: "none" });
                    });
            } else {
                //markNegative

                spinnerElement.replaceWith(spinnerHtml);

                data = {
                    keywords: selectedData.map((k: Keyword) => ({
                        state: StateTypeValues.ENABLED,
                        matchType: MatchType.NEGATIVE_EXACT,
                        adGroupId: k.ad_group_id,
                        campaignId: k.campaign_id,
                        programType: k.program_type,
                        keywordText: k.keyword_name,
                        attribute: ["create_negative_target"],
                    })),
                };

                createNegativeKeywords(data as TCreateNegativeKeyword)
                    .then((response) => {
                        const message = response.metadata
                            ? `${response.metadata.keywordsAndTargets.success}/${response.metadata.keywordsAndTargets.total} negative keywords and targets are successfully created.`
                            : response.message;
                        if (response.status) {
                            showToast("success", message);
                        } else {
                            showToast(
                                "danger",
                                response.isUserRestricted
                                    ? `Negative Keywords creation failed: ${message}`
                                    : `Negative Keywords creation failed.`
                            );
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        Sentry.captureException(err);
                        showToast(
                            "danger",
                            `Negative Keywords creation failed: ${(err as Error).message
                            }`
                        );
                    })
                    .finally(() => {
                        isBulkAction &&
                            setSpinner("remove", spinnerOptions.event, true);
                        //remove spinner
                        $("#bulkActionSpinner").replaceWith(spinnerElement);
                        $("#pa-bulk-action-drop-down").css({ display: "none" });
                    });
            }

            break;
        case "product-analytics":
            productAdsArr = selectedData
                .map((p: Record<string, any>) => p.ad_id.split(","))
                .flat()
                .filter((productAd: string) => productAd !== "");

            if (productAdsArr.length) {
                productAdsArr.forEach((k: string[]) => {
                    productsData.push({
                        productads: k,
                        state: operationType,
                        attribute: ["state"],
                    });
                });

                // add spinner here
                spinnerElement.replaceWith(spinnerHtml);

                updateProductAds(productsData)
                    .then((response) => {
                        if (response.status) {
                            selectedData.forEach((product: Keyword) => {
                                const statusInputId = `productad-status-btn-${product.ad_id}`;
                                $(`#${statusInputId}`).prop(
                                    "checked",
                                    operationType === StateTypeValues.ENABLED
                                );
                            });
                            showToast("success", response.message);
                        } else {
                            showToast(
                                "danger",
                                response.isUserRestricted
                                    ? `Operation Product status updation is unsuccessful: ${response.message}`
                                    : `Operation Product status updation is unsuccessful. Please try again later.`
                            );
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        Sentry.captureException(err);
                        showToast(
                            "danger",
                            `Operation Product status updation is unsuccessful. Please try again later.: ${err.message}`
                        );
                    })
                    .finally(() => {
                        isBulkAction &&
                            setSpinner("remove", spinnerOptions.event, true);
                        //remove spinner
                        $("#bulkActionSpinner").replaceWith(spinnerElement);
                        $("#pa-bulk-action-drop-down").css({ display: "none" });
                    });
            } else {
                showToast("danger", "No product ads available to update");
            }

            break;
        case "products":
            productAdsArr = selectedData
                .map((p: Record<string, any>) => p.ad_id.split(","))
                .flat()
                .filter((productAd: string) => productAd !== "");

            if (productAdsArr.length) {
                productAdsArr.forEach((k: string[]) => {
                    productsData.push({
                        productads: k,
                        state: operationType,
                        attribute: ["state"],
                    });
                });

                // add spinner here
                spinnerElement.replaceWith(spinnerHtml);

                updateProductAds(productsData)
                    .then((response) => {
                        if (response.status) {
                            selectedData.forEach((product: Keyword) => {
                                const statusInputId = `products-status-btn-${product.ad_id}`;
                                operationType === StateTypeValues.ENABLED
                                    ? $(`#${statusInputId}`).prop(
                                        "checked",
                                        true
                                    )
                                    : $(`#${statusInputId}`).prop(
                                        "checked",
                                        false
                                    );
                            });
                            showToast("success", response.message);
                        } else {
                            showToast(
                                "danger",
                                response.isUserRestricted
                                    ? `Operation Product status updation is unsuccessful: ${response.message}`
                                    : `Operation Product status updation is unsuccessful. Please try again later.`
                            );
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        Sentry.captureException(err);
                        showToast(
                            "danger",
                            `Operation Product status updation is unsuccessful. Please try again later.: ${err.message}`
                        );
                    })
                    .finally(() => {
                        isBulkAction &&
                            setSpinner("remove", spinnerOptions.event, true);
                        //remove spinner
                        $("#bulkActionSpinner").replaceWith(spinnerElement);
                        $("#pa-bulk-action-drop-down").css({ display: "none" });
                    });
            } else {
                showToast("danger", "No product ads available to update");
            }

            break;
        default:
            console.info(`Module ${type} not found for bulk action.`);
    }
}

export function showChangeBid() {
    showElementById("updateBidDiv");
}

export function hideChangeBid() {
    hideElementById("updateBidDiv");
}

export function onKeywordSelectionChanged(event: GridReadyEvent) {
    const selectedNodes = event.api.getSelectedNodes();
    const { activeModule } = getActiveModule();
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node) => node.data);
        if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
            store.dispatch(updateKeywordsSelectionData(selectedData));
            showElementById("keywords-bulk-operations-div");
        } else {
            store.dispatch(updateOverviewKeywordsSelectionData(selectedData));
        }
    } else {
        if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
            store.dispatch(updateKeywordsSelectionData([]));
            hideElementById("keywords-bulk-operations-div");
        } else {
            store.dispatch(updateOverviewKeywordsSelectionData([]));
        }
    }
}

export function onProductAdGroupsSelectionChanged(event: GridReadyEvent) {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node) => ({
            ad_id: node.data.ad_id,
        }));
        store.dispatch(updateProductAdgroupsSelectionData(selectedData));
        showElementById("bulk-operations-pa");
    } else {
        store.dispatch(updateProductAdgroupsSelectionData([]));
        hideElementById("bulk-operations-pa");
    }
}

export const onSearchTermCampaignSelectionChanged = (event: GridReadyEvent) => {
    const selectedNodes = map(
        event.api.getSelectedNodes(),
        (node) => node.data
    );

    if (selectedNodes.length) {
        store.dispatch(setAddAsExactData(selectedNodes));
    } else {
        store.dispatch(setAddAsExactData([]));
    }
};

export function onProductSelectionChanged({ api }: { api: GridApi }) {
    const selectedNodes: RowNode[] = api
        .getSelectedNodes()
        .filter((node) => node.displayed);
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node) => ({
            asin: node.data.asin,
            sku_title: node.data.sku_title,
            ad_id: node.data.ad_id,
            isEligible: node.data.overall_status || "INELIGIBLE",
            sku: node.data.sku,
            isFocusedAsin: node.data.isFocusedAsin,
        }));
        store.dispatch(updateProductsSelectionData(selectedData));
    } else {
        store.dispatch(updateProductsSelectionData([]));
    }
}

export const createCampaigns = async (campaigns: TCommonRowData) => {
    try {
        const data = {
            campaigns,
        };
        const response = await sendRequest({
            data,
            method: "post",
            type: "campaigns",
        });
        if (response) {
            return response;
        }
        return [];
    } catch (error) {
        console.error(error);
    }
};

export function inverse(obj: Record<string, string>) {
    const retobj: Record<string, string> = {};
    for (const key in obj) {
        retobj[obj[key]] = key;
    }
    return retobj;
}

export function onTargetProductsSelectionChanged(
    event: GridReadyEvent,
    setTargetSelectedNode: Dispatch<SetStateAction<RowNode[]>>
) {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length) {
        setTargetSelectedNode(selectedNodes);
        showElementById("bulk-operations-div");
        hideElementById("updateBidDiv");
        (
            document.getElementById("createCampaign") as HTMLButtonElement
        ).disabled = false;

        $("#createCampaign").css({
            opacity: "1",
            pointerEvents: "",
        });
    } else {
        $("#createCampaign").css({
            opacity: "0.7",
            pointerEvents: "none",
        });
        hideElementById("bulk-operations-div");
    }
}

export function onSelectionChangedKeywordRecommendations(
    event: GridReadyEvent
) {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes.length) {
        showElementById("add-to-adgroup-button");
    } else {
        hideElementById("add-to-adgroup-button");
    }
}

export const agFilterModified = (event: Record<string, any>) => {
    const colName = event.column.colDef.field;
    if (!event.filterInstance.context._cachedDOMElement)
        event.filterInstance.context._cachedDOMElement = {};
    if (!event.filterInstance.context._cachedDOMElement[colName]) {
        const gui = event.filterInstance.getFocusableElement();
        event.filterInstance.context._cachedDOMElement[colName] = {
            gui,
            applyButton: $(gui)
                .find(
                    ".ag-standard-button.ag-filter-apply-panel-button[ref=applyFilterButton]"
                )
                .get()
                .shift(),
            resetButton: $(gui)
                .find(
                    ".ag-standard-button.ag-filter-apply-panel-button[ref=resetFilterButton]"
                )
                .get()
                .shift(),
        };
    }
    const { gui, applyButton, resetButton } =
        event.filterInstance.context._cachedDOMElement[colName];
    try {
        gui.onkeydown = (ev: Record<string, string>) => {
            if (ev.code === "Enter") applyButton.click();
            else if (ev.code === "Escape") resetButton.click();
        };
        resetButton.onclick = () => {
            gui.onkeydown = null;
            const collapseFilter = $(gui)
                .closest(".ag-filter-toolpanel-group-level-0")
                .find("[ref=eTitle]")
                .get()
                .shift();
            collapseFilter.click();
        };
    } catch (e) {
        delete event.filterInstance.context._cachedDOMElement[colName];
        console.error("Error is occuring in onFilterModified Listener", e);
    }
};

export function formatCronString(cronString: string): string {
    if (!cronString) return "";
    try {
        return cronstrue.toString(cronString);
    } catch (error) {
        console.error("Invalid cron string:", error);
        return cronString;
    }
}

export function handleCronInput(reset: boolean) {
    const inputel: HTMLInputElement = document.querySelector(
        "input.cron#cron_string"
    );
    if (!inputel.value.length)
        return $(inputel).removeClass("is-valid is-invalid");
    try {
        if (!isValidCron(inputel.value, { seconds: false, alias: true })) {
            throw new Error("Invalid cron expression");
        }
        const humanized = formatCronString(inputel.value);
        $(inputel.parentElement.parentElement)
            .find(".valid-feedback")
            .text(humanized);
        $(inputel).addClass("is-valid").removeClass("is-invalid");
        store.dispatch(setIsRuleSaveButtonDisabled(false));
    } catch (error) {
        store.dispatch(setIsRuleSaveButtonDisabled(true));
        $(inputel.parentElement.parentElement)
            .find(".invalid-feedback")
            .text(error as string);
        $(inputel).addClass("is-invalid").removeClass("is-valid");
    }

    if (reset) {
        $("#frequency-value").val(null);
        (
            document.querySelector("#frequency-units") as HTMLSelectElement
        ).selectedIndex = 0;
        $(".frequency").attr("disabled");
    }
}
export function generateCron() {
    const freq = $("#frequency-value").val() as number;
    const unit = $("#frequency-units").val() as string;
    let cron = "";
    if (!(freq && unit)) return;
    switch (unit) {
        case "day":
            cron = `0 0 */${freq} * *`;
            break;
        case "month":
            cron = `0 0 * */${freq} *`;
            break;
        case "week":
            cron = `0 0 */${freq * 7} * *`;
            break;
        case "year":
            cron = `0 0 * */${freq * 12} *`;
            break;
    }

    $("#cron_string").val(cron);
    handleCronInput(false);
}

export async function getRuleByFilter(ruleFilter: IFilters) {
    try {
        const response = await sendRequest({
            type: `rules/search`,
            data: { filter: ruleFilter },
            method: "post",
        });
        if (!response.status) {
            throw new Error(`Rules: ${response.message}`);
        }
        return response;
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
        Sentry.captureException(err);
    }
}

export const populateRules = async () => {
    try {
        const response = await sendRequest({
            type: "rules",
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }
        return response.rows;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        throw new Error((err as Error).message);
    }
};

export function showCountOfDisplayedData(api: GridApi) {
    const activeTab = getActiveModule().activeModule;
    const count: number = api.getDisplayedRowCount();
    switch (activeTab) {
        case SubModule.PORTFOLIO:
            setPillBadges("portfolios-badge", count);
            break;
        case SubModule.CAMPAIGN:
            setPillBadges("campaigns-badge", count);
            break;
        case SubModule.ADGROUP:
            setPillBadges("adgroups-badge", count);
            break;
        case SubModule.KEYWORD:
            setPillBadges("keywords-badge", count);
            break;
        case SubModule.PLACEMENTS:
            setPillBadges("placements-badge", count);
            break;
        case SubModule.PRODUCT:
            setPillBadges("products-badge", count);
            break;
        case SubModule.SUGGESTED_NEG_KWS:
            setPillBadges("suggested-badge", count);
            break;
        case SubModule.EXISTING_NEG_KWS:
            setPillBadges("existing-badge", count);
            break;
        case SubModule.KEYWORD_MANUAL:
            setPillBadges("manual-badge", count);
            break;
        case SubModule.KEYWORD_REVINITI:
            setPillBadges("reviniti-badge", count);
            break;
        case SubModule.CAMPAIGN_BUDGET:
            setPillBadges("budget-badge", count);
            break;
        case SubModule.CAMPAIGN_PLACEMENT:
            setPillBadges("placement-badge", count);
            break;
    }
}

// Here, identifying the removed filter, if any, and removing it from the activeFiltersList to render the pill properly
export function onFilterChanged({ api }: TApi) {
    // to check if filters are being applied on rule redirection
    const tabRedirectionFilter = JSON.parse(
        sessionStorage.getItem("tabRedirection")
    );
    const filterModel = api.getFilterModel();
    // custom filtes like tags are not being retrieved from the model directly, so explicitly setting it.
    const customFilterModel =
        tabRedirectionFilter && Object.keys(tabRedirectionFilter).length
            ? {
                ...filterModel,
                ...tabRedirectionFilter.filter,
            }
            : filterModel;
    const appliedFilters = JSON.parse(sessionStorage.getItem("activeFilters"));
    const activeFilters = { ...appliedFilters, ...filterModel };
    const initialFilters = setInitialFilters();
    const filtersToReset = appliedFilters
        ? filter(
            Object.keys(appliedFilters),
            (filterKey) =>
                filterKey !== "report_date" &&
                !(filterKey in customFilterModel) &&
                !(!!initialFilters && filterKey in initialFilters)
        )
        : [];

    forEach(
        filtersToReset,
        (filterToReset: string) => delete activeFilters[filterToReset]
    );
    sessionStorage.setItem("activeFilters", JSON.stringify(activeFilters));
    sessionStorage.removeItem("tabRedirection");
    setFilters(api);
    onModelUpdated({ api });
    showCountOfDisplayedData(api);

    // Following logic applies only for modules with tag type column
    const { activeModule } = getActiveModule();
    if (Object.keys(TAGS_MODULE_MAPPING).includes(activeModule)) {
        const tagsFilterComponent: any = api.getFilterInstance(
            TAGS_MODULE_MAPPING[activeModule as keyof TagsMap].colName
        );
        const tagTypeFilterValues: any = filterModel.tag_types?.values;

        // Only update tag filter values if tag_types filter has changed
        if (tagTypeFilterValues && tagsFilterComponent) {
            const clientTagsList = store.getState().clientTagsList.value;
            const tagsByType = getTagsByType(
                clientTagsList,
                tagTypeFilterValues
            );

            // Compare current and new values before updating
            const currentValues = tagsFilterComponent.getFilterValues();
            if (JSON.stringify(currentValues) !== JSON.stringify(tagsByType)) {
                tagsFilterComponent.setFilterValues(tagsByType);
            }
        }
    }
}

export function onModelUpdated({ api }: TApi) {
    /**
     * !NOTE:
     * This function will be called when there is any change in the filters
     * Initially this fn was called directly in ag-grid react component in attr. named onModelUpdated
     * but with any change in the grid api this fn used to run which is a costly process
     * so, now we are calling it wherever required
     *
     *change-log is skipped as it uses SSRM hence filters are manged on server side
     */
    if (getActiveModule().activeModule === ParentModule.CHANGE_LOG) {
        return;
    }
    setFilters(api);
    const data = (api as any).filterManager.rowModel.rowsToDisplay?.map(
        (row: RowNode) => row.data
    );
    data?.length && populateTotalRow({ api, data });
}

export function onRowDataChanged({ api }: TApi) {
    api.setPinnedTopRowData([]);
}

const countryCurrency: Record<string, string> = { IN: "₹", US: "$" };

export function formatCurrency(currency: number, sign: string, precision = 0) {
    if (currency === undefined) return;
    sign = sign in countryCurrency ? countryCurrency[sign] : sign;
    const formatted =
        currency &&
        currency.toFixed(precision).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return sign + `${formatted}`;
}

export const updateCampaigns = async (campaigns: TUpdateCampaigns) => {
    const data = {
        campaigns,
    };

    return await sendRequest({
        type: `campaigns`,
        data,
        method: "put",
    });
};

export const updateRequiredDailyBudget = async (campaigns: {
    campaignId: string;
    dailyBudget: number;
}) => {
    const data = {
        campaigns,
    };

    return await sendRequest({
        type: `campaigns/daily-budget`,
        data,
        method: "put",
    });
};

export const underScoreCaseToCamelCase = (value: string) => {
    if (value) {
        const values = value.split("_");
        const firstElement = values.shift();
        return `${firstElement}${values.map((v) => titleCase(v)).join("")}`;
    }
};

export const filterTrendsData = (type: string, key: string) => {
    const trendType = `${type}Trend`;
    const data = JSON.parse(sessionStorage.getItem(trendType));
    return data
        .filter((item: Record<string, string>) => item.report_date)
        .map((item: Record<string, string>) => ({
            x: +item.report_date,
            y: parseFloat(item[key]),
            cpc: item["cpc"],
        }));
};

export const getTrendsData = async (id: TGetTrendsData, type: string) => {
    try {
        // sessionStorage.setItem("trendType", type);
        const { startDate, endDate } = getSelectedDateRange();
        const response = await sendRequest({
            type: `${type}/trend`,
            data: {
                startDate: startDate.format("YYYY-MM-DD"),
                endDate: endDate.format("YYYY-MM-DD"),
                ...id,
            },
            method: "post",
        });
        if (!response.status) {
            throw new Error(response.message);
        }
        return response.rows;
    } catch (err) {
        console.error(err);
        showToast("danger", `Internal Server Error`);
    }
};

export function updateWithInputApplyEventHandler(element: HTMLInputElement) {
    return element.value;
}

export function updateWithInputCancelEventHandler(element: string) {
    $(element)
        .parent()
        .find("input")
        .val($(element).attr("data-original-value"));
    // enableOtherThanIndexRows(identifier);
}

export async function bidUpdateApplyEventHandler(
    inputValue: number,
    dataId: string,
    otherAttributes: TOtherAttr,
    additionalParams?: AdditionalBidParams
) {
    const channel = store.getState().channel.value;
    const { activeModule } = getActiveModule();
    const changedKeyword = dataId;
    const {
        costType,
        baseProgramType,
        campaignBudget,
        maxBidValue,
        recordType,
    } = otherAttributes;

    let MAX_ALLOWABLE_BID = maxBidValue;
    switch (channel) {
        case Channels.AMAZON: {
            const changedValue = +inputValue;
            const programType =
                costType === "vcpm" ? "SD-VCPM" : baseProgramType;

            if (
                programType.toUpperCase() === "SD" ||
                programType.toUpperCase() === "SD-VCPM"
            ) {
                MAX_ALLOWABLE_BID = Math.min(
                    campaignBudget / 2,
                    MAX_ALLOWABLE_BID
                );
            } else if (
                programType.toUpperCase() === "SP" ||
                programType.toUpperCase() === "SB"
            ) {
                MAX_ALLOWABLE_BID = Math.min(campaignBudget, MAX_ALLOWABLE_BID);
            }

            if (changedValue > MAX_ALLOWABLE_BID) {
                return {
                    status: false,
                    message: `Cannot set bid value greater than ${MAX_ALLOWABLE_BID}`,
                };
            } else {
                const data = {
                    keywords: [
                        {
                            keywordId: changedKeyword.toString(),
                            changeType: ActionType.ABSOLUTE,
                            changeValue: changedValue,
                            attribute: ["bid"],
                            campaignBudget: campaignBudget,
                        },
                    ],
                };

                const success = await updateKeywords(data);
                return success;
            }
        }
        case Channels.FLIPKART:
        case Channels.BLINKIT:
        case Channels.ZEPTO:
        case Channels.TAKEALOT:
        case Channels.PURPLLE:
        case Channels.INSTAMART:
        case Channels.MYNTRA:
        case Channels.NOON:
        case Channels.NOON_MINUTES:
        case Channels.TALABAT:
        case Channels.WALMART: {
            const changedValue = +inputValue;
            if (
                MAX_ALLOWABLE_BID &&
                (channel === Channels.FLIPKART ||
                    (channel === Channels.BLINKIT &&
                        recordType === RecordType.TARGET)) &&
                changedValue > MAX_ALLOWABLE_BID
            ) {
                return {
                    status: false,
                    message: `Cannot set bid value greater than ${MAX_ALLOWABLE_BID}`,
                };
            }

            const data = {
                keywords: [
                    {
                        ...(activeModule === SubModule.KEYWORD
                            ? { keywordId: changedKeyword.toString() }
                            : { placementId: changedKeyword.toString() }),
                        changeType: ActionType.ABSOLUTE,
                        changeValue: changedValue,
                        attribute: [
                            activeModule === SubModule.KEYWORD
                                ? "bid"
                                : "placement",
                        ],
                        ...additionalParams,
                    },
                ],
            };

            const success =
                activeModule === SubModule.KEYWORD
                    ? await updateKeywords(data)
                    : await updatePlacements(data);
            return success;
        }
        default:
            return false;
    }
}

export function bidUpdateChangeHandler(dataId: string) {
    disableOtherThanIndexRows(dataId);
}

export function enableOtherThanIndexRows(index: string) {
    $(`div[id^="BidUpdateBtn-"]:not("#BidUpdateBtn-${index}")`)
        .find("button")
        .attr("disabled", "false");
}

function disableOtherThanIndexRows(index: string) {
    $(`div[id^="BidUpdateBtn-"]:not("#BidUpdateBtn-${index}")`)
        .find("button")
        .attr("disabled", "true");
}

export const updateKeywords = async (data: TUpdateKeywords) => {
    return await sendRequest({
        type: `keywords`,
        data,
        method: "put",
    });
};

export const updatePlacements = async (data: TUpdateKeywords) => {
    return await sendRequest({
        type: `placements`,
        data,
        method: "put",
    });
};

export const validateCreateKeywords = async (
    data: Record<string, TCommonRowObj[]>
) => {
    return await sendRequest({
        type: `keywords/validate`,
        data,
        method: "post",
    });
};

export const updateProductAds = async (productads: TUpdateProductAds) => {
    return await sendRequest({
        type: `products`,
        data: {
            productads,
        },
        method: "put",
    });
};

export const updateNegativeKeywords = async (
    keywords: TUpdateNegativeKeywords
) => {
    return await sendRequest({
        type: `keywords/negative`,
        data: {
            keywords,
        },
        method: "put",
    });
};

export const updatePortfolios = async (
    portfolios: Array<TUpdatePortfolios>
) => {
    return await sendRequest({
        type: `portfolios`,
        data: {
            portfolios,
        },
        method: "put",
    });
};

export const updateAdGroups = async (adgroups: Array<TUpdateAdgroups>) => {
    return await sendRequest({
        type: `adgroups`,
        data: {
            adgroups,
        },
        method: "put",
    });
};

export async function toggleStatusBtn(
    rowIdentifer: string | number,
    context: string,
    newState: string,
    isDprActive = false
) {
    const elementId = `#${context}-status-btn-${rowIdentifer}`;

    switch (context) {
        case "portfolio":
            return updatePortfolios([
                {
                    portfolioId: rowIdentifer.toString(),
                    attribute: ["state"],
                    state: newState,
                },
            ]);

        case "ad-group":
            return updateAdGroups([
                {
                    adgroupId: rowIdentifer.toString(),
                    attribute: ["state"],
                    state: newState,
                },
            ]);

        case "campaign":
            return updateCampaigns([
                {
                    campaignId: rowIdentifer.toString(),
                    attribute: ["state"],
                    state: newState,
                    isDprActive,
                },
            ]);

        case "keyword":
            return updateKeywords({
                keywords: [
                    {
                        keywordId: rowIdentifer.toString(),
                        attribute: ["state"],
                        state: newState,
                    },
                ],
            });

        case "productad":
        case "products":
            return updateProductAds([
                {
                    productads: $(elementId).data("id").toString(),
                    state: newState,
                    attribute: ["state"],
                },
            ]);

        case "automate_bid":
            return {
                status: true,
            };

        default:
            console.error(`Unknown ${context} context`);
    }
}

export const createKeywords = async (data: Record<string, TCommonRowObj[]>) => {
    return await sendRequest({
        type: `keywords`,
        data,
        method: "post",
    });
};

export function numericValueFormatter(params: ValueFormatterParams) {
    if (
        params.colDef.cellRendererParams &&
        !params.colDef.cellRendererParams.hasPinnedColumnValue &&
        params.node.rowPinned
    ) {
        return;
    }
    const numberOfDecimalPoints =
        typeof params.colDef.cellRendererParams.decimalPlace == "number"
            ? params.colDef.cellRendererParams.decimalPlace
            : DEFAULT_DECIMAL_PLACE;
    const val =
        +params.value !== null && isFinite(+params.value)
            ? `${params.colDef.cellRendererParams.hasPercent
                ? +(+params.value || 0).toFixed(numberOfDecimalPoints)
                : internationalizeNumericValue(
                    +(+params.value || 0).toFixed(numberOfDecimalPoints)
                )
            }${params.colDef.cellRendererParams.hasPercent ? "%" : ""}`
            : params.value !== null &&
                !isNaN(params.value) &&
                !params.colDef.cellRendererParams?.hideInfinite
                ? "∞"
                : params.colDef.cellRendererParams.suppressNullValueText || "";

    return val;
}

export const agBtnExport = (api: GridApi, isPoExport = false, module = "") => {
    const state = store.getState();
    const title = state.title.value;
    let activeTab = "";
    if (
        title === titleCase(ParentModule.PERFORMANCE_OVERVIEW) ||
        title === titleCase(SubModule.KEYWORD) ||
        title === titleCase(SubModule.CAMPAIGN)
    ) {
        activeTab = isPoExport ? module : state.activeTab.value;
    } else {
        switch (title) {
            case "Search Term Analytics":
                activeTab = "keyword-analytics";
                break;
            case "Product Analytics":
                activeTab = "product-analytics";
                break;
            case "Negative Keywords":
                activeTab = `${getActiveModule().activeModule
                    }-Negative-Keywords`;
                break;
        }
    }
    const clientName = (
        document.getElementsByClassName("client-info") as HTMLSelectElement
    )[0].innerText
        .split(" ")
        .join("-")
        .replace(/[().]/g, "");

    const { startDate, endDate } = getSelectedDateRange();

    const fileName = `Reviniti-${clientName}-${titleCase(activeTab)}${!isPoExport
            ? `-${moment(startDate).format("DD-MM-YYYY")}-to-${moment(
                endDate
            ).format("DD-MM-YYYY")}`
            : ""
        }-${generateRandomString(8)}.xlsx`;

    const params: ExcelExportParams = {
        fileName,
        sheetName: `${titleCase(activeTab)}`,
        suppressTextAsCDATA: false,
        headerRowHeight: 35,
        rowHeight: 28,
        processCellCallback: (cbParams) => {
            const colId = cbParams.column.getColId();
            const rowData = cbParams.api.getDisplayedRowAtIndex(
                cbParams.node.rowIndex
            )?.data;
            const isTotalRow = cbParams.node.rowPinned === "top";
            switch (colId) {
                case TagColFields.TAG_TYPES:
                    if (isTotalRow) {
                        return "";
                    }
                    const tagColField =
                        TAGS_MODULE_MAPPING[
                            activeTab as keyof typeof TAGS_MODULE_MAPPING
                        ].colName;
                    const tagsData = rowData?.[tagColField];
                    if (Array.isArray(tagsData)) {
                        const tagTypes = [
                            ...new Set(
                                tagsData
                                    .map((tag: any) => tag.tag_type)
                                    .filter(Boolean)
                            ),
                        ];
                        return tagTypes.join(", ");
                    }
                    return "";

                case TagColFields.CAMPAIGN_TAGS:
                case TagColFields.PRODUCT_TAGS:
                    if (Array.isArray(cbParams.value)) {
                        return cbParams.value
                            .map((tag: any) => tag.tag_name || tag)
                            .filter(Boolean)
                            .join(", ");
                    }
                    return cbParams.value;

                default:
                    return cbParams.value;
            }
        },
    };

    if (api) {
        api.exportDataAsExcel(params);
        setTimeout(
            () =>
                showToast("success", `${fileName} exported from ${activeTab}`),
            200
        );
    } else showToast("danger", `unexpected issue during exporting of data`);
};

export const resetPerformanceOverview = (api: GridApi) => {
    store.dispatch(updateMainGridFilters({}));
    store.dispatch(updateAdgroupFilters({}));
    store.dispatch(updateCampaignFilters({}));
    store.dispatch(updateKeywordFilters({}));
    store.dispatch(updateProductFilters({}));
    store.dispatch(updateKeywordFilters({}));
    store.dispatch(updatePlacementFilters({}));
    store.dispatch(updatePoCheckedNode([]));
    store.dispatch(updatePdCheckedNode([]));
    store.dispatch(updateAdCheckedNode([]));
    store.dispatch(updateCaCheckedNode([]));
    store.dispatch(updatePoGridFilters({}));
    store.dispatch(updatePdGridFilters({}));
    store.dispatch(updateCaGridFilters({}));
    store.dispatch(updateAdGridFilters({}));

    type TBadgeData = {
        keywordsData: ICommonRowDataRedux;
        productsData: ICommonRowDataRedux;
        campaignsData: ICommonRowDataRedux;
        adgroupsData: ICommonRowDataRedux;
        placementsData: ICommonRowDataRedux;
    };

    const {
        keywordsData,
        productsData,
        campaignsData,
        adgroupsData,
        placementsData,
    }: TBadgeData = store.getState();
    setPillBadges("campaigns-badge", campaignsData.value.length);
    setPillBadges("adgroups-badge", adgroupsData.value.length);
    setPillBadges("keywords-badge", keywordsData.value.length);
    setPillBadges("placements-badge", placementsData.value.length);
    setPillBadges("products-badge", productsData.value.length);
    onClickClearFiltersHandler(api);
    api.deselectAll();
    api.setFilterModel(null);
};

export const resetCurrentModule = (api: GridApi) => {
    onClickClearFiltersHandler(api);
};

export const getCampaignTarget = async (
    campaignCreationObject: TCampaignTargetObject,
    setTargetsRowData: React.Dispatch<React.SetStateAction<TSelectedTargets[]>>
) => {
    try {
        const response = await sendRequest({
            type: `campaigns/targets`,
            data: {
                ...campaignCreationObject,
            },
            method: "post",
        });
        if (!response.status) {
            throw new Error("Campaign Targets: Internal Server Error");
        }
        const data = response.campaignTargets.map(
            (target: TSelectedTargets) => ({
                ...target,
                suggest_bid: target.suggest_bid || getDefaultBid(),
            })
        );
        setTargetsRowData(data);
    } catch (error) {
        console.error(error);
        showToast("danger", (error as Error).message);
    }
};

export const getDefaultBid = () => {
    const channel = store.getState().channel.value;
    const channelName = CHANNEL_CONFIGS[channel].name;
    return moduleConfigs[channelName as ChannelName].options.recommendedBid;
};

export const gridH = () => {
    const nH = $(".main-header").outerHeight();
    const fH = $("#footer").outerHeight();
    const tabH = $("#myTab").outerHeight();
    const dH = $(window).height();
    const wH = dH - (nH + fH + tabH + fH);
    const { activeModule } = getActiveModule();
    if (
        activeModule === SubModule.PORTFOLIO ||
        activeModule === SubModule.CAMPAIGN ||
        activeModule === SubModule.ADGROUP ||
        activeModule === SubModule.KEYWORD ||
        activeModule === SubModule.PRODUCT
        // activeModule === "keyword" ||
        // activeModule === "campaign"
    ) {
        $(".wrapper").css("height", wH - 15);
    } else {
        $(".wrapper").css("height", wH);
    }
};

export function updateRow({
    id,
    data,
    grid,
    forceColumns = [],
    force = true,
}: TUpdateRow) {
    const newId = $(`div:contains(${id})`);
    const Id = newId[10].getAttribute("row-id");
    const row = grid.api.getRowNode(Id);
    const changedCols = Object.entries(data)
        .filter(([key, val]) => {
            return val !== row.data[key];
        })
        .map(([key]) => key);
    row.setData({ ...row.data, ...data });
    grid.api.refreshCells({ force });
    grid.api.flashCells({
        rowNodes: [row],
        columns: changedCols.concat(forceColumns),
    });
    // sortByStatusAndColumn(grid);
}

export const activeTabsFn = (activeTab: string) => {
    $(".react-tabs__tab")
        .removeClass("react-tabs__tab--selected")
        .addClass("react-tabs__tab--disabled");
    $(`#${activeTab}-tab`)
        .removeClass("react-tabs__tab--disabled")
        .addClass("react-tabs__tab--selected");
};

export const createKeywordsRequest = async (
    keywordData: Array<TNegativeKw>,
    targetsData: Array<TNegativeKw>
) => {
    try {
        const response = await createKeywords({
            ...(keywordData.length && {
                keywords: keywordData.filter((keyword) => keyword.bid !== 0),
            }),
            ...(targetsData.length && {
                targets: targetsData.filter((target) => target.bid !== 0),
            }),
        });

        //TODO not getting msg from backend
        if (!response.status) {
            throw new Error(
                `Operation keyword creation failed. ${response.message}`
            );
        }

        const message = response.metadata
            ? `${response.metadata.keywords.success}/${response.metadata.keywords.total} keywords and ${response.metadata.targets.success}/${response.metadata.targets.total} targets are successfully created`
            : response.message;
        showToast("success", message);
    } catch (err: any) {
        console.error(err);
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export async function addSearchTermsToAdgroup(
    gridApi: GridApi,
    activeTab: string,
    customBid?: string
) {
    const selectedData = [Nature.MANUAL, Nature.AUTO].includes(
        activeTab as Nature
    )
        ? gridApi
            .getSelectedNodes()
            .map((node) => node.data)
            .map(
                ({
                    search_term,
                    campaign_id,
                    bid,
                    program_type,
                    ad_group_id,
                    target,
                }) => ({
                    keywordText: search_term,
                    campaignId: campaign_id,
                    programType: program_type,
                    bid: customBid ? +customBid : +bid,
                    adGroupId: ad_group_id,
                    adGroupType: !isTarget(target) ? "keyword" : "target",
                    state: StateTypeValues.ENABLED,
                    attribute: ["create_target"],
                })
            )
        : gridApi
            .getSelectedNodes()
            .map((node) => node.data)
            .map(
                ({
                    search_term,
                    campaign_id,
                    bid,
                    program_type,
                    ad_group_id,
                    asin,
                    target,
                }) => ({
                    keywordText: !isTarget(target) ? search_term : asin,
                    campaignId: campaign_id,
                    programType: program_type,
                    bid: customBid
                        ? +customBid
                        : bid
                            ? +bid
                            : getDefaultBid(),
                    adGroupId: ad_group_id,
                    adGroupType: !isTarget(target) ? "keyword" : "target",
                    state: StateTypeValues.ENABLED,
                    attribute: ["create_target"],
                })
            );

    try {
        // Here we create keywords and targets
        const keywords = selectedData
            .filter((i) => i.adGroupType === "keyword")
            .map((i) => {
                delete i["adGroupType"];
                return {
                    ...i,
                    matchType: "exact",
                };
            });

        const targets = selectedData
            .filter((i) => i.adGroupType === "target")
            .map((i) => {
                delete i["adGroupType"];
                return {
                    ...i,
                    matchType: "asinSameAs",
                };
            });

        // Here we are checking if the sections have keywords and targets with bid 0
        const doKwdsWithBidZeroExists = keywords.filter(
            (data) => data.bid === 0
        ).length;
        const doTargetsWithBidZeroExists = targets.filter(
            (data) => data.bid === 0
        ).length;

        // This code block shows alerts if theres and selection with bid 0

        if (doKwdsWithBidZeroExists || doTargetsWithBidZeroExists) {
            let message;
            if (
                keywords.length !== doKwdsWithBidZeroExists ||
                targets.length !== doTargetsWithBidZeroExists
            ) {
                message = `Selected search terms have selections with bid value 0. Please, add bid greater than 0 and try again. Or click OK to proceed with other values.`;
                const result = window.confirm(message);
                if (result) {
                    createKeywordsRequest(keywords, targets);
                }
            } else {
                message = `Selected search terms have selections with bid value 0. Please, add bid greater than 0 and try again`;
                window.alert(message);
            }
        } else {
            createKeywordsRequest(keywords, targets);
        }
    } catch (err) {
        showToast("danger", (err as Error).message);
    }
}

export const activeTabHandler = (activeTab: string) => {
    activeTabsFn(activeTab);
    store.dispatch(updateActiveTab(activeTab));
    store.dispatch(updateActiveModule(activeTab));
};

/**
 * * Worker in the createWorkers function is not accepting dynamic path
 * * that's why we have to write the code in this way
 */

export const createWorkers = async (
    workerType: string,
    data:
        | IConfigs
        | TMerge
        | IParams
        | TCommonRowData
        | Array<TBulkKeywords>
        | IUpdatedGridData
        | ITagWorkerPayload
        | TClientTags[]
) => {
    try {
        let worker: Worker;

        switch (workerType) {
            case "aggregate":
                worker = new aggregateWorker();
                break;

            case "request":
                worker = new requestWorker();
                break;

            case "merge":
                worker = new mergeWorker();
                break;

            case "bulkKeywords":
                worker = new bulkKeywordsWorker();
                break;

            case "selectedData":
                worker = new selectedDataWorker();
                break;

            case "updateGridParam":
                worker = new getUpdatedGridData();
                break;

            case "tag":
                worker = new tagWorker();
                break;

            case "table":
                worker = new tableWorker();
                break;

            default:
                throw new Error(`Unknown worker type: ${workerType}`);
        }
        worker.postMessage(data);

        const message = await new Promise((resolve) => {
            worker.onmessage = (e) => {
                return resolve(e.data);
            };
        });

        worker.terminate();
        return message;
    } catch (error) {
        console.error(
            error,
            `Error in worker thread while performing task related to ${workerType}`
        );
        throw false;
    }
};

export const fetchAssets = async (data: TFetchAssets) => {
    try {
        const response = await sendRequest({
            type: `assets/list`,
            method: "POST",
            data,
        });

        if (!response.status) {
            throw new Error("Failed to get assets");
        }
        return response.data;
    } catch (error) {
        console.error(error);
        showToast("danger", (error as Error).message);
    }
};

export const fetchAssetByID = async (id: string) => {
    try {
        const response = await sendRequest({
            type: `assets/${id}`,
            method: "GET",
        });

        if (!response.status) {
            showToast("danger", response.message);
        } else {
            return response.data;
        }
    } catch (e) {
        throw (e as Error).message;
    }
};

export const hash = async (hashConfig: THashConfig) => {
    //@ts-ignore
    const finalHex = CryptoJS.SHA512(JSON.stringify(hashConfig)).toString(
        CryptoJS.enc.Hex
    );
    return finalHex;
};

export const getFileFromHash = async (file_hash: string) => {
    try {
        const response = await sendRequest({
            type: `assets/get-asset`,
            data: {
                file_hash,
            },
            method: "POST",
        });

        if (!response.status) {
            throw new Error("Failed to upload asset");
        }
        return response;
    } catch (e) {
        throw (e as Error).message;
    }
};

export const uploadFiles = async (data: FormData) => {
    const response = await sendRequest(
        {
            type: `assets`,
            method: "POST",
            data: data,
        },
        true,
        false,
        true,
        "multipart/form-data"
    );

    return response.json();
};

export const resetAssetModal = (
    setActivePage: React.Dispatch<React.SetStateAction<number>>
) => {
    $("#asset_upload_div").hide();
    $("#select-asset").hide();
    $("#upload-asset").hide();
    $("#upload-form").trigger("reset");
    $(".selectedProduct").css({ display: "unset" });

    if ($("#firstStep").hasClass("showing")) {
        $("#firstStep").css({ display: "unset" });
        $("#firstStep").removeClass("showing");
        $("#createCampaign").show();
    } else {
        $("#secondStep").css({ display: "unset" });
        $("#secondStep").removeClass("showing");
        $("#publish-campaigns").show();
        $("#back").show();
    }

    // sessionStorage.removeItem("strapiAssetID")
    $("#upload-loader").hide();
    $("#upload-msg").hide();
    const assetCards = document.querySelectorAll(".assetCard");
    assetCards.forEach((assetCard) => {
        assetCard.classList.remove("border", "border-3", "border-primary");
    });
    $("#select-asset").prop("disabled", true);

    setActivePage(1);
};

export const getActiveModule = (): {
    activeSection: string;
    activeModule: SubModule | ParentModule;
    activeParentModule: ParentModule;
    reportIdFromUrl: string;
} => {
    let reportIdFromUrl: string | null = null;
    const currentPath = window.location.pathname;
    const campaignCreationDisplay =
        store.getState().campaignCreationDisplay.value;

    let paths;
    for (const routePattern of routePatterns) {
        const match = matchPath(routePattern, currentPath);
        if (match) {
            reportIdFromUrl = match.params.id;
            paths = compact(
                match.pathnameBase.split(`/${match.params.id}`)[0].split("/")
            );
            break;
        }
    }

    if (!paths) {
        paths = compact(currentPath.split("/"));
    }

    // Special handling for client view URL path
    if (
        paths.length >= 4 &&
        paths[0] === ParentModule.ADMIN_SETTINGS &&
        paths[1] === "settings" &&
        paths[2] === "clients"
    ) {
        return {
            activeSection: ParentModule.ADMIN_SETTINGS,
            activeModule: ParentModule.ADMIN_SETTINGS,
            activeParentModule: ParentModule.ADMIN_SETTINGS,
            reportIdFromUrl: paths[3] || "",
        };
    }

    let [activeSection, activeParentModule, activeModule] = paths.slice(-3) as [
        string,
        ParentModule,
        SubModule | ParentModule
    ];

    // To close BCC module
    if (campaignCreationDisplay && activeModule !== SubModule.CAMPAIGN) {
        store.dispatch(updateCampaignCreationDisplay(false));
    }

    const activeClientId = getClientId();
    const { userData } = store.getState();
    const userDetails = userData.value;

    const userAccess = userDetails?.access?.find((access: IAccess) =>
        access.clients.find(
            (client: IClientAccess) => client.client_id === activeClientId
        )
    );
    const platformAccess = userAccess
        ? userAccess?.platforms.map((item: string) => item.toLowerCase())
        : [];
    const isRevstackAccount =
        platformAccess.length === 1 &&
        platformAccess.includes(Platforms.PLANNING);

    const resolvedActiveModule: SubModule | ParentModule = (() => {
        if (
            [
                ParentModule.SETTINGS,
                ParentModule.INTEGRATIONS,
                ParentModule.CHATBOT,
                ParentModule.ONEDER,
                ParentModule.ADMIN_SETTINGS,
            ].includes(activeSection as ParentModule)
        ) {
            activeParentModule = activeSection as ParentModule;
            activeModule = activeSection as ParentModule | SubModule;
            return activeSection as ParentModule | SubModule;
        }

        activeSection =
            activeSection ||
            (isRevstackAccount ? Platforms.PLANNING : Platforms.ACTIVATION);
        if (
            (!activeParentModule ||
                activeParentModule === ParentModule.PERFORMANCE_OVERVIEW) &&
            !activeModule
        ) {
            return SubModule.OVERVIEW;
        }

        switch (activeParentModule) {
            case ParentModule.NEGATIVE_KEYWORDS:
                return activeModule || SubModule.SUGGESTED_NEG_KWS;
            case ParentModule.KEYWORD_RECOMMENDATIONS:
                return activeModule || SubModule.KEYWORD_MANUAL;
            case ParentModule.CAMPAIGN_RECOMMENDATIONS:
                return activeModule || SubModule.CAMPAIGN_BUDGET;
            default:
                return activeModule || activeParentModule;
        }
    })();

    const result = {
        activeSection: activeSection,
        activeModule: resolvedActiveModule || activeParentModule,
        activeParentModule:
            activeParentModule || ParentModule.PERFORMANCE_OVERVIEW,
        reportIdFromUrl,
    };

    return result;
};

export const resetPillBadges = () => {
    let pillsArray = [];

    switch (getActiveModule().activeModule) {
        case SubModule.CAMPAIGN:
            pillsArray = ["budget", "placement"];
            break;
        case SubModule.KEYWORD:
            pillsArray = ["kwmanual", "reviniti"];
            break;
        case SubModule.SUGGESTED_NEG_KWS:
            pillsArray = ["existing", "suggested"];
            break;
        default:
            pillsArray = [
                "portfolios",
                "campaigns",
                "adgroups",
                "keywords",
                "products",
            ];
    }

    pillsArray.forEach((id) =>
        $(`#${id}-badge`).html(`<i class="spinner-grow spinner-grow-sm" />`)
    );
};

export const setPillBadges = (id: string, data: number) => {
    $(`#${id}`).html(
        `<span class="mx-1 rounded-pill badge bg-dark">${data}</span>`
    );
};

const round = (value: number, numDecimalPoints = 2) => {
    const divisor = Math.pow(10, numDecimalPoints);
    return Math.round((value + Number.EPSILON) * divisor) / divisor;
};

export const setSpinner = (
    operation: string,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    isBulkActionBtn = false
) => {
    const componentId = (event.target as HTMLButtonElement).id;
    switch (operation) {
        case "add": {
            const inputGroupElement = document.createElement("span");
            const spinnerIconElement = document.createElement("i");
            spinnerIconElement.className = "spinner-border";
            spinnerIconElement.style.cssText = "width:1em;height:1em";

            if (isBulkActionBtn) {
                // This block runs for simple buttons performing bulk operations
                const btnName = $(`#${componentId}`).attr("data-bs-name");
                const buttonSpan = document.createElement("span");
                buttonSpan.innerHTML = `${btnName}&nbsp;`;
                inputGroupElement.append(buttonSpan);
                inputGroupElement.append(spinnerIconElement);
                $(`#${componentId}`).html(inputGroupElement);
            }
            break;
        }

        case "remove":
            if (isBulkActionBtn) {
                const btnName = $(`#${componentId}`).attr("data-bs-name");
                $(`#${componentId}`).html(btnName);
            }
            break;
    }
};

export const createPortfoliosOptions = async (
    setPortfoliosOptions: React.Dispatch<
        React.SetStateAction<TargetTypeOption[]>
    >
) => {
    const portfoliosData = store.getState().portfoliosData.value;
    const portfoliosOptionsData: TargetTypeOption[] = [];
    const clientPortfolio = portfoliosData.length
        ? portfoliosData
        : await getPortfolio();

    clientPortfolio.forEach((portfolio: IPortfolio) => {
        const options = {
            value: portfolio.portfolio_id,
            label: portfolio.portfolio_name,
        };
        portfoliosOptionsData.push(options);
    });
    setPortfoliosOptions(portfoliosOptionsData);
};

export const dayPartingBtnDisplay = (
    activeTab: string,
    activeCheckedNode: RowNode[]
) => {
    if (activeTab === "campaigns" && activeCheckedNode.length >= 1) {
        $("#dayPartingBtn").show();
    } else {
        $("#dayPartingBtn").hide();
    }
};

export const fetchTimezones = async () => {
    try {
        const response = await sendRequest({
            type: `admin/timezones`,
            method: "GET",
        });

        if (!response.status) {
            showToast("danger", response.message);
        } else {
            return response.message;
        }
    } catch (e) {
        throw (e as Error).message;
    }
};

export const fetchCountriesData = async (): Promise<ICountryData[]> => {
    try {
        const response = await sendRequest({
            type: `admin/country`,
            method: "GET",
        });
        if (!response.status) {
            showToast("danger", response.message);
            return [];
        }
        return response.rows;
    } catch (e) {
        throw (e as Error).message;
    }
};

export const onFileUploadClickHandler = async (
    setIsAssetUpload: React.Dispatch<React.SetStateAction<boolean>>,
    setAssetResponse: React.Dispatch<
        React.SetStateAction<IStrapiAssetResponse | IStrapiResponse[] | []>
    >,
    isFirstStep: boolean,
    setSelectedImageFilter: React.Dispatch<React.SetStateAction<string>>
) => {
    setAssetResponse([]);
    setIsAssetUpload(true);
    $("#productnamelength").hide();
    $("#select-asset").prop("disabled", true);
    if ($("#asset_upload_tab-tab-selectFile").hasClass("active")) {
        $("#select-asset").show();
        $("#upload-asset").hide();
    } else {
        $("#select-asset").hide();
        $("#upload-asset").show();
    }

    if (isFirstStep) {
        $("#firstStep").css({ display: "none" });
        $("#firstStep").addClass("showing");
        $("#createCampaign").css({ display: "none" });

        sessionStorage.removeItem("strapiAssetID");

        (document.getElementById("file-name") as HTMLInputElement).value = "";
        document.getElementById("assetname").removeAttribute("disabled");
        setSelectedImageFilter("logo");
    } else {
        $("#back").css({ display: "none" });
        $("#secondStep").css({ display: "none" });
        $("#secondStep").addClass("showing");
        $("#publish-campaigns").css({ display: "none" });
        setSelectedImageFilter("creative_static");
        sessionStorage.removeItem("campaignCustomImageStrapiAssetID");
    }

    $(".selectedProduct").css({ display: "none" });
    $("#asset_upload_div").css({ display: "unset" });
    $("#image_filter").css({ display: "unset" });
    $("#upload-form").trigger("reset");
};

export const timeIntervalArr = () => {
    const items = [];
    for (let hour = 0; hour < 24; hour++) {
        items.push([hour, 0]);
        items.push([hour, 30]);
    }

    const date = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: false,
    });

    const range = ["00:01", "00:30"];
    items.forEach((time) => {
        const [hour, minute] = time;
        date.setHours(hour);
        date.setMinutes(minute);
        range.push(formatter.format(date));
    });

    const filteredRange = range.filter(
        (time) => time !== "24:00" && time !== "24:30"
    );
    filteredRange.push("23:59");
    return filteredRange;
};

export const removeTimezoneDefaultStyle = () => {
    $(
        ".mySelect__value-container__indicator.mySelect__value-container__dropdown-indicator.css-tlfecz-indicatorContainer"
    ).css({ display: "none" });
    $(
        ".mySelect__value-container__indicator-separator.css-1okebmr-indicatorSeparator"
    ).css({ display: "none" });
    $(".mySelect__value-container__input-container.css-6j8wv5-Input").css({
        padding: 0,
        margin: 0,
    });
};

export const addToBuybox = async (
    appendData = false,
    buyboxEnabledData: TBuyboxEnabledData = []
) => {
    try {
        const selectedData = store.getState().productsSelectionData.value;
        let asins = selectedData.map((data) => data.asin);

        if (appendData) {
            //@ts-ignore
            asins = [...new Set([...asins, ...buyboxEnabledData])];
        }
        const data = {
            asin: asins,
            operation: "update",
        };
        const response = await updateBuybox(data);
        if (!response) {
            throw new Error(response.message);
        }
        showToast("success", response.message);
        $("#pa-bulk-action-drop-down").css({ display: "none" });
        const isBuyboxUpdated = store.getState().isBuyboxUpdated.value;
        store.dispatch(updateIsBuyboxUpdated(!isBuyboxUpdated));
        store.dispatch(updateBuyboxEnabledData([]));
        sessionStorage.removeItem("selectedData");
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
        Sentry.captureException(err);
    }
};

export const removeFromBuybox = async () => {
    //already existing skus that have buybox enabled
    const focusedAsins = store.getState().focusedAsins.value;

    // selected skus from which buybox is to be removed
    const selectedAsins = map(
        store.getState().productsSelectionData.value,
        (product) => product.asin
    );

    const asinsToRemove = intersection(focusedAsins, selectedAsins);

    if (asinsToRemove.length >= 1) {
        const data = {
            asin: asinsToRemove,
            operation: "remove",
        };
        const response = await updateBuybox(data);
        if (!response) {
            throw new Error(response.message);
        }
        showToast(
            `${response.status ? "success" : "danger"}`,
            response.message
        );
        const isBuyboxUpdated = store.getState().isBuyboxUpdated.value;
        store.dispatch(updateIsBuyboxUpdated(!isBuyboxUpdated));
    } else {
        showToast(
            "danger",
            "Buybox is not enabled for the selected product(s)."
        );
    }
    $("#pa-bulk-action-drop-down").css({ display: "none" });
};

export const updateBuyboxHandler = async () => {
    try {
        const { sellerDetails } = (await populateSellersData()).message;
        const preferredSellers = sellerDetails.filter(
            (data: TSellersData) => data.isPreferredSeller
        );
        const focusedAsins = store.getState().focusedAsins.value;
        store.dispatch(
            updateDoPreferredSellersExist(preferredSellers.length > 0)
        );
        if (preferredSellers.length) {
            if (focusedAsins?.length) {
                store.dispatch(updateBuyboxEnabledData(focusedAsins));
                store.dispatch(updateShowRequestAlert(true));
            } else {
                addToBuybox();
            }
        } else {
            store.dispatch(updateShowRequestAlert(true));
        }
    } catch (err) {
        console.error(err);
        showToast("danger", (err as Error).message);
        Sentry.captureException(err);
    }
};

export const addSellersToList = (
    e: ChangeEvent<HTMLInputElement>,
    selectedSellersData: string[],
    setSelectedSellersData: React.Dispatch<SetStateAction<string[]>>,
    sellersData: TSellersData[]
) => {
    const seller = e.target.value;
    const isChecked = e.target.checked;
    const id = +e.target.id;
    let data = [...selectedSellersData];
    if (isChecked) {
        for (const item of sellersData) {
            if (item.id === id) {
                item.isPreferredSeller = true;
                break;
            }
        }
        data.push(seller);
    } else {
        for (const item of sellersData) {
            if (item.id === id) {
                item.isPreferredSeller = false;
                break;
            }
        }
        data = data.filter((s: string) => s !== seller);
    }
    setSelectedSellersData(data);
};

export const addBrandsToList = (
    e: ChangeEvent<HTMLInputElement>,
    selectedBrandsData: number[],
    setSelectedBrandsData: React.Dispatch<SetStateAction<number[]>>,
    brandsData: TBrandsData[]
) => {
    const { checked, id: targetId } = e.target;
    const id = Number(targetId);

    const brand = brandsData.find((item) => item.id === id);
    if (brand) {
        brand.is_selected = checked;
    }

    const updatedData = checked
        ? [...selectedBrandsData, id]
        : selectedBrandsData.filter((brandId) => brandId !== id);
    setSelectedBrandsData(updatedData);
};

export const submitSettings = async (
    selectedSellersData: string[],
    selectedTimezone: TTimezone,
    asinsAvailable: boolean,
    selectedCountryDetails: IUserCountryDetails,
    selectedBrandsData: number[],
    onSuccess?: () => void
) => {
    const enableBuybox = store.getState().enableBuybox.value;
    if (enableBuybox && selectedSellersData) {
        if (!selectedSellersData.length && asinsAvailable) {
            showToast("danger", `Please remove all the asin from buybox`);
        } else {
            updateUserSettings({
                selectedSellersData,
                selectedTimezone,
                selectedCountryDetails,
                selectedBrandsData,
                onSuccess,
            });
        }
    } else {
        updateUserSettings({
            selectedTimezone,
            selectedCountryDetails,
            selectedBrandsData,
            onSuccess,
        });
    }
};

export const getChannelParams = () => {
    const { channel, channelList } = store.getState();
    const availableChannels = channelList.value.map((data) => data.channel_id);

    const defaultChannel = availableChannels.includes(channel.value)
        ? channel.value
        : availableChannels[0];

    return channelList.value.find(
        (data: IChannels) => data.channel_id === defaultChannel
    );
};

export const updateChannelSettings = () => {
    if (getChannelParams()) {
        const {
            // revstack,
            dayparting,
            buybox,
            wallet_balance,
            keywordrecommendation,
            domain,
            selected_country_code,
            selected_country_locale,
        } = getChannelParams();
        store.dispatch(updateEnableDayparting(dayparting));
        store.dispatch(updateEnableBuybox(buybox));
        store.dispatch(
            updateEnableKeywordRecommendation(keywordrecommendation)
        );
        store.dispatch(updateChannelWalletBalance(wallet_balance));
        store.dispatch(updateChannelDomain(domain));
        store.dispatch(
            updateUserCountryDetails({
                selected_country_code,
                selected_country_locale,
            })
        );
    }
};

/**
 * !Note[DND]:
 * Ensures channels are loaded and returns a valid channel ID to use
 * Logic:
 * 1. Fetches channels if not loaded or forceRefresh is true
 * 2. Gets currently selected channel from state
 * 3. Validates if selected channel exists in the channels list
 * 4. Returns valid channel or first available channel
 */

export const ensureChannelsLoaded = async (
    forceRefresh = false
): Promise<{
    channelId: number;
    channels: IChannels[];
}> => {
    let channels: IChannels[] = store.getState().channelList.value;

    if (!channels || channels.length === 0 || forceRefresh) {
        const result = await store.dispatch(getClientChannels());
        channels = result.payload as IChannels[];

        if (!channels || channels.length === 0) {
            throw new Error("No channels found for this client");
        }
    }

    const currentChannelId = store.getState().channel.value;

    const isCurrentChannelValid = channels.find(
        (channel: IChannels) => channel.channel_id === currentChannelId
    );

    const selectedChannelId =
        isCurrentChannelValid?.channel_id ?? channels[0]?.channel_id ?? 0;

    return {
        channelId: selectedChannelId,
        channels,
    };
};

export const setActivationChannel = (channelId: number) => {
    store.dispatch(updateChannel(channelId));
    updateChannelSettings();
};

export const setActivationConfig = (channelId: number) => {
    setActivationChannel(channelId);
    clearClientTimezone();
    sessionStorage.removeItem(SessionStorageKey.ActiveFilters);
    // resetReviewFilters();
    resetMediaPlanningConfig();
    store.dispatch(setPortfoliosData([]));
};

export const fetchAndUpdateLogo = async (clientId: number) => {
    try {
        const logoUrl = await getClientLogoUrl(clientId);
        store.dispatch(updateSidebarLogo(logoUrl || null));
    } catch (error) {
        store.dispatch(updateSidebarLogo(null));
    }
};

export const updateClientSettings = async (activeClient: number) => {
    // changing client call
    // doNewChannelsHaveCurrentChannel => keep the channel state same
    // else update the channel id to the first element of channelList value
    // Error handling is done inside the asyncThunkMiddleware

    const clients = store.getState().clients.value;

    const clientData = clients.find(
        (client: IClient) => +client.id === activeClient
    );

    // This is to fetch the correct channel list for the client that is changed
    // without fetching the other module related data which is dependent on activeClientId
    // so as to avoid api calls with wrong set of client/channel

    store.dispatch(updateActiveClientId(activeClient));
    store.dispatch(updateClientIdOnChannelChange(activeClient));
    store.dispatch(updateActiveClientGroupId(+clientData.client_group_id));
    store.dispatch(updateClientSubGroupId(+clientData.client_subgroup_id));
    store.dispatch(getClientReports());

    setClientTimezone(
        getClientAttributes().clientTimezone ??
        Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    if (typeof clientData.logo_url === "string") {
        store.dispatch(updateSidebarLogo(clientData.logo_url));
    } else {
        fetchAndUpdateLogo(activeClient);
    }


    updateUserAccess(activeClient);
};

export const updateUserAccess = async (activeClient: number) => {
    const userData = store.getState().userData.value;

    const userAccess = userData?.access?.find((access: IAccess) =>
        access.clients.find(
            (client: IClientAccess) => +client.client_id === activeClient
        )
    );
    const platformAccess = userData?.is_super_admin
        ? [
            Platforms.PLANNING.toLowerCase(),
            Platforms.ACTIVATION.toLowerCase(),
            Platforms.CHATBOT.toLowerCase(),
            Platforms.MEASUREMENT.toLowerCase(),
        ]
        : userAccess
            ? userAccess?.platforms.map((item: string) => item.toLowerCase())
            : [];

    // TODO: Change the below condition when revstack is set at client level
    if (platformAccess.includes(Platforms.PLANNING)) {
        const clientReports = store.getState().reportsData.value;
        if (
            platformAccess.length === 1 &&
            clientReports &&
            clientReports.revstack.length
        ) {
            store.dispatch(setSelectedReportData(clientReports.revstack[0]));
        }
        store.dispatch(updateEnableRevstack(true));
    }

    if (platformAccess.includes(Platforms.ACTIVATION)) {
        try {
            const { channelId } = await ensureChannelsLoaded(true);
            setActivationConfig(channelId);
        } catch (error) {
            console.error("Failed to load channels:", error);
        }
    }
};

export const applyAdminSettingsOnload = async (activeClientId: number) => {
    const clients: IClient[] = store.getState().clients.value;
    if (clients.length > 0) {
        const activeClient = clients.filter(
            (data: IClient) => data.id === +activeClientId
        );

        const {
            timezone,
            // country_name,
            client_group_id,
            client_subgroup_id,
            currency_symbol,
        } = activeClient[0] || clients[0];

        store.dispatch(
            updateClientTimezone(
                timezone
                    ? timezone
                    : Intl.DateTimeFormat().resolvedOptions().timeZone
            )
        );

        updateChannelSettings();

        store.dispatch(updateChannelCurrencySymbol(currency_symbol));
        store.dispatch(updateActiveClientGroupId(client_group_id));
        store.dispatch(updateClientSubGroupId(client_subgroup_id));
    }
};

export const onSelectAllGridDataClick = async (activeGridApi: GridApi) => {
    const dayPartingDisplay = store.getState().dayPartingDisplay.value;
    const selectedData: TCommonRowData = [];
    const { activeModule } = getActiveModule();
    activeGridApi.forEachNodeAfterFilter((node: RowNode) => {
        selectedData.push(node.data);
    });
    const filteredData =
        selectedData &&
        ((await createWorkers("selectedData", {
            selectedData,
            activeModule,
            isDayParting: dayPartingDisplay,
        })) as TCommonRowData);
    if (filteredData.length) {
        switch (activeModule) {
            case SubModule.PORTFOLIO:
                store.dispatch(updateIsAllPortfoliosSelected(true));
                store.dispatch(updateAllPortfolioId(filteredData));
                break;

            case SubModule.CAMPAIGN:
                store.dispatch(updateIsAllCampaignsSelected(true));
                store.dispatch(updateAllSysCampaignId(filteredData));
                break;

            case SubModule.ADGROUP:
                store.dispatch(updateIsAllAdgroupsSelected(true));
                store.dispatch(updateAllSysAdgroupId(filteredData));
                break;
        }
        showToast(
            "success",
            `All ${titleCase(activeModule)} have been selected`
        );
    }

    return;
};

export const initialFilters = (gridApi: GridApi) => {
    const { activeModule } = getActiveModule();
    sessionStorage.removeItem("activeFilters");
    if (
        activeModule === SubModule.SUGGESTED_NEG_KWS ||
        activeModule === SubModule.KEYWORD_MANUAL
    ) {
        setDefaultFilters(gridApi);
    } else if (
        activeModule === ParentModule.RULES ||
        activeModule === ParentModule.CHANGE_LOG
    ) {
        gridApi.setFilterModel({});
    } else {
        removeAppliedFilters();
        setDefaultFilters(gridApi);
        gridApi.setFilterModel({});
    }
};

export const getClientAttributes = () => {
    const selector = ".ant-select-selection-item .client-info";
    const clientData = store
        .getState()
        .clients.value.find((client: IClient) => +client.id === getClientId());
    const $element = $(selector);

    return {
        clientTimezone: $element.attr("data-timezone") ?? clientData?.timezone,
        accountType:
            $element.attr("data-account_type") ?? clientData?.account_type,
        countryCode:
            $element.attr("data-country") ?? clientData?.country_non_iso,
        currency: $element.attr("data-currency") ?? clientData?.currency,
    };
};

export const nameValidation = (name: string) => {
    const channel = CHANNEL_CONFIGS[store.getState().channel.value].name;
    const maxLength = 128;
    const validationRegex =
        moduleConfigs[channel as ChannelName].modules[
            ParentModule.PERFORMANCE_OVERVIEW
        ].subModules[SubModule.CAMPAIGN]?.nameValidationRegex ||
        DEFAULT_CAMPAIGN_NAME_REGEX;

    let newValue = name.replace(validationRegex, "");
    let errorMsg = "";

    if (newValue.length !== name.length) {
        errorMsg = "Entered invalid character(s) (eg; !,#,&,<,>,₹,|)";
    }

    if (name.length > maxLength) {
        newValue = newValue.slice(0, maxLength);
        errorMsg += errorMsg ? " and " : "";
        errorMsg += `name length cannot be greater than ${maxLength}`;
    }

    if (errorMsg) {
        showToast("danger", errorMsg);
    }

    return newValue;
};

export const getStatusCellStyle = (params: CellClassParams) => {
    const status = params.value.toLowerCase();
    const color = statusColorMap[status] || "black";
    return { color };
};

export const resetActiveGridState = (api: GridApi) => {
    // Setting rowdata undefined so that grid loader appears
    // Deselected all the checkboxes and cleared all filters from grid

    api.deselectAll();
    if (getActiveModule().activeModule === ParentModule.CHANGE_LOG) {
        api.onFilterChanged();
    } else {
        api.setRowData(undefined);
    }
    api.setFilterModel({});
};

export const handleRevertAction = async () => {
    const spinnerElement = $(`#revert-bulk-action`);
    spinnerElement.replaceWith(spinnerHtml);
    try {
        const historyLogsSelectionData: ILog[] =
            store.getState().historyLogsSelectionData.value;

        const data: IRevertAction[] = map(
            historyLogsSelectionData,
            ({ id, module, record_id, old_value, attribute, metainfo }) => ({
                id,
                module,
                record_id,
                old_value,
                attribute,
                metainfo,
            })
        );

        if (data.length > 50) {
            throw new Error("Maximum 50 revert actions allowed at once!");
        } else {
            const response = await revertAction(data);
            if (!response.status) {
                throw new Error("Failed to revert actions");
            }
            showToast("success", response.message);
        }
    } catch (err: any) {
        console.error(err.message);
        showToast("danger", err.message);
    }
    $("#bulkActionSpinner").replaceWith(spinnerElement);
    $("#pa-bulk-action-drop-down").css({ display: "none" });
};

export const revertAction = async (logs: IRevertAction[]) => {
    try {
        const response = await sendRequest({
            type: `history/revert`,
            method: "POST",
            data: {
                logs,
            },
        });

        return response;
    } catch (err: any) {
        throw new Error(err.message);
    }
};
// export const internationalizeNumericValue = (value: any) => {
//     const { selected_country_code } = store.getState().userCountryDetails.value;
//     const formattedValue = new Intl.NumberFormat(
//         `en-${selected_country_code}`
//     ).format(value);
//     return formattedValue;
// };

export const internationalizeNumericValue = (value: number | string) => {
    const { userCountryDetails } = store.getState();
    const selected_country_code =
        userCountryDetails?.value?.selected_country_code;

    // Fallback to "en-US" if selected_country_code is undefined, null, or an empty string
    const locale = selected_country_code
        ? `en-${selected_country_code}`
        : "en-US";

    try {
        return new Intl.NumberFormat(locale).format(Number(value));
    } catch (error) {
        console.error("Error formatting number:", error);
        return value; // Return the original value if formatting fails
    }
};

export const parseInternationalizedValue = (
    stringNumber: string | number
): number => {
    const { selected_country_locale } =
        store.getState().userCountryDetails.value;
    const locale = selected_country_locale?.filter((data) => data !== "en")[0];
    const thousandSeparator = Intl.NumberFormat(locale || "en")
        ?.format(11111)
        ?.replace(/\p{Number}/gu, "");
    const decimalSeparator = Intl.NumberFormat(locale || "en")
        ?.format(1.1)
        ?.replace(/\p{Number}/gu, "");

    return stringNumber
        ? parseFloat(
            stringNumber
                ?.toString()
                ?.replace(new RegExp("\\" + thousandSeparator, "g"), "")
                ?.replace(new RegExp("\\" + decimalSeparator), ".")
        )
        : +stringNumber;
};

export const validateMaxCampaignBudget = (value: number): boolean => {
    const channel = store.getState().channel.value;
    const maxCampaignBudget =
        moduleConfigs[channelsMapping[channel] as ChannelName].options
            .maxCampaignBudget || 100000000;
    return Math.abs(value) < maxCampaignBudget;
};

export const getAllRowsFromGrid = () => {
    // This fn can get module level grid data only, for modal level we might have to add modal level globalapi
    // Note: In future developments keep the globalGrid api and modal level global grid api different

    const currentGridApi: any = store.getState().globalGridApi.value;
    const rowData: Record<string, any>[] = [];
    currentGridApi.forEachNode((node: Record<string, any>) =>
        rowData.push(node.data)
    );
    return rowData;
};

export const getGridUpdateConfig = (
    params: ICellRendererParams,
    value: string | number | boolean | string[] | TClientTags[],
    additionalValuesToUpdate = {},
    modalParamToChange = ""
) => {
    const { activeModule } = getActiveModule();
    const globalGridApi: GridApi | Record<string, never> =
        store.getState().globalGridApi.value;
    const selectedRows =
        globalGridApi instanceof GridApi
            ? globalGridApi.getSelectedNodes().map((row: RowNode) => row.data)
            : [];
    const currentRow = JSON.parse(JSON.stringify(params?.data));
    return {
        ...(selectedRows?.length ? { selectedRows } : { currentRow }),
        newParamValue: value,
        additionalValuesToUpdate,
        paramToChange: modalParamToChange || params?.colDef.field,
        paramToFilter: gridUpdateConfig[activeModule as Modules].paramToFilter,
    };
};

export const cellSpinnerHandler = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    applyChange: (isCancel: boolean) => Promise<void>,
    isCancel = false
) => {
    setLoading(true);
    await applyChange(isCancel);
    setLoading(false);
};

export const getBadgeParams = (
    paramType: string,
    badgeType: "status" | "campaignType" | "new",
    servingStatus?: string,
    campaignType?: string
) => {
    const index =
        badgeType === "status"
            ? servingStatus
            : badgeType === "campaignType"
                ? campaignType
                : "new";
    if (paramType === "color") {
        return BadgeColor[index as keyof typeof BadgeColor];
    }

    if (paramType === "text") {
        return BadgeText[index as keyof typeof BadgeText];
    }
};

export const isTarget = (target: string) => target.match(/b0[A-Za-z0-9]{8}/i);

export const handleAddExactBtnClick = async ({
    matchType,
    addAsExactData,
    addAsExactConfig,
    bidField,
    show,
    setShow,
    handleClose,
    setAddLoader,
    isIndividualUpdate,
}: THandleAddBtnClick) => {
    const { setLoader, attribute, isBidRequired, addFunc, validateFunc } =
        addAsExactConfig[matchType];

    store.dispatch(setLoader(true));
    isIndividualUpdate && setAddLoader(true);
    try {
        if (addAsExactData.length > 100)
            throw new Error(
                "Cannot send request for more than 100 keywords at once"
            );

        const data = omit(
            addAsExactData.reduce(
                (
                    acc,
                    {
                        sys_campaign_id: sysCampaignId,
                        sys_adgroup_id: sysAdgroupId,
                        campaign_id: campaignId,
                        ad_group_id: adGroupId,
                        keyword_name: keywordText,
                        customer_search_term: searchTerm,
                        program_type: programType,
                        ...rest
                    }
                ) => {
                    const checkIsTarget = isTarget(searchTerm ?? keywordText);
                    const payloadArray = checkIsTarget ? "targets" : "keywords";

                    acc[payloadArray].push({
                        sysCampaignId,
                        ...(sysAdgroupId && { sysAdgroupId }),
                        campaignId,
                        ...(adGroupId && { adGroupId }),
                        keywordText: checkIsTarget
                            ? checkIsTarget[0]
                            : searchTerm ?? keywordText,
                        programType,
                        matchType: checkIsTarget ? "asinSameAs" : matchType,
                        state: StateTypeValues.ENABLED,
                        attribute: [attribute],
                        ...(isBidRequired && {
                            bid: Math.floor(rest[bidField] || 10),
                        }),
                    });

                    return acc;
                },
                { keywords: [], targets: [] }
            ),
            (value) => isEmpty(value)
        );

        if (validateFunc) {
            //keyword creation
            const validatedResponse = await validateFunc(data);
            if (validatedResponse.status) {
                if (
                    validatedResponse.metadata.keywordsAndTargetsToProcess
                        .toCreate.length
                ) {
                    const kwResponse = await addFunc(data);

                    if (!kwResponse.status) {
                        throw new Error(kwResponse.message);
                    }
                    showToast("success", kwResponse.message);
                } else {
                    throw new Error("Keywords already exist");
                }
            } else {
                throw new Error("Failed to send create keywords request");
            }
        } else {
            // neg keyword creation
            const negKwResponse = await addFunc(data);

            if (!negKwResponse.status) {
                throw new Error(negKwResponse.message);
            }
            showToast("success", negKwResponse.message);
        }
    } catch (err: any) {
        console.error(err.message);
        showToast(
            "danger",
            `Failed to send ${matchType === MatchType.NEGATIVE_EXACT ? "negative" : ""
            } keywords creation request: ${(err as Error).message}`
        );
        Sentry.captureException(err);
    } finally {
        store.dispatch(setLoader(false));
        show && setShow(false);
        handleClose && handleClose();
        isIndividualUpdate && setAddLoader(false);
    }
};

export const getCampaignsAndPortfolios = async () => {
    try {
        const response = await sendRequest({
            type: "campaigns/list",
            method: "GET",
        });
        if (!response) {
            throw new Error("Unable to get campaigns list");
        }

        store.dispatch(setcampaignPortfolioData(response.rows));
    } catch (err: any) {
        showToast("danger", err.message);
    }
};

export const isPropPresent = (params: CommonGridParams, prop: string) =>
    params ? prop in params : false;

export const isDisabledDate = (current: Dayjs | null): boolean => {
    return current ? current.isBefore(dayjs().startOf("day"), "day") : false;
};

export const getReviewedKeywords = async (campaigns: (number | string)[]) => {
    try {
        const response = await sendRequest({
            type: `keywords/review`,
            method: "POST",
            data: { campaigns },
        });
        if (!response.status) {
            showToast("danger", response.message);
        }
        return response.rows;
    } catch (e) {
        throw (e as Error).message;
    }
};

export const autoSizeAll = (
    skipHeader: boolean,
    gridRef: MutableRefObject<AgGridReact>
) => {
    return gridRef.current.columnApi.autoSizeAllColumns(skipHeader);
};

export const getClientTagsList = async () => {
    try {
        store.dispatch(updateTagTypeListLoading(true));
        const response = await sendRequest({
            type: "clients/tags",
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        store.dispatch(updateTagTypeList(response.rows));
        store.dispatch(setIsAddTagTypeFormSubmitted(false));

        return response.rows;
    } catch (err) {
        throw new Error((err as Error).message);
    } finally {
        store.dispatch(updateTagTypeListLoading(false));
    }
};

export const getFocusedAsinsList = async () => {
    try {
        const response = await sendRequest({
            type: "analytics/products/focused-asins",
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response.rows;
    } catch (err) {
        throw new Error((err as Error).message);
    }
};

const getTagsByType = (tagsMapping: TClientTags[], tagTypes: string[]) => {
    const recordTagsData = store.getState().recordTagsData.value;
    const uniqueTags = compact(tagTypes)?.length
        ? chain(tagsMapping)
            .filter((entry) => contains(tagTypes, entry.tag_type))
            .pluck("tags")
            .flatten()
            .uniq()
            .value()
        : recordTagsData;
    return uniqueTags;
};

export const getGridType = () => {
    const { activeModule } = getActiveModule();

    if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
        const keywordModalType = store.getState().keywordModalType.value;
        return keywordModalType === KeywordModalType.CAMPAIGNS_MODAL
            ? SubModule.CAMPAIGN
            : SubModule.KEYWORD;
    }

    if (activeModule === ParentModule.PRODUCT_ANALYTICS) {
        const productModalType = store.getState().productModalType.value;
        return productModalType === ProductModalType.PRODUCTS_MODAL
            ? SubModule.KEYWORD
            : SubModule.ADGROUP;
    }

    return null;
};

export const getGoalsConfig = async (): Promise<TGoalsConfig[]> => {
    try {
        const response = await sendRequest({
            type: "goals/config",
            method: "GET",
        });
        if (!response.status) {
            throw new Error("Unable to get goals config data!!");
        }

        return response.rows as TGoalsConfig[];
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        throw err;
    }
};

export const getGoalDataValues = async () => {
    try {
        const response = await sendRequest({
            type: "goals/data-values",
            method: "GET",
        });
        if (!response.status) {
            throw new Error("Unable to get goals data values!!");
        }

        return response.rows;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        throw err;
    }
};

export const populateGoals = async (status = "") => {
    try {
        const response = await sendRequest({
            type: `goals/list${status ? `/${status}` : ""}`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }
        return response.rows;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        throw new Error((err as Error).message);
    }
};

export const addGoals = async (data: TGoalsData) => {
    try {
        const response = await sendRequest({
            type: "goals",
            method: "POST",
            data,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        showToast(
            "success",
            `Goal - ${data.goalName} ${data.goalActionType}${data.goalActionType.endsWith("e") ? "d" : "ed"
            } successfully`
        );
    } catch (err: any) {
        showToast("danger", "Failed to create goal");
        Sentry.captureException(err);
        console.error(err);
    }
};

export const archiveGoals = async (goalId: number, goalName: string) => {
    try {
        const response = await sendRequest({
            type: `goals/archive/${goalId}`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        showToast("success", `Goal - ${goalName} archived successfully`);
    } catch (err: any) {
        showToast("danger", "Failed to archive goal");
        Sentry.captureException(err);
        console.error(err);
    }
};

export const restoreGoals = async (goalId: number, goalName: string) => {
    try {
        const response = await sendRequest({
            type: `goals/restore/${goalId}`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        showToast("success", `Goal - ${goalName} restored successfully`);
    } catch (err: any) {
        showToast("danger", "Failed to restore goal");
        Sentry.captureException(err);
        console.error(err);
    }
};

export const refreshGoalsResult = async () => {
    try {
        const response = await sendRequest({
            type: `goals/refresh`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", "Failed to refresh goal results");
        Sentry.captureException(err);
        console.error(err);
    }
};

export const getDataLevelConfig = (
    goalsConfig: TGoalsConfig[],
    level: string
) => find(goalsConfig, (config) => config.data_level === level);
export const calcOutOfStockInfo = (data: any) => {
    let outOfStockSince = null;
    for (const item of data) {
        if (!item.availability) {
            outOfStockSince = item.crawl_date;
        } else {
            break;
        }
    }

    const totalDays = data.length;
    const outOfStockDays = data.filter(
        (item: any) => !item.availability
    ).length;
    const outOfStockPercentage = (outOfStockDays / totalDays) * 100;

    outOfStockSince = outOfStockSince
        ? dayjs(outOfStockSince).format("DD-MM-YYYY")
        : null;

    return {
        out_of_stock_since: outOfStockSince,
        out_of_stock_percentage: `${outOfStockPercentage.toFixed(1)}%`,
    };
};

const calcPercentageChange = (key: string, dataObj: any[]) => {
    const isValidNumber = (num: any) => typeof num === "number" && !isNaN(num);

    if (key === DeepDiveBrandScoreInfo.MS_PERC_BY_VALUE) {
        const percentages = dataObj
            .map((item) => {
                if (
                    isValidNumber(item.revenue) &&
                    isValidNumber(item.cat_revenue) &&
                    item.cat_revenue !== 0
                ) {
                    return {
                        date: item.crawl_date,
                        percentage: (item.revenue / item.cat_revenue) * 100,
                    };
                } else {
                    return { date: item.crawl_date, percentage: null };
                }
            })
            .filter((item) => item.percentage !== null);

        if (percentages.length === 0) {
            return null;
        }

        MISC_PA_REPORT_WIDGET.msValue = percentages[0].percentage.toFixed(1);

        const midpoint = Math.floor(percentages.length / 2);
        const firstHalf = percentages.slice(0, midpoint);
        const secondHalf = percentages.slice(midpoint);

        const avgFirstHalf =
            firstHalf.reduce((sum, item) => sum + item.percentage, 0) /
            firstHalf.length;
        const avgSecondHalf =
            secondHalf.reduce((sum, item) => sum + item.percentage, 0) /
            secondHalf.length;

        const percentageChange =
            ((avgSecondHalf - avgFirstHalf) / avgFirstHalf) * 100;

        return percentageChange ? `${percentageChange.toFixed(2)}%` : null;
    } else if (key === DeepDiveBrandScoreInfo.LATEST_BSR) {
        const sortedData = dataObj.sort((a, b) =>
            moment(b.date).diff(moment(a.date))
        );

        const latestEntry = sortedData.find((item) =>
            isValidNumber(item.bsr_rank_2)
        );
        if (!latestEntry) {
            return null;
        }

        const latestCategory = latestEntry.bsr_category_2;

        MISC_PA_REPORT_WIDGET.latestBsrCategory = latestCategory;

        const filteredData = sortedData.filter(
            (item) =>
                item.bsr_category_2 === latestCategory &&
                isValidNumber(item.bsr_rank_2)
        );

        if (filteredData.length < 2) {
            return null;
        }

        const midpoint = Math.floor(filteredData.length / 2);
        const firstHalf = filteredData.slice(0, midpoint);
        const secondHalf = filteredData.slice(midpoint);

        const latestFirstHalfBSR = firstHalf[0].bsr_rank_2;
        MISC_PA_REPORT_WIDGET.latestBsrRank = latestFirstHalfBSR;
        const latestSecondHalfBSR = secondHalf[0].bsr_rank_2;

        if (latestFirstHalfBSR == null || latestSecondHalfBSR == null) {
            return null;
        }

        const absoluteChange = latestSecondHalfBSR - latestFirstHalfBSR;

        const result =
            absoluteChange > 0 ? `+${absoluteChange}` : `${absoluteChange}`;

        return result;
    } else if (key === DeepDiveBrandScoreInfo.ORGANIC_VISIBILITY) {
        const percentages = dataObj
            .map((item) => {
                if (
                    isValidNumber(item.org_sku_wt_crawl_sv) &&
                    isValidNumber(item.org_cat_wt_crawl_sv) &&
                    item.org_cat_wt_crawl_sv !== 0
                ) {
                    return {
                        date: item.date,
                        percentage:
                            (item.org_sku_wt_crawl_sv /
                                item.org_cat_wt_crawl_sv) *
                            100,
                    };
                } else {
                    return { date: item.date, percentage: null };
                }
            })
            .filter((item) => item.percentage !== null);

        if (percentages.length === 0) {
            return null;
        }

        const midpoint = Math.floor(percentages.length / 2);
        const firstHalf = percentages.slice(0, midpoint);
        const secondHalf = percentages.slice(midpoint);

        const avgFirstHalf =
            firstHalf.reduce((sum, item) => sum + item.percentage, 0) /
            firstHalf.length;
        const avgSecondHalf =
            secondHalf.reduce((sum, item) => sum + item.percentage, 0) /
            secondHalf.length;

        const percentageChange =
            ((avgSecondHalf - avgFirstHalf) / avgFirstHalf) * 100;

        return percentageChange ? `${percentageChange.toFixed(2)}%` : null;
    } else if (key === DeepDiveBrandScoreInfo.PAID_VISIBILITY) {
        const percentages = dataObj
            .map((item) => {
                if (
                    isValidNumber(item.org_sku_wt_crawl_sv) &&
                    isValidNumber(item.org_cat_wt_crawl_sv) &&
                    item.org_cat_wt_crawl_sv !== 0
                ) {
                    return {
                        date: item.date,
                        percentage:
                            (item.paid_sku_wt_crawl_sv /
                                item.paid_cat_wt_crawl_sv) *
                            100,
                    };
                } else {
                    return { date: item.date, percentage: null };
                }
            })
            .filter((item) => item.percentage !== null);

        if (percentages.length === 0) {
            return null;
        }

        const midpoint = Math.floor(percentages.length / 2);
        const firstHalf = percentages.slice(0, midpoint);
        const secondHalf = percentages.slice(midpoint);

        const avgFirstHalf =
            firstHalf.reduce((sum, item) => sum + item.percentage, 0) /
            firstHalf.length;
        const avgSecondHalf =
            secondHalf.reduce((sum, item) => sum + item.percentage, 0) /
            secondHalf.length;

        const percentageChange =
            ((avgSecondHalf - avgFirstHalf) / avgFirstHalf) * 100;

        return percentageChange ? `${percentageChange.toFixed(2)}%` : null;
    }

    return null;
};

const compileBuyboxData = (data: any) => {
    let buyboxWinner: any = null;
    let buyboxLostSince: any = null;
    const totalRecords = data.length;
    let buyboxWinCount = 0;

    data.sort((a: any, b: any) =>
        moment(b.crawl_date).diff(moment(a.crawl_date))
    );

    data.forEach((item: any) => {
        if (item.buybox_win) {
            buyboxWinCount++;
            if (item.merchant_name && item.merchant_name.length > 0) {
                buyboxWinner = item.merchant_name[0];
            }
        }
    });

    for (const item of data) {
        if (item.buybox_win) {
            break;
        } else {
            buyboxLostSince = item.crawl_date;
            if (
                item.merchant_name &&
                item.merchant_name.length > 0 &&
                !buyboxWinner
            ) {
                buyboxWinner = item.merchant_name[0];
            }
        }
    }

    const buyboxWinPercent = (buyboxWinCount / totalRecords) * 100;

    return {
        buybox_winner: buyboxWinner,
        buybox_lost_since: buyboxLostSince
            ? moment(buyboxLostSince).format("DD-MM-YYYY")
            : "-",
        buybox_win_percent: `${buyboxWinPercent.toFixed(1)}%`,
    };
};

export const validateRemoveTag = async (tagId: number) => {
    try {
        const response: TValidateTagRemoveResponse = await sendRequest({
            type: `clients/tag/${tagId}/check`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error("Failed to validate request");
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
        console.error(err);
    }
};

export const validateRemoveTagType = async (tagType: string) => {
    try {
        const response: TValidateTagRemoveResponse = await sendRequest({
            type: `clients/tag_type/${tagType}/check`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error("Failed to validate request");
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
        console.error(err);
    }
};

export const addUser = async (data: any) => {
    try {
        const response = await sendRequest({
            type: "user/create",
            method: "POST",
            data,
        });

        return response;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
    }
};

export const updateTagMapping = async (
    data: TUpdateTagMapping,
    requestType: "add" | "remove" | "type-remove" | "type-add"
) => {
    try {
        const response = await sendRequest({
            type: `clients/tag-${requestType}`,
            method: "POST",
            data,
        });
        if (!response.status) {
            throw new Error(response.message);
        }

        showToast("success", response.message);
        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
        console.error(err);
    }
};

export const deleteUser = async (data: any) => {
    try {
        const { uid } = data;
        const response = await sendRequest({
            type: `user/${uid}`,
            method: "DELETE",
        });

        showToast(
            `${response.status ? "success" : "danger"}`,
            response.message
        );
        return response;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
    }
};

export const updateUserDetails = async (data: any) => {
    try {
        const { userId, clientChanges, ...userData } = data;

        const payload = {
            ...userData,
            ...(clientChanges && {
                clientChanges: clientChanges as IClientChanges,
            }),
        };

        const response = await sendRequest({
            type: `user/${userId}`,
            method: "PUT",
            data: payload,
        });

        return response;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
    }
};

export const sendPasswordResetMail = async (data: any) => {
    try {
        const { userId } = data;
        const response = await sendRequest({
            type: `user/${userId}/reset-password`,
            method: "PUT",
            data: {},
        });

        showToast(
            `${response.status ? "success" : "danger"}`,
            response.message
        );

        return response;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
    }
};

export const getSortedTagTypeList = (
    tagTypeList: TClientTags[],
    recordType: string
) => {
    // all avl tag types for the module
    const tagTypes = [
        ...DEFAULT_TAG_TYPES["global"],
        ...DEFAULT_TAG_TYPES[recordType],
        ...map(
            filter(tagTypeList, (type) => type.record_type === recordType),
            (recordTagType) => recordTagType.tag_type
        ),
    ];

    // tags list for that module
    const recordTagTypeList = filter(
        tagTypeList,
        (type) =>
            type.record_type === "global" || type.record_type === recordType
    );

    //sorted tags list for ordered color coding
    return recordTagTypeList.sort((a, b) => {
        return indexOf(tagTypes, a.tag_type) - indexOf(tagTypes, b.tag_type);
    });
};

export const getTagType = (tag: string, recordType: string) => {
    const tagTypeList: TClientTags[] = store.getState().tagTypeList.value;

    //sorted tags list for ordered color coding
    const sortedTagTypes = getSortedTagTypeList(tagTypeList, recordType);

    const foundTagType = find(sortedTagTypes, (type) =>
        type.tags_map.includes(tag)
    );

    const tagType = foundTagType?.tag_type || "";
    const foundRecordType = tagType ? foundTagType.record_type : recordType;

    // Count global tag types for color offset calculation
    const globalTagTypesCount = filter(tagTypeList, (type) => type.record_type === GlobalTagRecordType.GLOBAL).length;

    // Calculate tag type index within its level
    let tagTypeIndex = -1;
    if (tagType) {
        if (foundRecordType === "global") {
            // For global tags, use index directly (only count global tags before this one)
            tagTypeIndex = filter(sortedTagTypes, (type) =>
                type.record_type === "global" && indexOf(sortedTagTypes, type) < indexOf(sortedTagTypes, foundTagType)
            ).length;
        } else {
            // For campaign/product tags, count only tags of the same record type before this one
            tagTypeIndex = filter(sortedTagTypes, (type) =>
                type.record_type === foundRecordType && indexOf(sortedTagTypes, type) < indexOf(sortedTagTypes, foundTagType)
            ).length;
        }
    }

    // Calculate color index using the common utility function
    const finalColorIndex = getTagTypeColorIndex(foundRecordType, tagTypeIndex, globalTagTypesCount);

    return {
        tagType,
        tagFillColor: TAG_COLORS[finalColorIndex]?.fill,
        tagBorderColor: TAG_COLORS[finalColorIndex]?.border,
    };
};

export const normalizeTagType = (tagType: string) =>
    tagType.replace(/\s/g, "").toLowerCase();

/**
 * Gets the color index for a tag type based on global-first color assignment
 * Global level controls the master pointer, campaign/product start after global
 */
export const getTagTypeColorIndex = (
    recordType: string,
    tagTypeIndex: number,
    globalTagCount: number,
    totalColors: number = TAG_COLORS.length
): number => {
    const colorIndex = recordType === GlobalTagRecordType.GLOBAL
        ? tagTypeIndex
        : globalTagCount + tagTypeIndex;

    return colorIndex >= 0 ? colorIndex % totalColors : 0;
};

/**
 * !Note:
 * * days have been set as 7 cause, wrt to our flow if we add a exp time from tokens
 * * and if the value is expired, then it will be removed by the browser and will break our flow of
 * * validating the token before sending a api request, else we have to refactor the getTokens() fn in UserService
 */

export const setCookieData = (
    name: string,
    value: string,
    days = 7,
    path = "/"
) => {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
    )}; path=${path}; SameSite=Strict`;
    const isDevInstance = process.env.VITE_NODE_ENV === "local";
    const domainArr = window.location.hostname.split(".");
    const domain = isDevInstance ? null : domainArr.slice(-2).join(".");

    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        cookieString += `; expires=${date.toUTCString()}`;
    }

    if (domain) {
        cookieString += `; domain=${domain}`;
    }

    if (window.location.protocol === "https:") {
        cookieString += "; secure";
    }
    document.cookie = cookieString;
};

export const getCookieData = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
};

export const clearAllCookies = () => {
    const hostname = window.location.hostname;
    const isLocal =
        process.env.VITE_NODE_ENV === "local" ||
        hostname === "localhost" ||
        hostname.startsWith("127.");
    const domainParts = hostname.split(".");
    const domain = isLocal ? "" : `domain=${domainParts.slice(-2).join(".")};`;
    const cookies = document.cookie.split(";");
    each(cookies, (cookie) => {
        const cookieName = decodeURIComponent(cookie.split("=")[0].trim());
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; ${isLocal ? "" : domain.length ? domain : hostname
            }`;
    });
};

export const decodeRefreshTokenMetaData = () => {
    const cookieValue = getCookieData("refresh_meta_data");
    const decodedCookie = decodeURIComponent(cookieValue);
    return cookieValue
        ? JSON.parse(decodedCookie)
        : {
            exp: 0,
            iat: 0,
            jti: "",
        };
};

export const updateProductMapping = async (
    updateConfig: TProductMappingUpdateConfig | TUpdateConfigBulkProductMapping
) => {
    try {
        const response = await sendRequest({
            type: `products/mapping`,
            method: "PUT",
            data: updateConfig,
        });

        return response;
    } catch (err: any) {
        showToast("danger", "Failed to update product mapping!");
        Sentry.captureException(err);
    }
};

export const encryptData = (data: string) => {
    const secretKey = process.env.VITE_ENCRYPTION_SECRET;
    const IV = process.env.VITE_IV;

    const environment = process.env.VITE_NODE_ENV;

    if (
        (!secretKey && !IV) ||
        environment === "local" ||
        environment === "development"
    ) {
        return data;
    }

    const IVParsed = CryptoJS.enc.Hex.parse(IV);
    // Encrypt the JSON string with AES-CBC, using the fixed IV
    const encrypted = CryptoJS.AES.encrypt(
        data,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
            iv: IVParsed,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return encrypted.toString();
};

export const decryptData = (encryptedData: string) => {
    const secretKey = process.env.VITE_ENCRYPTION_SECRET;
    const IV = process.env.VITE_IV;
    const environment = process.env.VITE_NODE_ENV;

    if (
        (!secretKey && !IV) ||
        environment === "local" ||
        environment === "development"
    ) {
        return encryptedData;
    }

    const IVParsed = CryptoJS.enc.Hex.parse(IV);
    // Decrypt the data using AES-CBC with the same IV
    const decrypted = CryptoJS.AES.decrypt(
        encryptedData,
        CryptoJS.enc.Utf8.parse(secretKey),
        {
            iv: IVParsed,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    // Parse the decrypted JSON string
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    return jsonString;
};

export const growthbook = new GrowthBook({
    apiHost: process.env.VITE_GROWTHBOOK_API_HOST,
    clientKey: process.env.VITE_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: process.env.VITE_NODE_ENV === "local" ? true : false,
});

export const getDecryptedUserDetails = () => {
    const userData: string | null = localStorage.getItem("userData");
    if (!userData || userData === null || userData === "{}") {
        // Check if the page has already been refreshed
        if (localStorage.getItem("hasRefreshed") === "false") {
            // Set a flag to indicate the page will reload
            localStorage.setItem("hasRefreshed", "true");

            const initialUserData = JSON.stringify({});
            localStorage.setItem("userData", initialUserData);
            // Reload the page
            window.location.reload();
        } else {
            // Clear the refresh flag to avoid infinite reload loop
            localStorage.removeItem("hasRefreshed");
            return {};
        }
    }
    const decryptedUserData = decryptData(userData);
    return JSON.parse(decryptedUserData);
};

export const connectGrowthBook = async () => {
    try {
        await growthbook.init({ timeout: 1000, streaming: true });
    } catch (err) {
        Sentry.captureException(err);
    }
};

export const setQueryParams = (params: Record<string, string[]>) => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    Object.keys(params).forEach((key) => {
        searchParams.set(key, params[key].join(","));
    });

    window.history.replaceState({}, "", url.toString());
};

export const getQueryParams = () => {
    const urlObj = new URL(window.location.href);
    const searchParams = urlObj.searchParams;
    const params: Record<string, any> = {};

    searchParams.forEach((value, key) => {
        const arr = value.split(",");
        params[key] = arr.length === 1 ? value : arr;
    });

    return params;
};

export const getPermissions = async (
    principal: TCerbosPrincipal,
    resources: TCerbosResources
) => {
    try {
        const userData = store.getState().userData.value;
        if (userData?.is_super_admin) {
            const superAdminPrincipal = {
                ...principal,
                roles: [UserRoles.ADMIN],
            };

            const decision = await cerbos.checkResources({
                principal: superAdminPrincipal,
                resources: resources,
            });

            return decision;
        }

        const decision = await cerbos.checkResources({
            principal: principal,
            resources: resources,
        });

        return decision;
    } catch (err) {
        Sentry.captureException(err);
    }
};

export const checkPermissionIsAllowed = (
    cerbosPermissions: ICerbosData,
    resource: ICerbosResource,
    action: TCerbosAction
) => {
    return cerbosPermissions.results.length > 0
        ? cerbosPermissions.isAllowed({
            resource: resource,
            action: action,
        })
        : false;
};

export const checkSubModulesListPermissions = (
    cerbosPermissions: ICerbosData
) => {
    const disableRoute: Array<string> = [];

    let resource = CerbosResources.CAMPAIGNS;
    let action = "";
    action = CampaignsActions.LIST_CAMPAIGN;

    const canListCampaign = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.PORTFOLIOS;
    action = PortfoliosActions.LIST_PORTFOLIOS;
    const canListPortfolio = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.ADGROUPS;
    action = AdgroupsActions.LIST_ADGROUP;
    const canListAdGroups = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.KEYWORDS;
    action = KeywordsActions.LIST_KEYWORD;
    const canListKeyword = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.PRODUCTS;
    action = ProductsActions.LIST_PRODUCTS;
    const canListProduct = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.HISTORY;
    action = HistoryActions.CAN_VIEW_HISTORY;
    const canViewHistory = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.REPORTS;
    action = ReportsActions.VIEW_REPORT;
    const canViewReports = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.KEYWORDS;
    action = KeywordsActions.LIST_NEGATIVE;
    const canListNegativeKeywords = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.SEARCH_TERM_ANALYTICS;
    action = SearchTermAnalyticsActions.LIST_SEARCHTERM;
    const canListSearchTermAnalytics = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.RULES;
    action = RulesActions.LIST_RULE;
    const canListRules = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.COMMON_PERMISSIONS;
    action = CommonPermissionsActions.CAN_MANAGE_ADMIN_SETTINGS;
    const canManageAdminSettings = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    resource = CerbosResources.REVIEWS;
    action = ReviewActions.CAN_VIEW_REVIEW;
    const canViewReviews = checkPermissionIsAllowed(
        cerbosPermissions,
        { kind: resource, id: resource },
        action
    );

    if (!canListCampaign) {
        disableRoute.push(SubModule.CAMPAIGN as string);
    }
    if (!canListPortfolio) {
        disableRoute.push(SubModule.PORTFOLIO as string);
    }
    if (!canListAdGroups) {
        disableRoute.push(SubModule.ADGROUP as string);
    }
    if (!canListKeyword) {
        disableRoute.push(SubModule.KEYWORD as string);
    }
    if (!canListProduct) {
        disableRoute.push(SubModule.PRODUCT as string);
        disableRoute.push(ParentModule.PRODUCT_ANALYTICS as string);
    }
    if (!canViewHistory) {
        disableRoute.push(ParentModule.CHANGE_LOG as string);
    }
    if (!canViewReports) {
        disableRoute.push(ParentModule.COMMON_REPORTS as string);
    }
    if (!canListNegativeKeywords) {
        disableRoute.push(ParentModule.NEGATIVE_KEYWORDS as string);
    }
    if (!canListSearchTermAnalytics) {
        disableRoute.push(ParentModule.KEYWORD_ANALYTICS as string);
    }
    if (!canListRules) {
        disableRoute.push(ParentModule.RULES as string);
    }
    if (!canManageAdminSettings) {
        disableRoute.push(ParentModule.ADMIN_SETTINGS);
    }
    if (!canViewReviews) {
        disableRoute.push(ParentModule.REVIEW_ANALYTICS);
    }

    return disableRoute;
};

export const mergePermissions = (
    basePermissions: TCerbosResources,
    additionalPermissions: TCerbosResources
): TCerbosResources => {
    const updatedPermissions: TCerbosResources = [...basePermissions];

    additionalPermissions.forEach((additionalResource) => {
        const existingResource = updatedPermissions.find(
            (resource) =>
                resource.resource.id === additionalResource.resource.id
        );

        if (existingResource) {
            // If the resource exists, merge actions (avoiding duplicates)
            existingResource.actions = Array.from(
                new Set([
                    ...existingResource.actions,
                    ...additionalResource.actions,
                ])
            );
        } else {
            updatedPermissions.push(additionalResource);
        }
    });

    return updatedPermissions;
};

export const isDisabledUI = (params: Array<string>): boolean => {
    return params?.some((param) => DISABLED_STATES.includes(param));
};

export const convertIsoDate = (
    isoString: string,
    timeZone?: string
): string => {
    // Convert the ISO string to the specified time zone
    const dateWithZone = timeZone
        ? dayjs(isoString).tz(timeZone)
        : dayjs(isoString).utc();

    // Format the date
    const formattedDate = dateWithZone.format("DD-MM-YYYY HH:mm A");

    return formattedDate;
};

export const formatTimestampForDisplay = (
    timestamp: number | null,
    clientTimezone: string,
    format = "MMM DD, YYYY HH:mm"
): string => {
    if (!timestamp) return "";
    return dayjs
        .utc(timestamp * 1000)
        .tz(clientTimezone)
        .format(format);
};

export const fetchChannelsForClientIds = async (
    record: IUserRecord,
    groups: ClientGroup[]
) => {
    const channels2D = await Promise.all(
        groups.map(async (group) => {
            try {
                const allClientChannels = await getAllChannelsForClientIds(
                    group.clients
                );

                if (group.channels?.length) {
                    group.channels = group.channels.filter((channelId) =>
                        allClientChannels.some(
                            (channel: IUserChannelAccess) =>
                                channel.channel_id === channelId
                        )
                    );
                }
                return allClientChannels;
            } catch (err) {
                console.error("Error fetching channels for client group:", err);
                return [];
            }
        })
    );

    return channels2D;
};

export const groupClientsOnAccessConfig = (record: IUserRecord) => {
    const groups: ClientGroup[] =
        Object.values(
            record.access?.reduce(
                (acc: Record<string, ClientGroup>, accessData: any) => {
                    const roleId = accessData.role_id;
                    const platforms = accessData.platforms || [];
                    const privileges = accessData.privileges || [];

                    // Extract channel IDs for this access
                    const channelIds: Array<number> = accessData.channels.map(
                        (channel: IChannels) => channel.channel_id
                    );
                    // Create a unique key for grouping
                    const configKey = JSON.stringify({
                        platforms: platforms.sort(),
                        role_id: roleId,
                        privileges: [...privileges].sort(),
                        channels: channelIds.sort(),
                    });

                    const clientIds = pluck(accessData.clients, "client_id");

                    // Group by the configKey
                    if (acc[configKey]) {
                        acc[configKey].clients?.push(...clientIds);
                    } else {
                        acc[configKey] = {
                            clients: clientIds,
                            platforms,
                            role_id: roleId,
                            privileges,
                            channels: channelIds,
                        };
                    }
                    return acc;
                },
                {}
            )
        ) || [];

    return groups;
};

export const addReportUser = async (data: {
    userName: string;
    password: string;
}) => {
    try {
        const response = await sendRequest({
            type: "reports/users",
            method: "POST",
            data,
        });

        return response;
    } catch (err) {
        Sentry.captureException(err);
    }
};

export const getAllReportUsers = async ({
    page,
    pageSize,
    searchQuery,
}: {
    page: number;
    pageSize: number;
    searchQuery?: string;
}) => {
    try {
        const response = await sendRequest({
            type: `reports/users`,
            method: "GET",
            data: {
                page,
                pageSize,
                searchQuery,
            },
        });

        return response;
    } catch (err) {
        Sentry.captureException(err);
    }
};

export const updateReportUser = async (data: {
    userId: number;
    userName: string;
    password: string;
}) => {
    try {
        const response = await sendRequest({
            type: `reports/users/${data.userId}`,
            method: "PUT",
            data,
        });

        return response;
    } catch (err) {
        Sentry.captureException(err);
    }
};

export const deleteReportUser = async (data: { id: number }) => {
    try {
        const { id } = data;
        const response = await sendRequest({
            type: `reports/users/${id}`,
            method: "DELETE",
        });

        return response;
    } catch (err) {
        Sentry.captureException(err);
    }
};
export const reactivateUser = async (uid: string) => {
    try {
        const response = await sendRequest({
            type: `user/reactivate/${uid}`,
            method: "PATCH",
        });

        return response;
    } catch (err) {
        console.error(err);
        Sentry.captureException(err);
    }
};

export const filterSelectOptionsWithIdAndName = (
    input: string,
    childrenProps: TSelectOptionsChildrenProps
): boolean => {
    // Extract the first child's content (e.g., "Bajaj Electricals Limited-Bajaj_Lights (IN)")
    const firstChild =
        childrenProps.length > 0 && typeof childrenProps[0] === "string"
            ? childrenProps[0].toLowerCase()
            : "";

    // Extract the second child's content (e.g., "631##")
    const secondChild =
        childrenProps.length > 1 &&
            typeof childrenProps[1] === "object" &&
            childrenProps[1]?.props?.children
            ? childrenProps[1]?.props?.children.toString()
            : "";

    // Perform the filtering logic
    // Partial match for the first child
    const matchesFirstChild = firstChild.includes(input.toLowerCase());

    // Exact match for the second child
    const matchesSecondChild = secondChild === input;

    // Return true if either condition matches
    return matchesFirstChild || matchesSecondChild;
};

export const createMediaPlan = async (planInfo: ICreateMediaPlan) => {
    try {
        const response = await sendRequest({
            type: `media-planning/create`,
            method: "POST",
            data: planInfo,
        });

        return response;
    } catch (err: any) {
        Sentry.captureException(err);
    }
};

export const editMediaPlan = async (planInfo: IEditMediaPlan) => {
    try {
        const response = await sendRequest({
            type: `media-planning/edit`,
            method: "POST",
            data: planInfo,
        });

        return response;
    } catch (err: any) {
        Sentry.captureException(err);
    }
};

export const listMediaPlans = async () => {
    store.dispatch(setMediaPlanListLoading(true));
    try {
        const response = await sendRequest({
            type: `media-planning/list`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error("Failed to fetch media plan list!");
        }

        store.dispatch(setMediaPlanningList(response.rows));
        return response.message;
    } catch (err: any) {
        Sentry.captureException(err);
        return [];
    } finally {
        store.dispatch(setMediaPlanListLoading(false));
    }
};

export const disableMediaPlan = async (planId: number) => {
    try {
        const response = await sendRequest({
            type: `media-planning/archive/${planId}`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        showToast("success", `Plan archived successfully!`);
        return response.status;
    } catch (err: any) {
        showToast("danger", "Failed to delete media plan!");
        Sentry.captureException(err);
    }
};

export const onMediaPlanGridModelUpdated = ({ api }: TApi) => {
    const data = (api as any).filterManager.rowModel.rowsToDisplay.map(
        (row: RowNode) => row.data
    );
    data.length && populateTotalRow({ api, data });
};

export const getEditedPlanLevelConfig = (params: ICellRendererParams) => {
    const mediaPlanData: TMediaPlanRowData =
        store.getState().generateMediaPlanData.value;

    const editedPlanLevel = params.columnApi
        .getAllColumns()[0]
        .getColDef().headerName;

    const editedPlanRecordKey =
        GENERATE_MEDIA_PLAN_CONFIG[editedPlanLevel]?.fieldColumn ||
        GENERATE_MEDIA_PLAN_CONFIG["Default"].fieldColumn;

    const editedPlanRecord = params.data[editedPlanRecordKey];

    const editPlanRecordData = find(
        mediaPlanData[editedPlanLevel],
        (record: IMediaPlanRowObj) =>
            record[editedPlanRecordKey] === editedPlanRecord
    );

    return {
        editedPlanLevel,
        editedPlanRecordKey,
        editedPlanRecord,
        editPlanRecordData,
    };
};

export const getMediaPlanChangeLogs = async (planId: number) => {
    try {
        const response = await sendRequest({
            type: `media-planning/logs/${planId}`,
            method: "GET",
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response.rows;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

/**
 * Plan has to be adjusted as per the budget that is being set.
 * Happens when the plan is initially generated or when the budget is changed.
 *
 * @param mediaPlanData - existing plan data that is to be adjusted
 * @param planBudget - budget according to which the plan data is to be adjusted.
 *
 * @returns - adjusted plan data as per the budget that is set.
 */

export const adjustOverallMediaPlanData = (
    mediaPlanData: TMediaPlanRowData,
    planBudget: number
) =>
    mapObject(mediaPlanData, (planItems, planLevel) => {
        const planLevelTotalSpend = reduce(
            planItems,
            (acc: number, planRecord: IMediaPlanRowObj) => {
                return (acc += Number(planRecord.spend));
            },
            0
        );

        if (planLevelTotalSpend === 0) return planItems;

        const percentToAdjust =
            (planBudget - planLevelTotalSpend) / planLevelTotalSpend;

        return map(planItems, (item) => {
            return getAdjustedPlanRecord({
                recordToAdjust: item,
                percentToAdjust,
                absoluteMetrics: [...ABSOLUTE_PLAN_METRICES, PlanMetrics.SPEND],
                ratioMetrics: RATIO_PLAN_METRICES,
            });
        });
    });

/**
 * Adjusts the record on which edit was made proportionately as per the spend % change
 *
 * @param recordToAdjust - record on which the edit has been made
 * @param percentToAdjust - percentage change that is to be made
 * @param absoluteMetrics - absolute metrics that are to be adjusted
 * @param ratioMetrics - ratio metrics that are to be calculated basis the updated absolute metrics
 * @param isIndividualSpendUpdate - flag to check if the edit is an individual record's spend change.
 *                                  In case it is - pass the updated spend value too for ratio calculation.
 * @param recordSpend - spend value to be passed in case it is an individual spend update.
 *
 * @returns - adjusted plan record that was modified.
 */

export const getAdjustedPlanRecord = ({
    recordToAdjust,
    percentToAdjust,
    absoluteMetrics,
    ratioMetrics,
    isIndividualSpendUpdate,
    recordSpend,
}: {
    recordToAdjust: IMediaPlanRowObj;
    percentToAdjust: number;
    absoluteMetrics: string[];
    ratioMetrics: string[];
    isIndividualSpendUpdate?: boolean;
    recordSpend?: number;
}) => {
    const adjustedMetrics = mapObject(
        pick(recordToAdjust, absoluteMetrics),
        (value) => Math.round(Number(value) * (1 + percentToAdjust))
    );

    const updatedRatioMetrics = mapObject(
        pick(recordToAdjust, ratioMetrics),
        (value, key) =>
            calculateRatio(
                key,
                !isIndividualSpendUpdate
                    ? adjustedMetrics
                    : {
                        ...adjustedMetrics,
                        spend: recordSpend,
                    }
            )
    );

    return {
        ...recordToAdjust,
        ...adjustedMetrics,
        ...updatedRatioMetrics,
    };
};

/**
 * Saves the metric mapping corresonding to each plan level that is modified.
 * To be used for change logs/versioning
 *
 * @param editedPlanLevel - plan level that is modified
 * @param editedPlanRecord - plan level's record data that is modified
 * @param params - cell renderer params
 */

export const saveMediaPlanEditConfig = (
    editedPlanLevel: string,
    editedPlanRecord: string,
    params: ICellRendererParams
) => {
    const mediaPlanEditConfig: TMediaPlanEditConfig =
        store.getState().mediaPlanEditConfig.value;

    const modifiedPlanMetrics =
        mediaPlanEditConfig[editedPlanLevel]?.[editedPlanRecord] || [];

    store.dispatch(
        setMediaPlanEditConfig({
            ...mediaPlanEditConfig,
            [editedPlanLevel]: {
                ...mediaPlanEditConfig[editedPlanLevel],
                [editedPlanRecord]: uniq([
                    ...modifiedPlanMetrics,
                    params.colDef.field,
                ]),
            },
        })
    );
};

/**
 * Compares the existing and the updated plan record data
 * Computes the difference across each metric
 * Returns the computed metric mapping for ratio calculation.
 *
 * @param editedPlanRecordData - existing plan record data
 * @param updatedRecordData - adjusted plan record data
 * @param spendValue - spend value of that record being passed explicitly since its not part of ABSOLUTE_PLAN_METRICES by default
 *
 * @returns - the absolute metric values that are to be adjusted across the plan
 */

export const getAbsoluteMetricsToAdjust = (
    editedPlanRecordData: IMediaPlanRowObj,
    updatedRecordData: IMediaPlanRowObj,
    spendValue: number
) =>
    reduce(
        ABSOLUTE_PLAN_METRICES,
        (diff: IMediaPlanRowObj, metric: string) => {
            if (editedPlanRecordData[metric] !== updatedRecordData[metric]) {
                diff[metric] =
                    Number(updatedRecordData[metric]) -
                    Number(editedPlanRecordData[metric]);
            } else {
                diff[metric] = editedPlanRecordData[metric];
            }
            return diff;
        },
        // adding changed spend value by default to the adjusted object
        { spend: spendValue }
    );

/**
 *
 * @param mediaPlanData - Existing plan data to be adjusted
 * @param editedPlanLevel - Plan level that has been modified
 * @param editedPlanRecordKey - Unique key identifier of the plan level's record that has been updated
 * @param editedPlanRecord - Existing record data that is being modified .
 * @param modifiedRecord - Partially updated record data containing a boolean flag that the row has been modified for future tracking
 * @param finalUpdatedRecord - adjusted record data with updated absolute/ratio metrics
 * @param absoluteMetricesToAdjust - Absolute metrics to be proportionally adjusted across items in each plan level
 * @param isRatioEdit - flag to identify if the edit is a ratio edit or not
 *
 * @returns - Adjusted plan data with updated absolute and ratio metrics when change is made at an overall level.
 */

export const getOverallAdjustedPlanData = ({
    mediaPlanData,
    editedPlanLevel,
    editedPlanRecordKey,
    editedPlanRecord,
    modifiedRecord,
    finalUpdatedRecord,
    absoluteMetricesToAdjust,
    isRatioEdit = false,
}: {
    mediaPlanData: TMediaPlanRowData;
    editedPlanLevel: string;
    editedPlanRecordKey: string;
    editedPlanRecord: string;
    modifiedRecord: IMediaPlanRowObj;
    finalUpdatedRecord: IMediaPlanRowObj;
    absoluteMetricesToAdjust: IMediaPlanRowObj;
    isRatioEdit: boolean;
}) => {
    try {
        const planData = mapObject(mediaPlanData, (planItems, planLevel) => {
            if (planLevel === editedPlanLevel) {
                // all the records of the impacted level are returned as is.
                // only the edited record is updated.
                return map(planItems, (record: IMediaPlanRowObj) => {
                    if (record[editedPlanRecordKey] === editedPlanRecord) {
                        return finalUpdatedRecord;
                    }
                    return record;
                });
            }

            // calculate total plan level metrics
            const planLevelTotalMetrics: IMediaPlanRowObj = reduce(
                mediaPlanData[planLevel],
                (acc: IMediaPlanRowObj, planRecord: IMediaPlanRowObj) => {
                    [...ABSOLUTE_PLAN_METRICES, PlanMetrics.SPEND].forEach(
                        (metric) => {
                            acc[metric] =
                                (Number(acc[metric]) || 0) +
                                Number(planRecord[metric]);
                        }
                    );

                    return acc;
                },
                {}
            );

            //each item(row) is adjusted as per its weight in the respective level.
            return map(planItems, (record: IMediaPlanRowObj) =>
                getAdjustedMetrices({
                    planRecord: record,
                    modifiedRecord,
                    isRatioEdit,
                    planLevelTotalMetrics,
                    absoluteMetricesToAdjust,
                    isOverallAdjustment: true,
                })
            );
        });

        return {
            adjustmentStatus: true,
            planData,
        };
    } catch (err: any) {
        return {
            adjustmentStatus: false,
            planData: mediaPlanData,
            errMessage: err.message,
        };
    }
};

/**
 *
 * @param mediaPlanData - Existing plan data to be adjusted
 * @param editedPlanLevel - Plan level that has been modified
 * @param editedPlanRecordKey - Unique key identifier of the plan level's record that has been updated
 * @param editedPlanRecord - Existing record data that is being modified .
 * @param modifiedRecord - Partially updated record data containing a boolean flag that the row has been modified for future tracking
 * @param finalUpdatedRecord - adjusted record data with updated absolute/ratio metrics
 * @param absoluteMetricesToAdjust - Absolute metrics to be proportionally adjusted across items within that specific plan level in which the change was made.
 * @param isRatioEdit - flag to identify if the edit is a ratio edit or not
 *
 * @returns - Adjusted plan data with updated absolute and ratio metrics when change is made within plan.
 */

export const getAdjustedWithinPlanData = ({
    mediaPlanData,
    editedPlanLevel,
    editedPlanRecordKey,
    editedPlanRecord,
    modifiedRecord,
    finalUpdatedRecord,
    absoluteMetricesToAdjust,
    isRatioEdit = false,
}: {
    mediaPlanData: TMediaPlanRowData;
    editedPlanLevel: string;
    editedPlanRecordKey: string;
    editedPlanRecord: string;
    modifiedRecord: IMediaPlanRowObj;
    finalUpdatedRecord: IMediaPlanRowObj;
    absoluteMetricesToAdjust: IMediaPlanRowObj;
    isRatioEdit: boolean;
}) => {
    try {
        const planData = mapObject(mediaPlanData, (planItems, planLevel) => {
            if (planLevel !== editedPlanLevel) {
                return planItems;
            }

            const planLevelTotalMetrics = mediaPlanData[planLevel].reduce(
                (acc: Record<string, number>, planRecord: IMediaPlanRowObj) => {
                    if (
                        planRecord[editedPlanRecordKey] !== editedPlanRecord &&
                        !planRecord?.isRowModified
                    ) {
                        [...ABSOLUTE_PLAN_METRICES, PlanMetrics.SPEND].forEach(
                            (metric) => {
                                acc[metric] =
                                    (acc[metric] || 0) +
                                    Number(planRecord[metric]);
                            }
                        );
                    }
                    return acc;
                },
                {}
            );

            return map(planItems, (record: IMediaPlanRowObj) => {
                if (planItems.length === 1)
                    throw new Error("Only one record exists at this level");

                const unModifiedPlanItemsExist = filter(
                    planItems,
                    (item) => !item?.isRowModified
                ).length;

                if (!unModifiedPlanItemsExist)
                    throw new Error("All rows have already been modified!");

                if (record[editedPlanRecordKey] === editedPlanRecord) {
                    return finalUpdatedRecord;
                }

                if (record?.isRowModified) {
                    return record;
                }

                return getAdjustedMetrices({
                    planRecord: record,
                    modifiedRecord,
                    isRatioEdit,
                    planLevelTotalMetrics,
                    absoluteMetricesToAdjust,
                    isOverallAdjustment: false,
                });
            });
        });

        return {
            adjustmentStatus: true,
            planData,
        };
    } catch (err: any) {
        return {
            adjustmentStatus: false,
            planData: mediaPlanData,
            errMessage: err.message,
        };
    }
};

/**
 * Adjusts metric values proportionally based on the modified record's attributes.
 *
 * @param planRecord - The original plan record to be adjusted.
 * @param modifiedRecord - The modified record with updated metric values.
 * @param isRatioEdit - Flag indicating if a ratio metric is being edited.
 * @param planLevelTotalMetrics - Aggregated total metrics for the plan level.
 * @param absoluteMetricesToAdjust - Absolute metrics to be proportionally adjusted.
 * @param isOverallAdjustment - Flag indicating whether the adjustment is within a specific plan level or at an overall level.
 *
 * @returns - The adjusted plan record with updated absolute and ratio metrics.
 */

const getAdjustedMetrices = ({
    planRecord,
    modifiedRecord,
    isRatioEdit,
    planLevelTotalMetrics,
    absoluteMetricesToAdjust,
    isOverallAdjustment,
}: {
    planRecord: IMediaPlanRowObj;
    modifiedRecord: IMediaPlanRowObj;
    isRatioEdit: boolean;
    planLevelTotalMetrics: IMediaPlanRowObj;
    absoluteMetricesToAdjust: IMediaPlanRowObj;
    isOverallAdjustment: boolean;
}) => {
    {
        const adjustedMetrices = Object.keys(modifiedRecord);

        //adjust absolute metrics according to the attributes that are modified.
        const adjustedAbsoluteMetrics = mapObject(
            pick(planRecord, [...ABSOLUTE_PLAN_METRICES, PlanMetrics.SPEND]),
            (value: string | number | boolean, key: string) => {
                // if the metric is not in the adjusted metrics and it is a ratio edit, return the existing value itself
                if (isRatioEdit && !adjustedMetrices.includes(key)) {
                    return value;
                }

                const weightedPercentage =
                    Number(planRecord[key]) /
                    Number(planLevelTotalMetrics[key]);

                const adjustmentFactor =
                    Number(absoluteMetricesToAdjust[key]) || 0;

                const adjustmentValue = weightedPercentage * adjustmentFactor;

                const calculatedValue = Math.round(
                    isOverallAdjustment
                        ? Number(value) + adjustmentValue
                        : Number(value) - adjustmentValue
                );

                if (calculatedValue < 0)
                    throw new Error("Some records out of bounds!");

                return calculatedValue;
            }
        );

        const updatedRatioMetrics = getUpdatedRatioMetrics(
            planRecord,
            adjustedAbsoluteMetrics as Record<string, number>
        );

        return {
            ...planRecord,
            ...adjustedAbsoluteMetrics,
            ...updatedRatioMetrics,
        };
    }
};

export const compareMediaPlanData = (
    originalPlanDataMap: TMappedPlanData,
    editedPlanDataMap: TMappedPlanData
) => {
    // metrics that are changed in the current version
    const mediaPlanEditConfig = store.getState().mediaPlanEditConfig.value;

    const modifiedMetrices: TMediaPlanChangeLogs = {};
    const modifiedPlanData: TMediaPlanRowData = {};

    const processValue = (value: number, isAbsoluteMetric: boolean) => {
        return isAbsoluteMetric ? Math.round(value) : value;
    };

    // Compare each plan level
    for (const [origPlanLevel, origPlanLevelData] of originalPlanDataMap) {
        const editedRecords = editedPlanDataMap.get(origPlanLevel);
        if (!editedRecords) {
            //skip plan levels where no edits were made
            continue;
        }

        modifiedPlanData[origPlanLevel] = [];
        const planLevelChanges: TPlanLevelChanges = {};

        // Compare each record within the plan level
        for (const [recordKey, originalRecord] of origPlanLevelData) {
            const editedRecord = editedRecords.get(recordKey);

            if (!editedRecord || isEqual(editedRecord, originalRecord)) {
                //skip records where no edits were made
                // or where the edited record is the same as the original record
                continue;
            }

            const recordChanges: TPlanRecordChanges = {};
            const editedRecordData: IMediaPlanRowObj = {};
            let hasChanges = false;

            // Compare each field in the record
            Object.keys(originalRecord).forEach((field: string) => {
                const isAbsoluteMetric = [
                    ...ABSOLUTE_PLAN_METRICES,
                    PlanMetrics.SPEND,
                ].includes(field);

                const processedOriginalValue = processValue(
                    Number(originalRecord[field]),
                    isAbsoluteMetric
                );
                const processedEditedValue = processValue(
                    Number(editedRecord[field]),
                    isAbsoluteMetric
                );

                // if the original and edited value are not same - then include them in logs
                if (!isEqual(processedOriginalValue, processedEditedValue)) {
                    const editedFields: string[] =
                        mediaPlanEditConfig?.[
                        origPlanLevel as keyof typeof mediaPlanEditConfig
                        ]?.[recordKey] || [];
                    //for history - tracking only want to track the fields that are being edited
                    if (editedFields.includes(field)) {
                        recordChanges[field] = {
                            from: processedOriginalValue,
                            to: processedEditedValue,
                        };
                        hasChanges = true;
                    }

                    // for versioning - only inserting records that have been edited
                    editedRecordData[field] = processedEditedValue;
                } else {
                    editedRecordData[field] = processedOriginalValue;
                }
            });

            modifiedPlanData[origPlanLevel].push({
                recordKey,
                planDataMetrices: pick(
                    editedRecordData,
                    MEDIA_PLAN_METRICES
                ) as any,
            });

            if (hasChanges) {
                planLevelChanges[recordKey] = recordChanges;
            }
        }

        if (Object.keys(planLevelChanges).length > 0) {
            modifiedMetrices[origPlanLevel] = planLevelChanges;
        }
    }

    return {
        planData: modifiedPlanData,
        modifiedMetrices,
    };
};

export const getMappedPlanData = (
    planData: TMediaPlanRowData
): TMappedPlanData => {
    const mappedPlanData = new Map();
    Object.keys(planData).forEach((planLevel) => {
        mappedPlanData.set(
            planLevel,
            new Map(planData[planLevel].map((item) => [item.recordKey, item]))
        );
    });
    return mappedPlanData;
};

export const getUpdatedRatioMetrics = (
    recordData: IMediaPlanRowObj,
    newAbsoluteMetrics: Record<string, number>
) =>
    mapObject(pick(recordData, RATIO_PLAN_METRICES), (value, key) =>
        calculateRatio(key, newAbsoluteMetrics)
    );

export const resetMediaPlanningConfig = () => {
    store.dispatch(updateShowNewMediaPlanDisplay(false));
    store.dispatch(setMediaPlanConfigValues({} as TMediaPlanConfig));
    store.dispatch(setGenerateMediaPlanData({}));
    store.dispatch(resetMediaPlanGridApiMap({}));
    store.dispatch(resetMediaPlanEditConfig({}));
    store.dispatch(setIsMediaPlanEdit(false));
    store.dispatch(setIsMediaPlanCreate(false));
};

export const logOut = async () => {
    try {
        await sendRequest({
            type: "auth/logout",
            method: "POST",
        });
        return true;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
        return false;
    }
};
export const modifySentryCrashModalStyles = (userDetails: User) => {
    // Check if the style is already applied
    if (document.getElementById("sentry-crash-report-modal-custom-styles")) {
        return;
    }

    const style = document.createElement("style");
    style.id = "sentry-crash-report-modal-custom-styles";

    style.innerHTML = `
        .sentry-error-embed .powered-by {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
            height: 0 !important;
            width: 0 !important;
        }
        ${userDetails?.user_id
            ? `
            .sentry-error-embed input[name="name"],
            .sentry-error-embed input[name="email"] {
                pointer-events: none;
                background-color: #f3f3f3;
            }
        `
            : ""
        }
    `;

    document.head.appendChild(style);
};

/**
 * Removes the initial loader and prepares the DOM for displaying the Sentry crash report modal
 */
export const prepareForSentryModal = () => {
    // Remove the initial loader
    const initialLoader = document.getElementById("initial-loader");
    if (initialLoader) {
        initialLoader.remove();
    }

    // Ensure root element exists and is empty for Sentry to mount into
    const rootElement = document.getElementById("root");
    if (rootElement && rootElement.children.length === 0) {
        // Create a minimal container to ensure Sentry has something to work with
        const errorContainer = document.createElement("div");
        errorContainer.id = "error-container";
        errorContainer.style.cssText = `
            min-height: 100vh;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ffffff;
        `;
        rootElement.appendChild(errorContainer);
    }
};

export const showSentryCrashReportModal = (
    showModal: boolean,
    error: any,
    userDetails?: User
) => {
    // Prepare DOM for Sentry modal
    prepareForSentryModal();

    // Inject CSS to hide logo & disable name/email fields if user exists
    modifySentryCrashModalStyles(userDetails);

    const eventId = Sentry.captureException(error);
    if (showModal) {
        Sentry.showReportDialog({
            eventId,
            user: userDetails
                ? {
                    name: `${userDetails.first_name} ${userDetails.last_name} `,
                    email: userDetails.email,
                }
                : undefined,
            onClose: () => {
                store.dispatch(updateErrorStatusCode(false));
            },
        });
    }
};

export const validatePlanData = (planData: TMediaPlanRowData) =>
    Object.entries(planData).reduce((acc, [planLevel, planItems]) => {
        planItems.forEach(({ recordKey, planDataMetrices }) => {
            MEDIA_PLAN_METRICES.forEach((metric: string) => {
                const value =
                    planDataMetrices[metric as keyof typeof planDataMetrices];

                if (!value) return;

                if (isNaN(+value) || !isFinite(+value))
                    acc.push({
                        planLevel,
                        recordKey,
                        metric,
                        value,
                    });
            });
        });

        return acc;
    }, []);

export const orderReports = (reports: IReportsData[]) => {
    return reports
        .slice() // Create a shallow copy to avoid mutating the original array
        .sort((a, b) => {
            if (a.report_order_id === null && b.report_order_id === null)
                return 0;
            if (a.report_order_id === null) return 1; // Place `null` at the bottom
            if (b.report_order_id === null) return -1;
            return a.report_order_id - b.report_order_id;
        });
};
export const setClientTimezone = (tz: string) => {
    store.dispatch(updateClientTimezone(tz));
    sessionStorage.setItem("client_timezone", tz);
};

export const getClientTimezone = () => {
    return sessionStorage.getItem("client_timezone");
};

export const clearClientTimezone = () => {
    sessionStorage.removeItem("client_timezone");
};

export const getProductMappingList = async (
    params: IProductMappingListParams
) => {
    try {
        const response = await sendRequest({
            type: "products/mapping/list",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export const getKeywordMappingList = async (
    params: IProductMappingListParams
) => {
    try {
        const response = await sendRequest({
            type: "keywords/mapping/list",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export const getPfmColFilterValues = async (params: IPfmSkuFilterParams) => {
    try {
        const response = await sendRequest({
            type: "products/mapping/filter-values",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response.rows;
    } catch (err: any) {
        showToast("danger", "Failed to fetch filter values!");
        Sentry.captureException(err);
    }
};

export const formatCategoryOverviewSubCategoryPerformanceData = (
    data: ISubCategoryPerformance[] | null | undefined
): IFormattedSubCategoryPerformance[] => {
    if (!data?.length) return [];

    const roundToTwo = (value: number) => Math.round(value * 100) / 100;

    const getValue = <T>(value: T | null | undefined, defaultValue: T): T =>
        typeof value === "number"
            ? (roundToTwo(value) as T)
            : value ?? defaultValue;

    const createMetric = (
        current: number | null | undefined,
        prev: number | null | undefined
    ): MetricWithDelta => {
        const value = getValue(current, 0);
        if (prev == null || value === 0) return valueDeltaDefault;

        const previous = getValue(prev, 0);
        const delta = round((value - previous) / value);

        return { value, delta };
    };

    return data.map((item) => {
        const format = createMetric;
        return {
            [CommonWidgetMetrics.SUB_CATEGORY]: getValue(
                item.tag_subcategory,
                "N/A"
            ),
            [CommonWidgetMetrics.MS]: {
                revenue: format(item.revenue, item.prev_revenue),
                units: format(item.upd, item.prev_upd),
            },
            [CommonWidgetMetrics.MARKET_SIZE]: {
                revenue: format(item.revenue_size, item.prev_revenue_size),
                units: format(item.upd_size, item.prev_upd_size),
            },
            [CommonWidgetMetrics.AD_SALES]: format(item.sale, item.prev_sale),
            [CommonWidgetMetrics.AD_SPENDS]: format(
                item.spend,
                item.prev_spend
            ),
            [CommonWidgetMetrics.ROAS]: format(item.roas, item.prev_roas),
            [CommonWidgetMetrics.ORGANIC_SOV]: format(
                item.org_sov,
                item.prev_org_sov
            ),
            [CommonWidgetMetrics.PAID_SOV]: format(
                item.paid_sov,
                item.prev_paid_sov
            ),
            [CommonWidgetMetrics.SOV]: format(
                item.overall_sov,
                item.prev_overall_sov
            ),
            [CommonWidgetMetrics.RPI]: format(item.rpi, item.prev_rpi),
            [CommonWidgetMetrics.RATING]: format(item.rating, item.prev_rating),
            [CommonWidgetMetrics.REVIEWS]: format(
                item.review_count,
                item.prev_review_count
            ),
            [CommonWidgetMetrics.AVAILABILITY]: format(
                item.availability,
                item.prev_availability
            ),
            [CommonWidgetMetrics.BUYBOX]: format(
                item.buybox_win,
                item.prev_buybox_win
            ),
            [CommonWidgetMetrics.STOCK]: format(
                item.stock_in_hand,
                item.prev_stock_in_hand
            ),
            [CommonWidgetMetrics.COMPARE]: "", // Placeholder
        };
    });
};

export const formatCategoryOverviewDrainersData = (
    data: ICategoryOverviewDrainers[] | null | undefined
): IFormattedDrainerData[] => {
    const getValue = (val: number | null | undefined): number =>
        val !== null && val !== undefined ? val : 0;

    // Return empty array if data is null, undefined, or empty
    if (!data || data.length === 0) {
        return [];
    }

    return data.map((item) => {
        return {
            [CommonWidgetMetrics.SUB_CATEGORY]: item.tag_subcategory,

            [CommonWidgetMetrics.MS]: {
                value: round(getValue(item.cur_revenue_ms)),
                delta: round(
                    (getValue(item.cur_revenue_ms) -
                        getValue(item.prev_revenue_ms)) /
                    getValue(item.cur_revenue_ms)
                ),
            },

            [CommonWidgetMetrics.TOTAL_SALES]: {
                value: round(getValue(item.cur_sale)),
                delta: round(
                    (getValue(item.cur_sale) - getValue(item.prev_sale)) /
                    getValue(item.cur_sale)
                ),
            },

            [CommonWidgetMetrics.AD_SALES]: {
                value: round(getValue(item.cur_sale)),
                delta: round(
                    (getValue(item.cur_sale) - getValue(item.prev_sale)) /
                    getValue(item.cur_sale)
                ),
            },

            [CommonWidgetMetrics.AD_SPENDS]: {
                value: round(getValue(item.cur_spend)),
                delta: round(
                    (getValue(item.cur_spend) - getValue(item.prev_spend)) /
                    getValue(item.cur_spend)
                ),
            },

            [CommonWidgetMetrics.ROAS]: {
                value: round(getValue(item.cur_roas)),
                delta: round(
                    (getValue(item.cur_roas) - getValue(item.prev_roas)) /
                    getValue(item.cur_roas)
                ),
            },

            [CommonWidgetMetrics.CTR]: {
                value: round(getValue(item.cur_ctr)),
                delta: round(
                    (getValue(item.cur_ctr) - getValue(item.prev_ctr)) /
                    getValue(item.cur_ctr)
                ),
            },

            [CommonWidgetMetrics.CTC]: {
                value: round(getValue(item.cur_cpc)),
                delta: round(
                    (getValue(item.cur_cpc) - getValue(item.prev_cpc)) /
                    getValue(item.cur_cpc)
                ),
            },

            [CommonWidgetMetrics.CLICKS]: {
                value: getValue(item.cur_click),
                delta: round(
                    (getValue(item.cur_click) - getValue(item.prev_click)) /
                    getValue(item.cur_click)
                ),
            },

            [CommonWidgetMetrics.ORDERS]: {
                value: getValue(item.cur_orders),
                delta: round(
                    (getValue(item.cur_orders) - getValue(item.prev_orders)) /
                    getValue(item.cur_orders)
                ),
            },

            [CommonWidgetMetrics.IMPRESSIONS]: {
                value: getValue(item.cur_impression),
                delta: round(
                    (getValue(item.cur_impression) -
                        getValue(item.prev_impression)) /
                    getValue(item.cur_impression)
                ),
            },
        };
    });
};

export const formatCategoryOverviewCrossChannelAndCompetitionGraph = (
    data:
        | ICategoryOverviewCrossChannelGraphData[]
        | ICategoryOverviewCompetitionGraphData[]
        | null
        | undefined,
    date: TDate,
    type: MyProductTrendsModules
): ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] => {
    if (!Array.isArray(data)) return [];

    const result: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] =
        [];

    const groupedByDate: Record<
        string,
        (
            | ICategoryOverviewCrossChannelGraphData
            | ICategoryOverviewCompetitionGraphData
        )[]
    > = {};

    // Group by crawl_date
    for (const item of data) {
        const { crawl_date } = item;
        if (!groupedByDate[crawl_date]) {
            groupedByDate[crawl_date] = [];
        }
        groupedByDate[crawl_date].push(item);
    }

    // Format individual items
    for (const item of data) {
        const {
            tag_subcategory = "",
            crawl_date = "",
            roas = 0,
            sale = 0,
            spend = 0,
            total_sales = 0,
            revenue = 0,
            cat_revenue = "cat_revenue" in item ? item.cat_revenue : 0,
        } = item;

        const ms_percent =
            cat_revenue === 0
                ? 0
                : (round(revenue, 2) / round(cat_revenue, 2)) * 100;

        const formattedItem: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem =
        {
            [CommonWidgetMetrics.TAG_SUBCATEGORY]: tag_subcategory,
            [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
            [AggregationField.MS_PERCENT]: round(ms_percent, 2),
            [AggregationField.ROAS]: round(roas, 2),
            [AggregationField.SALE]: round(sale, 2),
            [AggregationField.SPEND]: round(spend, 2),
            [AggregationField.TOTAL_SALES]: round(total_sales, 2),
        };

        if (type === MyProductTrendsModules.CROSS_CHANNEL) {
            formattedItem[CommonWidgetMetrics.NAME] =
                "name" in item ? item.name : "";
        } else if (type === MyProductTrendsModules.COMPETITION) {
            formattedItem[CommonWidgetMetrics.BRAND] =
                "brand" in item ? item.brand : "";
        }

        result.push(formattedItem);
    }

    // Add "all" rows per crawl_date
    for (const [crawl_date, items] of Object.entries(groupedByDate)) {
        const groupedByKey: Record<string, typeof items> = {};

        for (const item of items) {
            const key =
                type === MyProductTrendsModules.CROSS_CHANNEL
                    ? "name" in item
                        ? item.name
                        : ""
                    : "brand" in item
                        ? item.brand
                        : "";

            if (!groupedByKey[key]) {
                groupedByKey[key] = [];
            }

            groupedByKey[key].push(item);
        }

        for (const [key, groupedItems] of Object.entries(groupedByKey)) {
            let totalRevenue = 0;
            let totalCatRevenue = 0;
            let totalRoas = 0;
            let totalSale = 0;
            let totalSpend = 0;
            let totalSales = 0;

            for (const item of groupedItems) {
                totalRevenue += item.revenue;
                totalCatRevenue += item.cat_revenue;
                totalRoas += item.roas;
                totalSale += item.sale;
                totalSpend += item.spend;
                totalSales += item.total_sales;
            }

            const ms_percent =
                totalCatRevenue === 0
                    ? 0
                    : (round(totalRevenue, 2) / round(totalCatRevenue, 2)) *
                    100;

            const aggregatedItem: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem =
            {
                [CommonWidgetMetrics.TAG_SUBCATEGORY]:
                    CommonWidgetMetrics.All,
                [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
                [AggregationField.MS_PERCENT]: round(ms_percent, 2),
                [AggregationField.ROAS]: round(totalRoas, 2),
                [AggregationField.SALE]: round(totalSale, 2),
                [AggregationField.SPEND]: round(totalSpend, 2),
                [AggregationField.TOTAL_SALES]: round(totalSales, 2),
            };

            if (type === MyProductTrendsModules.CROSS_CHANNEL) {
                aggregatedItem[CommonWidgetMetrics.NAME] = key;
            } else if (type === MyProductTrendsModules.COMPETITION) {
                aggregatedItem[CommonWidgetMetrics.BRAND] = key;
            }

            result.push(aggregatedItem);
        }
    }

    //  Sort the final result by crawl_date ascending
    result.sort((a, b) => {
        const dateA = new Date(a[CommonWidgetMetrics.CRAWL_DATE]).getTime();
        const dateB = new Date(b[CommonWidgetMetrics.CRAWL_DATE]).getTime();
        return dateA - dateB;
    });

    return result;
};

export const formatCategoryOverviewComparisonGraph = (
    data: ICategoryOverviewComparisonGraphData[] | null | undefined,
    date: TDate
): ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] => {
    if (!Array.isArray(data)) return [];

    const { startDate, endDate } = date;

    const start = startDate.toDate();
    const end = endDate.toDate();

    const filteredData = filter(data, ({ crawl_date }) => {
        const crawlDate = new Date(crawl_date);
        return crawlDate >= start && crawlDate <= end;
    });

    // Group by crawl_date
    const groupedByDate: Record<
        string,
        ICategoryOverviewComparisonGraphData[]
    > = {};

    for (const item of filteredData) {
        const { crawl_date } = item;
        if (!groupedByDate[crawl_date]) {
            groupedByDate[crawl_date] = [];
        }
        groupedByDate[crawl_date].push(item);
    }

    // Create "all" rows
    const allRows: ICategoryOverviewComparisonGraphData[] = [];

    for (const [crawl_date, items] of Object.entries(groupedByDate)) {
        let revenue_ms = 0;
        let roas = 0;
        let sale = 0;
        let spend = 0;
        let total_sales = 0;

        for (const item of items) {
            revenue_ms += item.revenue_ms || 0;
            roas += item.roas || 0;
            sale += item.sale || 0;
            spend += item.spend || 0;
            total_sales += item.total_sales || 0;
        }

        allRows.push({
            tag_subcategory: CommonWidgetMetrics.All,
            crawl_date,
            revenue_ms: round(revenue_ms, 2),
            roas: round(roas, 2),
            sale: round(sale, 2),
            spend: round(spend, 2),
            total_sales: round(total_sales, 2),
            upd_ms: 0,
        });
    }

    //Combine and sort
    const combinedData = [...filteredData, ...allRows].sort((a, b) => {
        return (
            new Date(a.crawl_date).getTime() - new Date(b.crawl_date).getTime()
        );
    });

    // Map to formatted output
    return combinedData.map((item) => {
        const {
            tag_subcategory = "",
            crawl_date = "",
            revenue_ms = 0,
            roas = 0,
            sale = 0,
            spend = 0,
            total_sales = 0,
        } = item;

        return {
            [CommonWidgetMetrics.TAG_SUBCATEGORY]: tag_subcategory,
            [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
            [AggregationField.MS_PERCENT]: round(revenue_ms, 2),
            [AggregationField.ROAS]: round(roas, 2),
            [AggregationField.SALE]: round(sale, 2),
            [AggregationField.SPEND]: round(spend, 2),
            [AggregationField.TOTAL_SALES]: round(total_sales, 2),
        };
    });
};

export const formatCategoryOverviewComparisonChartData = (
    data: ICategoryOverviewComparisonGraphFormattedData[]
): TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite => {
    const emptyChartData = {
        categories: [""],
        series: [
            {
                name: AggregationField.MS_PERCENT,
                data: [0],
            },
        ],
    };

    const skuTitles = {
        [AggregationField.MS_PERCENT]: "Ms%",
        [AggregationField.ROAS]: "ROAS",
        [AggregationField.SALE]: "Sale",
        [AggregationField.SPEND]: "Ad Spend",
        [AggregationField.TOTAL_SALES]: "Total Sales",
    };

    if (!Array.isArray(data)) {
        return {
            [AggregationField.MS_PERCENT]: {
                chartDataSeries: emptyChartData,
                skuTitles,
            },
            [AggregationField.ROAS]: {
                chartDataSeries: emptyChartData,
                skuTitles,
            },
            [AggregationField.SALE]: {
                chartDataSeries: emptyChartData,
                skuTitles,
            },
            [AggregationField.SPEND]: {
                chartDataSeries: emptyChartData,
                skuTitles,
            },
            [AggregationField.TOTAL_SALES]: {
                chartDataSeries: emptyChartData,
                skuTitles,
            },
        };
    }

    const sortedData = data
        .slice()
        .sort((a, b) => moment(a.crawl_date).diff(moment(b.crawl_date)));

    const categories = sortedData.map((item) => item.crawl_date);

    const msPercentSeries = {
        name: AggregationField.MS_PERCENT,
        data: sortedData.map((item) => item[AggregationField.MS_PERCENT]),
    };

    const roasSeries = {
        name: AggregationField.ROAS,
        data: sortedData.map((item) => item[AggregationField.ROAS]),
    };

    const salesSeries = {
        name: AggregationField.SALE,
        data: sortedData.map((item) => item[AggregationField.SALE]),
    };

    const spendsSeries = {
        name: AggregationField.SPEND,
        data: sortedData.map((item) => item[AggregationField.SPEND]),
    };

    const totalSalesSeries = {
        name: AggregationField.TOTAL_SALES,
        data: sortedData.map((item) => item[AggregationField.TOTAL_SALES]),
    };

    const chartData = {
        categories,
        series: [
            msPercentSeries,
            roasSeries,
            salesSeries,
            spendsSeries,
            totalSalesSeries,
        ],
    };

    const charts = {
        [AggregationField.MS_PERCENT]: {
            chartDataSeries: chartData,
            skuTitles,
        },
        [AggregationField.ROAS]: { chartDataSeries: chartData, skuTitles },
        [AggregationField.SALE]: { chartDataSeries: chartData, skuTitles },
        [AggregationField.SPEND]: { chartDataSeries: chartData, skuTitles },
        [AggregationField.TOTAL_SALES]: {
            chartDataSeries: chartData,
            skuTitles,
        },
    };

    // Return the formatted chart data object
    return charts;
};

export const formatBestSellerSKUTableData = (
    data: IBestSellerSKUData[]
): ICategoryOverviewBestSellerSKUTableRow[] => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    // Step 1: Sort by unit_per_day in descending order
    const sorted = [...data].sort((a, b) => {
        const unitA = a.unit_per_day ?? -Infinity;
        const unitB = b.unit_per_day ?? -Infinity;
        return unitB - unitA;
    });

    // Step 2: Assign rank only to items with valid unit_per_day
    let currentRank = 1;

    return sorted.map((item) => {
        const hasUnit = item.unit_per_day != null;
        const row = {
            sku: item.sku,
            title: item.sku_title,
            rank: hasUnit ? currentRank : "-",
            price: item.price != null ? round(item.price, 2) : "-",
        };
        if (hasUnit) currentRank++;
        return row;
    });
};

export const groupValuesByFeature = (rawData: any[]) => {
    const grouped: Record<
        string,
        { displayName: string; values: Set<string> }
    > = {};

    rawData.forEach(({ feature, value }) => {
        if (!feature || value == null) return;

        const featureKey = feature.toLowerCase();

        if (!grouped[featureKey]) {
            grouped[featureKey] = {
                displayName: feature,
                values: new Set(),
            };
        }

        const titleCaseValue = titleCase(String(value));
        grouped[featureKey].values.add(titleCaseValue);
    });

    return Object.values(grouped).map(({ displayName, values }) => ({
        feature: displayName,
        values: Array.from(values),
    }));
};

export const formatCategoryOverviewCrossChannelAndCompetitionTableData = (
    data: IcategoryOverviewCrossChannelCompetitonComparisonData[],
    groupByKey: CommonWidgetMetrics.NAME | CommonWidgetMetrics.BRAND
): TFormattedCategoryOverviewCrossChannelCompetitonComparisonData[] => {
    if (!Array.isArray(data)) return [];

    const initAggEntry = (
        groupValue: string
    ): TCatOverviewCrossChannelCompetitionComparisonAggEntry =>
    ({
        [groupByKey]: groupValue,
        tag_subcategory: CommonWidgetMetrics.All,
        ...Object.fromEntries(
            catOverviewCompareTablesMetricsToSum.map((key) => [key, 0])
        ),
    } as TCatOverviewCrossChannelCompetitionComparisonAggEntry);

    const grouped: Record<
        string,
        TCatOverviewCrossChannelCompetitionComparisonAggEntry
    > = {};

    for (const item of data) {
        const groupValue = item[groupByKey];
        if (!groupValue) continue;

        if (!grouped[groupValue]) {
            grouped[groupValue] = initAggEntry(groupValue);
        }

        const agg = grouped[groupValue];

        for (const key of catOverviewCompareTablesMetricsToSum) {
            agg[key] += item[key] || 0;
        }
    }

    const allRows = Object.values(
        grouped
    ) as TFormattedCategoryOverviewCrossChannelCompetitonComparisonData[];

    return [...data, ...allRows].map(
        (item) =>
            item as TFormattedCategoryOverviewCrossChannelCompetitonComparisonData
    );
};

export const formatCategoryOverviewComparisonTableData = (
    data: IcategoryOverviewCrossChannelCompetitonComparisonData[]
): IcategoryOverviewCrossChannelCompetitonComparisonData[] => {
    if (!Array.isArray(data)) return [];

    const updatedData = data.map((item) => ({
        ...item,
        name: item.tag_subcategory,
    }));

    const allEntry = {
        tag_subcategory: CommonWidgetMetrics.All,
        name: CommonWidgetMetrics.All,
        ...Object.fromEntries(
            catOverviewComparisonTableMetricsToSum.map((key) => [key, 0])
        ),
    } as IcategoryOverviewCrossChannelCompetitonComparisonData;

    for (const item of updatedData) {
        for (const key of catOverviewComparisonTableMetricsToSum) {
            allEntry[key] += item[key] || 0;
        }
    }

    return [...updatedData, allEntry];
};

export const formatCategoryOverviewData = (
    data: any,
    section: string,
    date: TDate
) => {
    let formattedData: any;

    if (section === CategoryInsightsOverviewSections.CHARTS) {
        formattedData = {
            [CategoryOverviewChartsKeys.BRAND_CONTRIBUTION]:
                formatCategoryOverviewBrandContributionData(
                    data[0]?.brand_contribution
                ),
            [CategoryOverviewChartsKeys.MS_TRENDS_OVER_TIME]:
                formatCategoryOverviewMSTrendsOverTimeData(
                    data[0]?.ms_trend_over_time
                ),
            [CategoryOverviewChartsKeys.SUB_CATEGORIES_CONTRIBUTION]:
                formatCategoryOverviewSubCategoriesData(
                    data[0]?.sub_cat_contribution
                ),
            [CategoryOverviewChartsKeys.MARKET_SHARE_AND_SIZE]:
                formatCategoryOverviewMarketShareAndSizeData(
                    data[0]?.market_share_and_size
                ),
            [CategoryOverviewChartsKeys.CROSS_CHANNEL_GRAPH]:
                formatCategoryOverviewCrossChannelAndCompetitionGraph(
                    data[0]?.my_brand_cross_channel_graph,
                    date,
                    MyProductTrendsModules.CROSS_CHANNEL
                ),
            [CategoryOverviewChartsKeys.CROSS_CHANNEL_TABLE]:
                formatCategoryOverviewCrossChannelAndCompetitionTableData(
                    data[0]?.cross_channel_table,
                    CommonWidgetMetrics.NAME
                ),
            [CategoryOverviewChartsKeys.COMPETITION_GRAPH]:
                formatCategoryOverviewCrossChannelAndCompetitionGraph(
                    data[0]?.my_brand_competition_graph,
                    date,
                    MyProductTrendsModules.COMPETITION
                ),
            [CategoryOverviewChartsKeys.COMPETITION_TABLE]:
                formatCategoryOverviewCrossChannelAndCompetitionTableData(
                    data[0]?.competition_table,
                    CommonWidgetMetrics.BRAND
                ),
        };
    } else if (section === CategoryInsightsOverviewSections.SERP) {
        formattedData = {
            [CategoryOverviewSerpKeys.SUMMARY_WIDGET]:
                formatCategoryOverviewSummaryWidgetData(data),
            [CategoryOverviewSerpKeys.SUB_CATEGORY_PERFORMANCE]:
                formatCategoryOverviewSubCategoryPerformanceData(
                    data[0]?.sub_category_performance_rating_buybox_review_rpi
                ),
            [CategoryOverviewSerpKeys.DRAINERS]:
                formatCategoryOverviewDrainersData(data[0]?.drainers),
            [CategoryOverviewSerpKeys.COMPARISON_TABLE]:
                formatCategoryOverviewComparisonTableData(data[0]?.comparison),
            [CategoryOverviewSerpKeys.COMPARISON_GRAPH]:
                formatCategoryOverviewComparisonGraph(
                    data[0]?.comparison_graph,
                    date
                ),
            [CategoryOverviewSerpKeys.BEST_SELLER_SKU]:
                formatBestSellerSKUTableData(data[0]?.best_seller_sku),
        };
    }

    return formattedData;
};

export const numericChartLabelFormatter = (value: number): string => {
    const thresholds = [
        { limit: 10000000, suffix: "Cr" }, // 1 Crore
        { limit: 100000, suffix: "L" }, // 1 Lakh
        { limit: 1000, suffix: "K" }, // 1 Thousand
    ];

    const matched = find(thresholds, ({ limit }) => value >= limit);

    if (matched) {
        const formatted = (value / matched.limit)
            .toFixed(1)
            .replace(/\.0$/, "");
        return `${formatted}${matched.suffix}`;
    }

    return value.toString();
};

export const apply1DSMapping = async (config: TApply1DSMappingConfig) => {
    try {
        const response = await sendRequest({
            type: "products/mapping/apply",
            method: "POST",
            data: config,
        });

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export const getProductMappingStats = async (
    params: IProductMappingListParams
) => {
    try {
        const response = await sendRequest({
            type: "products/mapping/stats",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export const validateBidOrBudgetValueUpdate = (
    selectedData: Campaign[] | Keyword[],
    inputValue: number,
    operationType: string,
    valueKey: "budget" | "bid"
): boolean => {
    const isValid = selectedData.every((item) => {
        let newValue: number;
        if (operationType === ActionType.PERC_INC) {
            newValue = item[valueKey] + (item[valueKey] / 100) * inputValue;
        } else if (operationType === ActionType.PERC_DEC) {
            newValue = item[valueKey] - (item[valueKey] / 100) * inputValue;
        } else {
            newValue = inputValue;
        }
        return newValue > 0;
    });

    if (!isValid) {
        return window.confirm(
            `Some ${valueKey}s violate the permissible limits. Do you want to set those to the respective permissible limits?`
        );
    }

    return true;
};

export const filterArchivedCampaigns = (
    campaignsSelectionData: Campaign[],
    isCampaignStateAction: boolean
) => {
    const [activeCampaigns, archivedCampaigns] = partition(
        campaignsSelectionData,
        (c) => c.state !== CAMPAIGN_STATES.ARCHIVED
    );

    const archivedCount = archivedCampaigns.length;
    const activeCount = activeCampaigns.length;
    const shouldBlockArchivedEdits = !isCampaignStateAction;

    const hasMixedSelectionWithArchived =
        archivedCount > 0 && activeCount > 0 && shouldBlockArchivedEdits;

    const isOnlyArchivedSelection =
        archivedCount > 0 && activeCount === 0 && shouldBlockArchivedEdits;

    if (hasMixedSelectionWithArchived) {
        return {
            message: `${archivedCount} stopped campaign${archivedCount > 1 ? "s have" : " has"
                } been filtered out for this action!`,
            isAllSelectedArchived: false,
        };
    }

    if (isOnlyArchivedSelection) {
        return {
            message: "Stopped campaigns cannot be edited!",
            isAllSelectedArchived: true,
        };
    }

    return {
        message: "",
        isAllSelectedArchived: false,
    };
};

export const getKeywordMappingStats = async (
    params: IProductMappingListParams
) => {
    try {
        const response = await sendRequest({
            type: "keywords/mapping/stats",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", err.message);
        Sentry.captureException(err);
    }
};

export const getGridTagsFormat = (tagIds: number[]) => {
    const tagTypeList = store.getState().tagTypeList.value;
    return chain(tagIds)
        .map((tagId: number) => {
            const tag = find(tagTypeList, (tag: any) =>
                tag.tags_map.some(
                    (tagMap: string) =>
                        tagMap.split("##")[0] === tagId.toString()
                )
            );
            if (!tag) {
                return null;
            }
            const tagMapEntry = tag.tags_map.find(
                (tagMap: string) => tagMap.split("##")[0] === tagId.toString()
            );
            const tagName = tagMapEntry ? tagMapEntry.split("##")[1] : "";
            return {
                tag_id: tagId,
                tag_name: tagName,
                tag_type: tag.tag_type,
                tag_type_id: tag.tag_type_id,
            };
        })
        .compact()
        .value();
};

export const capitalizeWords = (str: string) =>
    str
        ? str
            .replace(/(?<![([])\b\w/g, (char) => char.toUpperCase())
            .replace(/-/g, " ")
        : "-";

export const capitalizeSpecificSubstring = (
    sentence: string,
    targetWord: string,
    capitalizeAllOccurrences = true
) => {
    if (!sentence || !targetWord) return sentence;

    // Escape special regex characters in targetWord
    const escapedWord = targetWord.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const regex = new RegExp(escapedWord, "gi");

    if (capitalizeAllOccurrences) {
        return sentence.replace(regex, (match) => match.toUpperCase());
    } else {
        let replaced = false;
        return sentence.replace(regex, (match) => {
            if (!replaced) {
                replaced = true;
                return match.toUpperCase();
            }
            return match;
        });
    }
};

// Utility function for safe array cloning
export const safeCloneArray = (arr: any): any[] => {
    if (!Array.isArray(arr)) return [];
    // Check if array is frozen or sealed
    if (Object.isFrozen(arr) || Object.isSealed(arr)) {
        return [...arr];
    }
    // For performance, return the original if it's mutable
    return arr;
};

export const addKeywordMappings = async (config: KeywordMappingConfig) => {
    try {
        const response = await sendRequest({
            type: "keywords/mapping/update",
            method: "POST",
            data: config,
        });
        return response;
    } catch (error) {
        console.error("Error in addKeywordMappings:", error);
        showToast("danger", "Failed to update keyword mappings!");
        Sentry.captureException(error);
    }
};

export const applyKeyword1DSMapping = async (config: {
    keywords?: number[];
    filterModel?: Record<string, any>;
    update_params: string[];
}) => {
    try {
        const response = await sendRequest({
            type: "keywords/mapping/apply",
            method: "POST",
            data: config,
        });

        if (!response || typeof response !== "object") {
            throw new Error("Invalid response from server");
        }

        return response;
    } catch (err: any) {
        console.error("Error in applyKeyword1DSMapping:", err);
        Sentry.captureException(err);
        throw err;
    }
};

export const getKwdColFilterValues = async (params: IPfmSkuFilterParams) => {
    try {
        const response = await sendRequest({
            type: "keywords/mapping/filter-values",
            method: "POST",
            data: params,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response.rows;
    } catch (err: any) {
        showToast("danger", "Failed to fetch filter values!");
        Sentry.captureException(err);
    }
};

export const getRevstackDateFormat = () => {
    const countryCode = getCountryCode();

    return (
        REVSTACK_COUNTRY_DATE_FORMATS[
        countryCode as keyof typeof REVSTACK_COUNTRY_DATE_FORMATS
        ] || "DD/MM/YYYY"
    );
};

export const getSortedChannelList = () => {
    const channelList = store.getState().revstackChannelsList.value || [];
    const sortedChannels = sortBy(channelList, "view_order");
    return sortedChannels;
};
export function onPlacementSelectionChanged(event: GridReadyEvent) {
    const selectedNodes = event.api.getSelectedNodes();
    const { activeModule } = getActiveModule();
    if (selectedNodes.length) {
        const selectedData = selectedNodes.map((node) => node.data);
        if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
            store.dispatch(updateKeywordsSelectionData(selectedData));
            showElementById("keywords-bulk-operations-div");
        } else {
            store.dispatch(updateOverviewKeywordsSelectionData(selectedData));
        }
    } else {
        if (activeModule === ParentModule.KEYWORD_ANALYTICS) {
            store.dispatch(updateKeywordsSelectionData([]));
            hideElementById("keywords-bulk-operations-div");
        } else {
            store.dispatch(updateOverviewKeywordsSelectionData([]));
        }
    }
}

export const handlePriorityClick = (clusterId: string, productId: string) => {
    store.dispatch(toggleProductPriority({ clusterId, productId }));
};

export const getProductPriority = (
    clusterId: string,
    productId: string
): number => {
    const state = store.getState() as any;
    const clusters = state.clusters?.clusters || [];
    const cluster = clusters.find((c: any) => c.id === clusterId);

    if (cluster) {
        const product = cluster.products.find((p: any) => p.id === productId);
        return product?.priority || 0;
    }

    return 0;
};

export const saveClusterAndRefresh = async (
    clusterName: string,
    productsWithPriorities: any[],
    dispatch: any
) => {
    try {
        // Build API payload
        const apiPayload = {
            clusterName: clusterName.trim(),
            skuGroups: productsWithPriorities.map(
                ({ id, priority = 0, skuDetails = [] }) => ({
                    skuGroupId: Number(id),
                    ...(priority > 0 && { skuPriority: priority }), // add only if > 0
                    skuList: skuDetails.map(
                        ({ sku = 0, isActive = false }) => ({
                            sku: Number(sku),
                            isActive: isActive,
                        })
                    ),
                })
            ),
        };

        // Save to database
        const response: any = await createClusterGroups(apiPayload);

        if (!response || !response.status) {
            throw new Error(response?.message || "Failed to save cluster");
        }

        const clusterId = response.clusterId.toString();
        // Fetch updated cluster list and raw product groups data after successful save
        const [updatedClusters, rawProductGroups] = await Promise.all([
            getClusterGroups(),
            getProductGroups(),
        ]);

        if (updatedClusters && rawProductGroups) {
            // Format clusters with complete product data using raw product groups
            const formattedClusters = formatClusterDataWithProducts(
                updatedClusters,
                rawProductGroups
            );

            // Get existing clusters from Redux to preserve their state
            const currentState = store.getState();
            const existingClusters = currentState?.clusters?.clusters || [];

            // Create a map of existing clusters by ID for quick lookup
            const existingClustersMap = new Map();
            existingClusters.forEach((cluster: any) => {
                existingClustersMap.set(cluster.id, cluster);
            });

            // Merge fresh data with existing cluster state
            const mergedClusters: any[] = [];

            // First, add all fresh clusters (from API) with merged existing state
            formattedClusters.forEach((freshCluster: any) => {
                const existingCluster = existingClustersMap.get(
                    freshCluster.id
                );

                if (existingCluster) {
                    // Preserve existing cluster state (collections, custom properties, etc.)
                    // but update products and basic cluster info from fresh data
                    mergedClusters.push({
                        ...freshCluster,
                        // Preserve existing collections and other dynamic state
                        collections: existingCluster.collections || [],
                        totalBudget: existingCluster.totalBudget,
                        startDate: existingCluster.startDate,
                        endDate: existingCluster.endDate,
                        budgetUsed: existingCluster.budgetUsed,
                        // Update products but preserve existing product state (disabled status, etc.)
                        products: freshCluster.products.map(
                            (freshProduct: any) => {
                                const existingProduct =
                                    existingCluster.products?.find(
                                        (p: any) => p.id === freshProduct.id
                                    );
                                if (existingProduct) {
                                    // Preserve product state like disabled status, priority, and any UI-specific fields
                                    return {
                                        ...freshProduct,
                                        disabled: existingProduct.disabled,
                                        priority: existingProduct.priority, // Preserve user-set priorities
                                        // Preserve any additional UI state that might not be in fresh data
                                        expanded: existingProduct.expanded,
                                        // Keep other existing properties that might be missing from fresh data
                                        ...Object.keys(existingProduct).reduce(
                                            (acc: any, key: string) => {
                                                if (
                                                    !(key in freshProduct) &&
                                                    key !== "collections" &&
                                                    key !== "totalBudget" &&
                                                    key !== "startDate" &&
                                                    key !== "endDate" &&
                                                    key !== "budgetUsed"
                                                ) {
                                                    acc[key] =
                                                        existingProduct[key];
                                                }
                                                return acc;
                                            },
                                            {}
                                        ),
                                    };
                                }
                                return freshProduct;
                            }
                        ),
                    });
                } else {
                    // For new clusters, use the fresh data as-is
                    mergedClusters.push(freshCluster);
                }
            });

            // Second, add any existing clusters that aren't in the fresh data (like product clusters)
            existingClusters.forEach((existingCluster: any) => {
                const isAlreadyIncluded = mergedClusters.some(
                    (cluster: any) => cluster.id === existingCluster.id
                );
                if (!isAlreadyIncluded) {
                    // Preserve existing cluster as-is (this includes product clusters ##productCluster_*)
                    mergedClusters.push(existingCluster);
                }
            });

            dispatch(setClusters(mergedClusters));
        }

        return { success: true, clusterId };
    } catch (error: any) {
        console.error("Error saving cluster:", error);
        throw error;
    }
};

export const handleSaveCluster = async (
    clusterName: string,
    selectedProducts: any[],
    dispatch: any,
    setIsSavingCluster: (loading: boolean) => void,
    isSavingCluster: boolean,
    productGroups: any[],
    handleModalCancel: () => void,
    shouldAddCluster?: boolean,
    setSelectedClusters?: (clusters: string[]) => void,
    selectedClusters?: string[]
) => {
    if (!clusterName.trim() || selectedProducts.length === 0) {
        return;
    }

    if (isSavingCluster) {
        return; // Prevent multiple submissions
    }

    // Check for duplicate clusters with same SKU groups
    try {
        const existingClusters = await getClusterGroups();

        if (existingClusters) {
            const formattedClusters = formatClusterDataWithProducts(
                existingClusters,
                productGroups
            );

            // Get SKU group IDs from selected products
            const newClusterSkuGroupIds = selectedProducts
                .map((product) => product.id.toString())
                .sort();

            // Check if any existing cluster has the same SKU groups
            const duplicateCluster = formattedClusters.find((cluster: any) => {
                const existingSkuGroupIds =
                    cluster.products
                        ?.map((product: any) => product.sku_group_id.toString())
                        .sort() || [];
                return (
                    JSON.stringify(existingSkuGroupIds) ===
                    JSON.stringify(newClusterSkuGroupIds)
                );
            });

            if (duplicateCluster) {
                showToast(
                    "danger",
                    `A cluster with the same SKU groups already exists: "${duplicateCluster.name}"`
                );
                return;
            }
        }
    } catch (error) {
        console.error("Error checking for duplicate clusters:", error);
    }

    setIsSavingCluster(true);

    try {
        // Extract priorities from the priority state (products in modal use 'default' as clusterId)
        // Also merge variant selection state from local state
        const productsWithPriorities = selectedProducts.map((product) => {
            const productId = product.id || product.sku;
            // Primary source: local priority state used by the modal
            const statePriority = getProductPriorityFromState(
                "default",
                productId
            );
            // Fallback: any priority present on the product itself
            const priority =
                typeof statePriority === "number" && statePriority > 0
                    ? statePriority
                    : typeof product.priority === "number"
                        ? product.priority
                        : 0;

            // Get variant selection from local state and merge into skuDetails
            const skuDetails = Array.isArray(product.skuDetails)
                ? product.skuDetails.map((sku: any) => {
                    const skuObj = { ...sku };
                    // Check if this variant is selected in local state
                    const clusterId = `##productCluster_${productId}`;
                    const isActive = getVariantSelectionFromState(
                        clusterId,
                        productId,
                        sku.unit || sku.sku || ""
                    );
                    if (isActive) {
                        skuObj.isActive = true;
                    }
                    return skuObj;
                })
                : [];

            return {
                ...product,
                priority,
                skuDetails,
            };
        });

        // Use utility function to save cluster and refresh data
        const saveResult = await saveClusterAndRefresh(
            clusterName.trim(),
            productsWithPriorities,
            dispatch
        );

        // If shouldAddCluster is true, add the newly created cluster to selectedClusters
        if (
            shouldAddCluster &&
            saveResult.clusterId &&
            setSelectedClusters &&
            selectedClusters
        ) {
            // Find the cluster with the returned clusterId in the updated clusters
            const currentState = store.getState();
            const updatedClusters = currentState?.clusters?.clusters || [];
            const newCluster = updatedClusters.find(
                (cluster: any) => cluster.id === saveResult.clusterId
            );

            if (
                newCluster &&
                !selectedClusters.includes(saveResult.clusterId)
            ) {
                setSelectedClusters([
                    ...selectedClusters,
                    saveResult.clusterId,
                ]);
            }
        }

        showToast("success", "Cluster saved successfully!");

        // Reset form
        handleModalCancel();
    } catch (error: any) {
        console.error("Error saving cluster:", error);
        showToast("danger", error.message || "Failed to save cluster");
    } finally {
        setIsSavingCluster(false);
    }
};

export const mapProductGroupToUIFormat = (productGroup: any) => {
    const firstSku = productGroup.sku_details?.[0] || {};
    const channel = store.getState().channel.value;
    const channelDomain = store.getState().channelDomain.value;
    const title = productGroup.sku_group_title || firstSku.title || "";
    return {
        // Core IDs
        id: String(productGroup.sku_group_id),
        sku: firstSku.sku || "",
        sku_title: title,

        // Display fields for left panel
        title: title,
        category: productGroup.category || "-",
        subcategory: productGroup.subcategory || "-",
        msPercent: productGroup.market_share_pct || 0,
        sovPercent: productGroup.overall_sov || 0,
        wtAvailabilityPercent: productGroup.weighted_availability || 0,
        image: productGroup.sku_group_thumbnail || "",
        thumbnail: productGroup.sku_group_thumbnail || "",
        product_url: getProductPageLink(
            channel as number,
            firstSku.sku || "",
            channelDomain as string,
            title
        ),

        // Table column data (with _value and _change suffixes)
        market_share_value: productGroup.market_share_pct || 0,
        market_share_change: productGroup.market_share_pct_change || 0,
        weighted_availability_value: productGroup.weighted_availability || 0,
        weighted_availability_change: productGroup.weighted_availability_change,

        // Table column data for modal table (direct field access)
        market_share_pct: productGroup.market_share_pct || 0,
        market_share_pct_change: productGroup.market_share_pct_change || 0,
        overall_sov: productGroup.overall_sov || 0,
        overall_sov_change: productGroup.overall_sov_change || 0,
        weighted_availability_pct: productGroup.weighted_availability || 0,
        weighted_availability_pct_change:
            productGroup.weighted_availability_change || 0,
        organic_sov: productGroup.organic_sov || 0,
        organic_sov_change: productGroup.organic_sov_change || 0,
        paid_sov: productGroup.sponsored_sov || 0,
        paid_sov_change: productGroup.sponsored_sov_change || 0,
        priority_value: 0, // Default priority
        variants_value:
            productGroup.sku_details?.length > 1
                ? productGroup.sku_details
                    .map((sku: any) => sku.unit || sku.sku)
                    .filter(Boolean)
                : [],

        // Additional fields
        unit: firstSku.unit || "",
        organicSov: productGroup.organic_sov || 0,
        sponsoredSov: productGroup.sponsored_sov || 0,
        avgRating: productGroup.avg_rating || 0,
        isComboGroup: productGroup.is_combo_group || false,
        isVariantGroup: productGroup.is_variant_group || false,
        skuDetails: productGroup.sku_details || [],
        expanded: false,
    };
};

// Extract city names from various city format strings
export const extractCityNames = (cities: string[]): string[] => {
    return cities.map((city: string) => {
        if (city?.startsWith('cohort:')) {
            const parts = city.slice(7).split(':');
            return parts.length >= 2 ? parts[1] : city;
        }
        if (city?.startsWith('region:')) {
            const parts = city.slice(7).split(':');
            return parts[0] || city;
        }
        if (city?.startsWith('tier:')) {
            const parts = city.slice(5).split(':');
            return parts[0] || city;
        }
        if (city?.startsWith('zone:')) {
            const parts = city.slice(5).split(':');
            return parts[0] || city;
        }
        const parts = city.split("_");
        return parts[2] || city;
    });
};

// Generate cohort display label (e.g., "Gen + Comp" or "Brand")
export const getCohortDisplayLabel = (cohort: IKeywordCohort): string => {
    const types = cohort.keywordTypes || [];
    const hasCustomKeywords = cohort.keywords?.some((kw: IBCCKeyword) => kw.isCustom);
    if (types.length === 0) {
        return hasCustomKeywords ? 'Custom' : (cohort.categories?.length > 0 ? 'Category' : 'Cohort');
    }
    return types.map((t: string) => BCC_KEYWORD_TYPE_ABBREVIATIONS[t] || titleCase(t)).join(' + ');
};

// Get keyword types for campaign name generation
export const getKeywordTypesForName = (cohort: IKeywordCohort): string[] => {
    if (cohort.keywordTypes?.length > 0) {
        return cohort.keywordTypes;
    }
    const hasCustomKeywords = cohort.keywords?.some((kw: IBCCKeyword) => kw.isCustom || kw.keyword_type === BCC_KEYWORD_TYPES.CUSTOM);
    if (hasCustomKeywords) {
        return [BCC_KEYWORD_TYPES.CUSTOM];
    }
    return cohort.categories?.length > 0 ? [BCC_TARGET_TYPES.CATEGORIES] : [];
};

// Get current collection from Redux store
export const getCurrentCollection = (clusterId: string, collectionId: string) => {
    const currentState = store.getState();
    const allClusters = currentState?.clusters?.clusters || [];
    const cluster = allClusters.find((c: any) => c.id === clusterId);
    const collection = cluster?.collections.find((c: any) => c.id === collectionId);
    return { cluster, collection };
};

export const generateCampaignName = (
    clusterName: string,
    keywordType: string[],
    cities: string[],
    timeSlots: string[],
    campaignType: string
) => {
    // Handle keyword type abbreviations including 'categories' and 'custom'
    const keywordTypeShort = keywordType
        ?.map((ad: string) => {
            if (ad?.toLowerCase() === BCC_TARGET_TYPES.CATEGORIES) return 'Cat';
            if (ad?.toLowerCase() === KeywordTypeValues.CUSTOM) return 'Cust';
            return ad?.charAt(0).toUpperCase();
        })
        ?.join("_") || '';

    const citiesShortForm = cities
        .map((city) => city.slice(0, 3).toUpperCase())
        .join("_");

    const timeSlotsJoined =
        timeSlots.length > 1
            ? timeSlots.map((ts) => ts.slice(0, 3)).join("_")
            : timeSlots[0];

    const campaignTypeShort =
        BCC_CAMPAIGN_TYPE_MAPPING_SHORT[campaignType] || "";

    return `1DS x ${campaignTypeShort} x ${keywordTypeShort} x ${clusterName} x ${citiesShortForm} x ${timeSlotsJoined}`;
};

export const publishBulkCampaigns = (data: any) => {
    const campaigns =
        data?.flatMap((d: any) => {
            const products =
                d?.products
                    ?.filter(
                        (p: any) =>
                            p?.disabled === false || p?.disabled === undefined
                    )
                    ?.flatMap((p: any) => {
                        return (
                            p?.skuDetails
                                ?.filter(
                                    (sku: any) =>
                                        sku?.isActiveForSession === true
                                )
                                ?.map((sku: any) => {
                                    return {
                                        id: sku?.sku,
                                        is_star_product: p?.priority > 0,
                                        order: p?.priority,
                                    };
                                }) || []
                        );
                    }) || [];

            const currClusterCampaigns =
                d?.collections?.flatMap((c: any) => c?.campaigns) || [];

            const productIds = products.map((p: any) => p.id).join(",");
            //! Validation[DND]: Keep campaigns that meet the minimum budget and are not archived
            const relevantCampaigns = currClusterCampaigns?.filter(
                (c: any) =>
                    c?.budget !== null &&
                    c?.budget >= MIN_BULK_CAMPAIGN_BUGET_LIMIT &&
                    c?.isArchived !== true
            );
            if (relevantCampaigns?.length === 0) {
                throw new Error(
                    `All campaigns have budget less than ${MIN_BULK_CAMPAIGN_BUGET_LIMIT}`
                );
            }

            return relevantCampaigns?.map((c: any) => {
                // Extract city IDs, handling cohort/region/tier/zone format if present
                // Cohort format: cohort:level:displayLabel:cityId1|cityId2|cityId3
                // Region format: region:displayLabel:cityId1|cityId2|cityId3
                // Tier format: tier:displayLabel:cityId1|cityId2|cityId3
                // Zone format: zone:displayLabel:cityId1|cityId2|cityId3
                const extractCityIds = (cities: string[]): string[] => {
                    const result: string[] = [];
                    (cities || []).forEach((ci: string) => {
                        if (ci?.startsWith("cohort:")) {
                            // Parse cohort format
                            const parts = ci.slice(7).split(":");
                            if (parts.length >= 3) {
                                // New format: level:displayLabel:cityIds
                                const cityIds = parts[2].split("|");
                                result.push(...cityIds);
                            } else {
                                // Legacy format: just cityIds
                                const cityIds = parts[0].split("|");
                                result.push(...cityIds);
                            }
                        } else if (ci?.startsWith("region:")) {
                            // Parse region format: region:displayLabel:cityIds
                            const parts = ci.slice(7).split(":");
                            if (parts.length >= 2) {
                                const cityIds = parts[1].split("|");
                                result.push(...cityIds);
                            }
                        } else if (ci?.startsWith("tier:")) {
                            // Parse tier format: tier:displayLabel:cityIds
                            const parts = ci.slice(5).split(":");
                            if (parts.length >= 2) {
                                const cityIds = parts[1].split("|");
                                result.push(...cityIds);
                            }
                        } else if (ci?.startsWith("zone:")) {
                            // Parse zone format: zone:displayLabel:cityIds
                            const parts = ci.slice(5).split(":");
                            if (parts.length >= 2) {
                                const cityIds = parts[1].split("|");
                                result.push(...cityIds);
                            }
                        } else {
                            result.push(ci);
                        }
                    });
                    return result;
                };

                const cityIds = extractCityIds(c?.city);
                const cityParts: Array<{ code: string; name: string }> =
                    cityIds.map((ci: string) => {
                        const parts = ci?.split("_");
                        return { code: parts?.[0], name: parts?.[2] };
                    }) || [];

                const campaignName =
                    c?.name ||
                    generateCampaignName(
                        d?.name,
                        c?.keywordType,
                        cityParts.map(
                            (cp: { code: string; name: string }) => cp.name
                        ),
                        c?.timeSlot,
                        c?.campaignType
                    );

                return {
                    attribute: ["create_campaign"],
                    name: campaignName,
                    startDate: d?.startDate?.format("YYYY-MM-DD"),
                    ...(d?.endDate && {
                        endDate: d?.endDate.format("YYYY-MM-DD"),
                    }),
                    campaignType: "performance",
                    targetingType: "product",
                    adFormat: "keyword_targeting",
                    cities: cityParts
                        .map((cp: { code: string; name: string }) => cp.code)
                        .join(","),
                    // !NOTE: This has to be empty array for now as we are not supporting time slots in bulk campaign creation
                    ...(c?.timeSlot?.length && { timeslots: [] }),
                    bidding_strategy: {
                        total_budget: +c?.budget,
                        type: "daily",
                    },
                    ...(c?.keywords?.length && {
                        keywords: c.keywords.map((k: any) => ({
                            keyword: k?.keyword,
                            bids: [
                                ...(k?.exact_match_bid
                                    ? [
                                        {
                                            match_type: MatchType.EXACT.toUpperCase(),
                                            cpm: parseInt(k?.exact_match_bid),
                                            ...(k?.bid_booster
                                                ? { max_boost: k?.bid_booster }
                                                : {}),
                                        },
                                    ]
                                    : []),
                                ...(k?.smart_match_bid
                                    ? [
                                        {
                                            match_type: "SMART",
                                            cpm: parseInt(k?.smart_match_bid),
                                        },
                                    ]
                                    : []),
                            ],
                        })),
                    }),
                    ...(c?.negative_keywords?.length && {
                        negative_keywords: c.negative_keywords.map(
                            (nk: any) => nk?.keyword || nk
                        ),
                    }),
                    ...(c?.categories?.length && {
                        categories: c.categories.map((cat: any) => ({
                            category_id: String(cat?.category_id),
                            category_name: cat?.category_name,
                            bidding_strategy: {
                                cpm: parseInt(cat?.cpm_bid) || 0,
                            },
                        })),
                    }),
                    metadata: {
                        pids: productIds,
                        products,
                    },
                };
            });
        }) || [];

    const filteredCampaigns = campaigns?.filter(
        (c: any) => c?.metadata?.products?.length > 0
    );

    return { campaigns: filteredCampaigns };
};

export const createBulkCampaigns = async (campaigns: any) => {
    try {
        const response = await sendRequest({
            type: "campaigns",
            method: "POST",
            data: campaigns,
        });

        if (!response.status) {
            throw new Error(response.message);
        }

        return response;
    } catch (err: any) {
        showToast("danger", "Failed to create campaigns!");
        Sentry.captureException(err);
    }
};

export const disableCampaignsAddition = (record: any) => {
    const hasAnyField =
        record?.campaignType ||
        (record?.keywordType &&
            Array.isArray(record.keywordType) &&
            record.keywordType.length > 0) ||
        (record?.keywords &&
            Array.isArray(record.keywords) &&
            record.keywords.length > 0) ||
        (record?.city &&
            Array.isArray(record.city) &&
            record.city.length > 0) ||
        (record?.timeSlot &&
            Array.isArray(record.timeSlot) &&
            record.timeSlot.length > 0) ||
        (record?.budget !== null &&
            record?.budget !== undefined &&
            record?.budget !== "") ||
        record?.type;
    const disabled = !hasAnyField;
    return disabled;
};

export const getProductPageLink = (
    channel: number,
    asin: string,
    channelDomain: string,
    skuTitle: string
) => {
    let linkUrl = "";
    const productNameFormatted = skuTitle?.split(" ").join("-");
    switch (channel) {
        case Channels.AMAZON:
            linkUrl = `${channelDomain}/dp/${asin}`;
            break;
        case Channels.BLINKIT:
            linkUrl = `${channelDomain}/prn/${productNameFormatted}/prid/${asin}`;
            break;
        default:
            linkUrl = ""; // or handle other channels here
            break;
    }
    return linkUrl;
};

export const getCategoryOptions = (
    tableData: any[],
    additionalFilters?: any[]
): Array<{ label: string; value: string }> => {
    // !NOTE: commented for now as we are not showing default options in the dropdown
    // const defaultOptions =
    //     additionalFilters?.find(
    //         (filter: any) => filter.key === CommonWidgetMetrics.CATEGORY
    //     )?.props?.options || [];

    if (!tableData || !Array.isArray(tableData)) return [];

    const uniqueCategories = [
        ...new Set(
            tableData
                .map((item: any) => item.category)
                .filter((cat: any) => cat && cat !== "-" && cat.trim() !== "")
        ),
    ];

    return [
        // ...defaultOptions,
        ...uniqueCategories.map((cat: string) => ({
            label: cat,
            value: cat,
        })),
    ];
};

export const getSubcategoryOptions = (
    tableData: any[],
    additionalFilters?: any[],
    selectedCategory?: string,
    allCategoryValue: string = CommonWidgetMetrics.All,
    existingOptions?: Array<{ label: string; value: string }>
): Array<{ label: string; value: string }> => {
    const defaultOptions =
        additionalFilters?.find(
            (f: any) => f.key === CommonWidgetMetrics.SUB_CATEGORY
        )?.props?.options || [];

    if (existingOptions && Array.isArray(existingOptions)) {
        if (selectedCategory && selectedCategory !== allCategoryValue) {
            const filteredData =
                tableData?.filter(
                    (item: any) => item.category === selectedCategory
                ) || [];

            const validSubcategories = new Set(
                filteredData
                    .map((item: any) => item.subcategory)
                    .filter(
                        (subcat: any) =>
                            subcat && subcat !== "-" && subcat.trim() !== ""
                    )
            );

            return [
                ...defaultOptions,
                ...existingOptions.filter((option: any) =>
                    validSubcategories.has(option.value)
                ),
            ];
        }
        return existingOptions;
    }

    if (!tableData || !Array.isArray(tableData)) return defaultOptions;

    let dataToUse = tableData;

    if (selectedCategory && selectedCategory !== allCategoryValue) {
        dataToUse = tableData.filter(
            (item: any) => item.category === selectedCategory
        );
    }

    const uniqueSubcategories = [
        ...new Set(
            dataToUse
                .map((item: any) => item.subcategory)
                .filter(
                    (subcat: any) =>
                        subcat && subcat !== "-" && subcat.trim() !== ""
                )
        ),
    ];

    return [
        ...defaultOptions,
        ...uniqueSubcategories.map((subcat: string) => ({
            label: subcat,
            value: subcat,
        })),
    ];
};

export const enrichAdditionalFiltersWithCategoryData = (
    additionalFilters: any[],
    categoryOptions?: Array<{ label: string; value: string }>,
    subcategoryOptions?: Array<{ label: string; value: string }>,
    categoryFilters?: {
        selectedCategory: string;
        selectedSubcategory: string;
    },
    setCategoryFilters?: React.Dispatch<
        React.SetStateAction<{
            selectedCategory: string;
            selectedSubcategory: string;
        }>
    >,
    allCategoryValue: string = CommonWidgetMetrics.All
): any[] => {
    if (!additionalFilters || !Array.isArray(additionalFilters)) {
        return additionalFilters || [];
    }

    const selectedCategory = categoryFilters?.selectedCategory;
    const selectedSubcategory = categoryFilters?.selectedSubcategory;

    return additionalFilters.map((filter) => {
        if (
            filter.key === CommonWidgetMetrics.CATEGORY &&
            filter?.props &&
            categoryOptions
        ) {
            return {
                ...filter,
                props: {
                    ...filter.props,
                    options: categoryOptions,
                    value: selectedCategory || allCategoryValue,
                    onChange: setCategoryFilters
                        ? (value: string) =>
                            setCategoryFilters({
                                selectedCategory: value,
                                selectedSubcategory: allCategoryValue,
                            })
                        : () => { },
                },
            };
        } else if (
            filter.key === CommonWidgetMetrics.SUB_CATEGORY &&
            filter?.props &&
            subcategoryOptions
        ) {
            return {
                ...filter,
                props: {
                    ...filter.props,
                    options: subcategoryOptions,
                    value: selectedSubcategory || allCategoryValue,
                    onChange: setCategoryFilters
                        ? (value: string) =>
                            setCategoryFilters((prev) => ({
                                ...prev,
                                selectedSubcategory: value,
                            }))
                        : () => { },
                },
            };
        }
        return filter;
    });
};

export const findCityIdFromCitiesList = (
    cityValue: any,
    citiesList: Array<{
        city_id: number;
        city_name: string;
        city_offtake: number;
    }>
): number | null => {
    if (!cityValue || !citiesList || citiesList.length === 0) return null;

    let extractedId: number | null = null;

    if (typeof cityValue === "number") {
        extractedId = cityValue;
    } else if (typeof cityValue === "string") {
        // Try format: "IN_123_Delhi" -> parts[0]="IN", parts[1]="123", parts[2]="Delhi"
        const parts = cityValue.split("_");
        if (parts.length >= 2) {
            const cityId = parseInt(parts[1], 10);
            if (!isNaN(cityId)) {
                extractedId = cityId;
            }
        }

        if (extractedId === null) {
            const directNumber = parseInt(cityValue, 10);
            if (!isNaN(directNumber)) {
                extractedId = directNumber;
            }
        }
    }

    if (extractedId !== null) {
        const cityExists = citiesList.some((c) => c.city_id === extractedId);
        if (cityExists) {
            return extractedId;
        }
    }

    // If extraction failed or ID not found, try matching by city name
    if (typeof cityValue === "string") {
        const parts = cityValue.split("_");
        const cityName = parts.length >= 3 ? parts[2] : cityValue;

        const matchedCity = citiesList.find(
            (c) =>
                c.city_name &&
                c.city_name.toLowerCase() === cityName.toLowerCase()
        );
        if (matchedCity) {
            return matchedCity.city_id;
        }
    }

    return null;
};

// Helper to extract city IDs from special formats (region, tier, cohort, zone)
// Also handles city exclusion - if a city is individually selected, exclude it from region/tier/cohort/zone
const extractCityIdsForBudget = (
    cities: string[],
    allIndividualCityIds: Set<string>
): string[] => {
    const result: string[] = [];

    cities.forEach((ci: string) => {
        if (ci?.startsWith("cohort:")) {
            // Parse cohort format: cohort:level:displayLabel:cityIds
            const parts = ci.slice(7).split(":");
            let cityIds: string[] = [];
            if (parts.length >= 3) {
                cityIds = parts[2].split("|");
            } else {
                cityIds = parts[0].split("|");
            }
            // Exclude individually selected cities
            cityIds.forEach((id) => {
                if (!allIndividualCityIds.has(id)) {
                    result.push(id);
                }
            });
        } else if (ci?.startsWith("region:")) {
            // Parse region format: region:displayLabel:cityIds
            const parts = ci.slice(7).split(":");
            if (parts.length >= 2) {
                const cityIds = parts[1].split("|");
                // Exclude individually selected cities
                cityIds.forEach((id) => {
                    if (!allIndividualCityIds.has(id)) {
                        result.push(id);
                    }
                });
            }
        } else if (ci?.startsWith("tier:")) {
            // Parse tier format: tier:displayLabel:cityIds
            const parts = ci.slice(5).split(":");
            if (parts.length >= 2) {
                const cityIds = parts[1].split("|");
                // Exclude individually selected cities
                cityIds.forEach((id) => {
                    if (!allIndividualCityIds.has(id)) {
                        result.push(id);
                    }
                });
            }
        } else if (ci?.startsWith("zone:")) {
            // Parse zone format: zone:displayLabel:cityIds
            const parts = ci.slice(5).split(":");
            if (parts.length >= 2) {
                const cityIds = parts[1].split("|");
                // Exclude individually selected cities
                cityIds.forEach((id) => {
                    if (!allIndividualCityIds.has(id)) {
                        result.push(id);
                    }
                });
            }
        } else {
            // Regular city ID
            result.push(ci);
        }
    });

    return result;
};

// Helper to get all individually selected city IDs from a collection's campaigns
const getIndividualCityIds = (campaigns: any[]): Set<string> => {
    const individualCityIds = new Set<string>();

    campaigns.forEach((campaign: any) => {
        const cities = Array.isArray(campaign.city)
            ? campaign.city
            : campaign.city
                ? [campaign.city]
                : [];

        cities.forEach((ci: string) => {
            // Only add if it's a regular city ID (not region, tier, or cohort)
            if (
                ci &&
                !ci.startsWith("cohort:") &&
                !ci.startsWith("region:") &&
                !ci.startsWith("tier:")
            ) {
                individualCityIds.add(ci);
            }
        });
    });

    return individualCityIds;
};

export const calculateAutoSuggestBudgets = (
    targetCluster: any,
    citiesList: Array<{
        city_id: number;
        city_name: string;
        city_offtake: number;
    }>,
    targetCollectionId?: string,
    campaignBudget?: number
): Array<{
    collectionId: string;
    campaigns: any[];
    collectionBudget: number;
}> => {
    if (!targetCluster || !citiesList || citiesList.length === 0) {
        return [];
    }

    const totalBudget = campaignBudget !== undefined ? campaignBudget : 0;
    if (totalBudget <= 0) {
        return [];
    }

    // Budget split: Generic (70%), Competition (20%), Branded (10%)
    const budgetSplit = {
        generic: 0.7,
        competition: 0.2,
        branded: 0.1,
    };

    // Create a map of city_id to offtake for quick lookup
    const cityOfftakeMap = new Map<number, number>();
    citiesList.forEach((city) => {
        cityOfftakeMap.set(city.city_id, city.city_offtake);
    });

    // Process collections
    const collectionsToProcess = targetCollectionId
        ? targetCluster.collections?.filter(
            (c: any) => c.id === targetCollectionId
        ) || []
        : targetCluster.collections || [];

    const results: Array<{
        collectionId: string;
        campaigns: any[];
        collectionBudget: number;
    }> = [];

    collectionsToProcess.forEach((collection: any) => {
        const campaigns = collection.campaigns || [];
        const activeCampaigns = campaigns.filter((c: any) => !c.isArchived);

        if (activeCampaigns.length === 0) {
            return;
        }

        // Get all individually selected city IDs to exclude from region/tier/cohort calculations
        const individualCityIds = getIndividualCityIds(activeCampaigns);

        // Group campaigns by keywordType
        const campaignsByKeywordType: Record<string, any[]> = {
            generic: [],
            competition: [],
            branded: [],
        };

        activeCampaigns.forEach((campaign: any) => {
            const keywordTypes = Array.isArray(campaign.keywordType)
                ? campaign.keywordType
                : campaign.keywordType
                    ? [campaign.keywordType]
                    : [];

            keywordTypes.forEach((keywordType: string) => {
                const normalizedKeywordType = keywordType.toLowerCase();
                if (normalizedKeywordType === "generic") {
                    if (
                        !campaignsByKeywordType.generic.some(
                            (c: any) => c.id === campaign.id
                        )
                    ) {
                        campaignsByKeywordType.generic.push(campaign);
                    }
                } else if (normalizedKeywordType === "competition") {
                    if (
                        !campaignsByKeywordType.competition.some(
                            (c: any) => c.id === campaign.id
                        )
                    ) {
                        campaignsByKeywordType.competition.push(campaign);
                    }
                } else if (normalizedKeywordType === "branded") {
                    if (
                        !campaignsByKeywordType.branded.some(
                            (c: any) => c.id === campaign.id
                        )
                    ) {
                        campaignsByKeywordType.branded.push(campaign);
                    }
                }
            });
        });

        // Calculate adjusted budget splits based on active keyword types
        // If a keyword type has no campaigns, redistribute its budget proportionally to other types
        let totalActiveWeight = 0;
        Object.entries(budgetSplit).forEach(([keywordType, weight]) => {
            if (campaignsByKeywordType[keywordType].length > 0) {
                totalActiveWeight += weight;
            }
        });

        const adjustedBudgetSplit: Record<string, number> = {};
        Object.entries(budgetSplit).forEach(([keywordType, weight]) => {
            if (
                campaignsByKeywordType[keywordType].length > 0 &&
                totalActiveWeight > 0
            ) {
                // Redistribute: new percentage = (original weight / total active weight)
                adjustedBudgetSplit[keywordType] = weight / totalActiveWeight;
            }
        });

        // Process each keywordType category
        const updatedCampaigns = [...campaigns];
        // Track budget for each campaign (to accumulate if campaign belongs to multiple categories)
        const campaignBudgetMap = new Map<string, number>();

        Object.entries(adjustedBudgetSplit).forEach(
            ([keywordType, percentage]) => {
                const categoryCampaigns = campaignsByKeywordType[keywordType];
                if (categoryCampaigns.length === 0) return;

                const categoryBudget = totalBudget * percentage;

                // Group campaigns by city and calculate city weights
                const cityCampaignsMap = new Map<number, any[]>();
                const cityOfftakeMapForCategory = new Map<number, number>();

                categoryCampaigns.forEach((campaign: any) => {
                    const rawCities = Array.isArray(campaign.city)
                        ? campaign.city
                        : campaign.city
                            ? [campaign.city]
                            : [];

                    // Extract city IDs, handling region/tier/cohort formats and excluding individual cities
                    const extractedCityIds = extractCityIdsForBudget(
                        rawCities,
                        individualCityIds
                    );

                    extractedCityIds.forEach((cityValue: string) => {
                        const cityId = findCityIdFromCitiesList(
                            cityValue,
                            citiesList
                        );

                        if (cityId !== null && cityOfftakeMap.has(cityId)) {
                            const offtake = cityOfftakeMap.get(cityId) || 0;
                            if (!cityCampaignsMap.has(cityId)) {
                                cityCampaignsMap.set(cityId, []);
                                cityOfftakeMapForCategory.set(cityId, offtake);
                            }
                            // Only add campaign if not already in the list for this city
                            if (
                                !cityCampaignsMap
                                    .get(cityId)
                                    ?.some((c) => c.id === campaign.id)
                            ) {
                                cityCampaignsMap.get(cityId)?.push(campaign);
                            }
                        }
                    });
                });

                // Calculate total offtake for active cities
                let totalOfftake = 0;
                cityOfftakeMapForCategory.forEach((offtake) => {
                    totalOfftake += offtake;
                });

                if (totalOfftake === 0) {
                    return;
                }

                // Calculate city weights and distribute budget
                const cityBudgetMap = new Map<number, number>();
                cityOfftakeMapForCategory.forEach((offtake, cityId) => {
                    const weight = offtake / totalOfftake;
                    const cityBudget = categoryBudget * weight;
                    cityBudgetMap.set(cityId, cityBudget);
                });

                // Distribute budget to campaigns
                // For each city, divide its budget equally among all campaigns that include that city
                // For campaigns with multiple cities, sum up the portions from each city
                categoryCampaigns.forEach((campaign: any) => {
                    const rawCities = Array.isArray(campaign.city)
                        ? campaign.city
                        : campaign.city
                            ? [campaign.city]
                            : [];

                    // Extract city IDs, handling region/tier/cohort formats and excluding individual cities
                    const extractedCityIds = extractCityIdsForBudget(
                        rawCities,
                        individualCityIds
                    );

                    let categoryCampaignBudget = 0;
                    extractedCityIds.forEach((cityValue: string) => {
                        const cityId = findCityIdFromCitiesList(
                            cityValue,
                            citiesList
                        );
                        if (cityId !== null && cityBudgetMap.has(cityId)) {
                            const cityBudget = cityBudgetMap.get(cityId) || 0;
                            // Count how many campaigns share this city
                            const campaignsForCity =
                                cityCampaignsMap.get(cityId) || [];
                            const campaignCount = campaignsForCity.length;
                            if (campaignCount > 0) {
                                // Each campaign gets an equal share of the city's budget
                                categoryCampaignBudget +=
                                    cityBudget / campaignCount;
                            }
                        }
                    });

                    // Accumulate budget for campaigns that belong to multiple categories
                    const campaignId = campaign.id;
                    const currentBudget =
                        campaignBudgetMap.get(campaignId) || 0;
                    campaignBudgetMap.set(
                        campaignId,
                        currentBudget + categoryCampaignBudget
                    );
                });
            }
        );

        campaignBudgetMap.forEach((budget, campaignId) => {
            const campaignIndex = updatedCampaigns.findIndex(
                (c: any) => c.id === campaignId
            );
            if (campaignIndex !== -1) {
                // Ensure budget is at least the minimum budget
                const roundedBudget = Math.max(
                    MIN_BULK_CAMPAIGN_BUGET_LIMIT,
                    Math.round(budget)
                );
                updatedCampaigns[campaignIndex] = {
                    ...updatedCampaigns[campaignIndex],
                    budget: roundedBudget,
                };
            }
        });

        // Calculate collection budget
        const sumOfCampaignBudgets = updatedCampaigns
            .filter((c: any) => !c.isArchived)
            .reduce((sum: number, c: any) => {
                const budgetValue = Number(c.budget) || 0;
                return sum + budgetValue;
            }, 0);

        results.push({
            collectionId: collection.id,
            campaigns: updatedCampaigns,
            collectionBudget: sumOfCampaignBudgets,
        });
    });

    return results;
};

export const mergePercentAndNonPercentData = (
    data: any[],
    recordKey?: string
): any[] => {
    if (!Array.isArray(data) || !recordKey) return [];

    const metricGroups: any[][] = [];

    data.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
            const lower = key.toLowerCase();
            if (lower.includes("percent")) {
                metricGroups.push(obj[key] || []);
            }
        });
    });

    if (metricGroups.length === 0) return [];

    const mergedMap = new Map<string, any>();

    metricGroups.forEach((group) => {
        group.forEach((item) => {
            const identifier = item[recordKey];
            if (!identifier) return;

            const key = String(identifier);
            if (!mergedMap.has(key)) mergedMap.set(key, {});
            Object.assign(mergedMap.get(key), item);
        });
    });

    return Array.from(mergedMap.values());
};

export async function generateSHA1Hash(data: string): Promise<string> {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await crypto.subtle.digest('SHA-1', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export const toSafeKey = (tag_type: string) =>
    tag_type
        .toString()
        .trim()
        .toLowerCase()                    // <-- lower case everything
        .replace(/[^a-z0-9_]/g, '_')      // <-- replace non-valid chars
        .replace(/^_+/, '')               // <-- remove leading underscores
        .replace(/_+/g, '_');

// Sorter function for priority-based sorting (custom keywords always first, then rest sorted)
export const productDataSorter = <T,>(
    data: T[],
    originalData: T[],
    sortConfig: { sorter?: (a: T, b: T) => number; order?: 'ascend' | 'descend' },
    selectedKeywords: IBCCKeyword[],
    moduleType: BCC_MODULE_TYPES
): T[] => {
    if (!data || !Array.isArray(data)) return data;

    type ItemWithIndex = T & { _originalIndex: number };

    // Create original index map for maintaining order
    const originalIndexMap = new Map<string, number>();
    originalData.forEach((originalItem: any, index) => {
        const itemId = originalItem.id || originalItem.sku;
        const clusterId = originalItem.clusterId;
        const key = clusterId ? `${clusterId}_${itemId}` : String(itemId);
        if (!originalIndexMap.has(key)) {
            originalIndexMap.set(key, index);
        }
    });

    // Add original index to each item
    const dataWithIndex: ItemWithIndex[] = data.map((item: any) => {
        const itemId = item.id || item.sku;
        const clusterId = item.clusterId;
        const key = clusterId ? `${clusterId}_${itemId}` : String(itemId);
        const originalIndex = originalIndexMap.get(key) ?? Infinity;
        return { ...item, _originalIndex: originalIndex };
    });

    // Create a set of selected keyword keys for quick lookup (for keywords sorting)
    const selectedKeywordKeys = new Set(
        selectedKeywords
            .filter((kw: IBCCKeyword) => kw?.keyword_type !== BCC_KEYWORD_TYPES.NEGATIVE)
            .map((kw: IBCCKeyword) => kw.key)
    );

    // Check if sorting is applied
    const isSortingApplied = sortConfig.sorter && sortConfig.order;

    // Separate keywords into categories based on selection and custom status
    const selectedCustomKeywords: ItemWithIndex[] = [];    // 1. Selected custom keywords (top)
    const unselectedCustomKeywords: ItemWithIndex[] = [];  // 2. Unselected custom keywords
    const selectedItems: ItemWithIndex[] = [];             // 3. Other selected keywords
    const nonPriorityProducts: ItemWithIndex[] = [];       // 4. Other unselected keywords
    const priorityProducts: ItemWithIndex[] = [];          // Priority products (for cluster module)

    dataWithIndex.forEach((item: any) => {
        // For keywords module
        if (moduleType === BCC_MODULE_TYPES.KEYWORDS) {
            const isSelected = item.key && selectedKeywordKeys.has(item.key);

            if (item.isCustom) {
                // Custom keywords: selected first, then unselected
                if (isSelected) {
                    selectedCustomKeywords.push(item);
                } else {
                    unselectedCustomKeywords.push(item);
                }
                return;
            }

            // Regular keywords: selected ones go after custom keywords
            if (isSelected) {
                selectedItems.push(item);
            } else {
                nonPriorityProducts.push(item);
            }
            return;
        }

        // For cluster module: check priority
        const productId = String(item.id || item.sku || 'default');
        const clusterId = String(item.clusterId || 'default');
        const priority = getProductPriorityFromState(clusterId, productId);

        if (priority > 0) {
            priorityProducts.push(item);
        } else {
            nonPriorityProducts.push(item);
        }
    });

    // Sort selected custom keywords by original index
    selectedCustomKeywords.sort((a: any, b: any) => {
        return a._originalIndex - b._originalIndex;
    });

    // Sort unselected custom keywords by original index
    unselectedCustomKeywords.sort((a: any, b: any) => {
        return a._originalIndex - b._originalIndex;
    });

    // Sort selected items by original index
    selectedItems.sort((a: any, b: any) => {
        return a._originalIndex - b._originalIndex;
    });

    // Sort priority products by priority (ascending), then by column sorter if available
    priorityProducts.sort((a: any, b: any) => {
        const productIdA = String(a.id || a.sku || 'default');
        const productIdB = String(b.id || b.sku || 'default');
        const clusterIdA = String(a.clusterId || 'default');
        const clusterIdB = String(b.clusterId || 'default');

        const priorityA = getProductPriorityFromState(clusterIdA, productIdA);
        const priorityB = getProductPriorityFromState(clusterIdB, productIdB);

        if (priorityA !== priorityB) {
            return priorityA - priorityB;
        }

        if (isSortingApplied && sortConfig.sorter) {
            const sortResult = sortConfig.sorter(a, b);
            return sortConfig.order === 'ascend' ? sortResult : -sortResult;
        }

        return a._originalIndex - b._originalIndex;
    });

    // Sort non-priority products by column sorter if available
    nonPriorityProducts.sort((a: any, b: any) => {
        if (isSortingApplied && sortConfig.sorter) {
            const sortResult = sortConfig.sorter(a, b);
            return sortConfig.order === 'ascend' ? sortResult : -sortResult;
        }
        return a._originalIndex - b._originalIndex;
    });

    // Combine and remove _originalIndex
    // Order: selected custom → unselected custom → other selected → other unselected (+ priority products for cluster module)
    const sortedData = [...selectedCustomKeywords, ...unselectedCustomKeywords, ...selectedItems, ...priorityProducts, ...nonPriorityProducts];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return sortedData.map(({ _originalIndex, ...item }) => item) as T[];
};

export const arraysEqual = (arr1: (string | number)[], arr2: (string | number)[]) => {
    if (arr1.length !== arr2.length) return false;
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    return sorted1.every((val, idx) => val === sorted2[idx]);
};

export const mapStatusToSyncStatus = (statusText: string): MappingSyncStatus => {
    const normalizedStatus = statusText.toLowerCase().trim();

    if (normalizedStatus === "success") {
        return MappingSyncStatus.Success;
    }

    if (
        normalizedStatus === "started" ||
        normalizedStatus === "starting" ||
        normalizedStatus === "queued" ||
        normalizedStatus === "not started" ||
        normalizedStatus === "managed" ||
        normalizedStatus === "canceling"
    ) {
        return MappingSyncStatus.Syncing;
    }

    if (
        normalizedStatus === "failure" ||
        normalizedStatus === "canceled"
    ) {
        return MappingSyncStatus.Error;
    }

    return MappingSyncStatus.Error;
};